export default {
    // แถบแท็บหน้าจอบน navbar (spec 2026-10-03 §7) — คู่กับ taskbar ใน en.js
    taskbar: {
        pin: "ปักหมุดแท็บ",
        unpin: "เลิกปักหมุด",
        close: "ปิดแท็บ",
        close_others: "ปิดแท็บอื่น",
        close_all: "ปิดทั้งหมด",
        scroll_left: "เลื่อนซ้าย",
        scroll_right: "เลื่อนขวา"
    },
    // ปุ่ม ☰ ย่อ/ขยาย sidebar (spec 2026-10-07 T3) — คู่กับ sidebar ใน en.js
    sidebar: {
        expand: "ขยายเมนู",
        collapse: "ย่อเมนู"
    },
    errors: {
        // account categories tree (bo-api 2026-10-26; Msg = errors.account.*)
        account: {
            bad_body: "ข้อมูลที่ส่งไม่ถูกต้อง",
            parent_not_found: "ไม่พบหมวดหมู่แม่ (อาจถูกลบไปแล้ว)",
            parent_cycle: "ไม่สามารถย้ายหมวดหมู่ไปอยู่ใต้ตัวเองหรือหมวดหมู่ย่อยของตัวเองได้",
            parent_type_mismatch: "หมวดหมู่แม่ต้องเป็นประเภทเดียวกัน (รายรับ/รายจ่าย)",
            type_change_has_children: "เปลี่ยนประเภทไม่ได้ เพราะยังมีหมวดหมู่ย่อยอยู่",
            delete_has_children: "ลบไม่ได้ เพราะยังมีหมวดหมู่ย่อยอยู่ — ย้ายหรือลบหมวดหมู่ย่อยก่อน",
            platform_on_income: "หมวดหมู่รายรับผูกแพลตฟอร์มไม่ได้",
            platform_invalid: "แพลตฟอร์มไม่ถูกต้อง",
            duplicate_name: "มีหมวดหมู่ชื่อนี้อยู่แล้วในระดับเดียวกัน",
        },
        // spec 2026-10-14 — recipient edit / tracking retry
        tracking_number_invalid: "กรุณากรอกเลขพัสดุ (ไม่เกิน 45 ตัวอักษร)",
        bad_request: "ข้อมูลที่ส่งไม่ถูกต้อง",
        order_not_found: "ไม่พบออเดอร์",
        packing_not_found: "ไม่พบรอบแพ็ค",
        order_has_tracking: "ออเดอร์นี้มีเลขพัสดุแล้ว แก้ไขที่อยู่ไม่ได้",
        order_status_not_editable: "แก้ไขได้เฉพาะออเดอร์ที่รอตัดรอบหรือรอขนส่งเข้ารับ",
        recipient_phone_invalid: "เบอร์โทรผู้รับไม่ถูกต้อง",
        recipient_postcode_invalid: "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
        too_many_orders: "เลือกได้ไม่เกิน 100 ออเดอร์ต่อครั้ง",
        recipient_required: "กรุณากรอกข้อมูลให้ครบ",
        order_already_returned: "รายการสั่งซื้อถูกตีกลับไปแล้ว",
		no_orders : "ไม่พบสินค้า",
        db_connection_failed: "เชื่อมต่อฐานข้อมูลไม่ได้ กรุณาลองใหม่อีกครั้ง",
        db_query_failed: "เชื่อมต่อฐานข้อมูลผิดพลาด",
        db_fetch_failed: "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
        permission_denied: "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
        invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
        invalid_parameters: "ข้อมูลที่ระบุไม่ถูกต้อง",
		internal: "เกิดข้อผิดพลาดภายในระบบ",
		payment_method_not_found:"ไม่พบช่องทางการซื้อ",
		// BO-Packing.go:269 ส่ง key นี้มาตั้งแต่แรกแต่ยังไม่เคยมีคำแปล ⇒ user เห็น key ดิบ
		payment_method_type_not_found: "ไม่พบประเภทการชำระเงินที่เลือก",
		// ตัดรอบแพ็คร้านค้าซ้อนกัน (design 2026-10-04 §4.2, Redis idempotency 120s)
		cutoff_in_progress: "กำลังตัดรอบอยู่ กรุณารอสักครู่",
		tracking_in_progress: "กำลังสร้างเลข Tracking ของรอบนี้อยู่ กรุณารอสักครู่แล้วรีเฟรช",
		// bo-api #931: round lock held by a booking pass or another change
		tracking_busy: "กำลังสร้างหรือแก้ไขเลขพัสดุของรอบนี้อยู่ กรุณาลองใหม่อีกครั้งในสักครู่",
		inventory_not_found :"ไม่พบสินค้าในคลังสินค้า",
		invalid_tracking_number:"หมายเลขพัสดุไม่ถูกต้อง",
		orders:{
			not_found:"ไม่พบรายการสั่งซื้อ",
			map_product:"สินค้ายังไม่เชื่อมต่อกับคลังสินค้า",
			invalid_date_range: "กรุณาระบุช่วงวันที่ไม่เกิน 31 วัน",
		},
        fix_status: {
            disallowed_source_status: "สถานะต้นทางไม่ได้รับอนุญาต — ตรวจสอบค่าที่ส่ง",
            // ข้ามแถว ไม่ใช่ error — งานยังสำเร็จ ดูหมายเหตุใน OrderReprocess.vue
            skipped_return_in_transit: "ข้าม {count} รายการที่กำลังตีกลับ (ล่าสุด #{order}) — พัสดุกำลังเดินทางกลับ การบังคับเป็น 'สำเร็จ' จะประทับวันที่ปิดการขายและเข้าไปคิดค่าคอมมิชชั่น",
            // ห้ามใช้ {count} ที่นี่ — count ผูกกับ skipped_returning ซึ่ง BE
            // จงใจไม่นับเคสนี้ ใส่ไปจะโชว์เลขของอีกเรื่องหนึ่ง
            skipped_changed_underneath: "ข้ามรายการที่สถานะเปลี่ยนระหว่างทำงาน (ล่าสุด #{order}) — อ่านค่ามาแล้วแต่มีคนหรือระบบอื่นแก้ก่อนจะเขียน จึงไม่เขียนทับ",
        },
        user: {
            duplicate: "ข้อมูลผู้ใช้งานซ้ำ",
            duplicate_username: "ข้อมูลผู้ใช้งานซ้ำ",
            duplicate_email: "ข้อมูลอีเมล์ซ้ำ",
            blcok_delete_by_self: "ไม่สามารถลบข้อมูลตนเองได้",
            fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
            email_wrong_format: "รูปแบบอีเมล์ไม่ถูกต้อง",
            enterprise_empty: "กรุณาระบุองค์กร"
        },
        auth: {
            login_fail: "เข้าสู่ระบบผิดพลาด",
            block: "ผู้ใช้งานถูกระงับ",
            login_success: "เข้าสู่ระบบสำเร็จ",
            logout_success: "ออกจากระบบสำเร็จ",
            unauthoriezed: "เข้าสู่ระบบผิดพลาด",
            reset_invalid_token: "token ไม่ถูกต้อง",
            reset_token_expired: "token หมดอายุ",
            forgot_password_fail: "ลืมรหัสผ่านไม่สำเร็จ",
            reset_password_fail: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
            username_wrong_format: "รูปแบบของชื่อผู้ใช้งานไม่ถูกต้อง",
            password_wrong_format: "รูปแบบของรหัสผ่านไม่ถูกต้อง",
            token: "Toekn ไม่ถูกต้อง",
            password: "รหัสผ่านไม่ถูกต้อง",
            password_confirm: "การยืนยันรหัสผ่านไม่ถูกต้อง",
            // LINE login / LINE link — คีย์ตรงกับ `msg` ที่ API ส่งมา
            // (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §2)
            line_disabled:
                "ระบบเข้าสู่ระบบด้วย LINE ยังไม่เปิดใช้งาน กรุณาติดต่อฝ่าย IT",
            line_state_invalid:
                "การเชื่อมต่อหมดอายุหรือถูกใช้ไปแล้ว กรุณาลองอีกครั้ง",
            line_code_invalid:
                "ข้อมูลยืนยันจาก LINE ไม่ถูกต้อง กรุณาลองอีกครั้ง",
            line_verify_failed:
                "ยืนยันกับ LINE ไม่สำเร็จ กรุณาลองอีกครั้งในอีกสักครู่",
            // 403 — ประโยคเต็มเพราะนี่คือข้อความเดียวที่บอกทางออกให้ผู้ใช้
            line_not_linked:
                "บัญชี LINE นี้ยังไม่ได้เชื่อมกับผู้ใช้ Backoffice — เข้าสู่ระบบด้วยรหัสผ่านแล้วเชื่อมต่อที่หน้าโปรไฟล์ก่อน",
            line_already_linked:
                "บัญชี LINE นี้ถูกใช้เชื่อมต่อกับผู้ใช้งานอื่นแล้ว",
            line_already_linked_self:
                "บัญชีของคุณเชื่อมต่อกับ LINE อื่นอยู่แล้ว กรุณายกเลิกการเชื่อมต่อเดิมก่อน",
            // 429 — IP cap บน authorize-url/callback (bo-api #785)
            line_too_many: "ลองเชื่อมต่อ LINE บ่อยเกินไป กรุณารอสักครู่",
            // ผู้ใช้กดยกเลิกที่หน้าขออนุญาตของ LINE (spec §6 ข้อ 7) — ไม่ใช่
            // ความผิดพลาด และไม่มีการเรียก API
            line_cancelled: "ยกเลิกการเชื่อมต่อกับ LINE แล้ว"
        },
        profile: {
            change_profile_failed: "แก้ไขข้อมูลผิดพลาด",
            change_password_failed: "แก้ไขรหัสผ่านผิดพลาด",
            password_confirm_not_match: "การยืนยันรหัสผ่านไม่ถูกต้อง",
            password_confirm_wrong_format: "รูปแบบรหัสผ่านไม่ฟถูกต้อง",
            password_old_wrong: "รหัสผ่านเดิมไม่ถูกต้อง"
        },
        wms: {
            inventory_create_fails: "สร้างคลังสินค้าผิดพลาด",
            inventory: {
                balance_not_enough: "สินค้าคงเหลือไม่เพียงพอ"
            },
            return_main: {
                return_not_configured:
                    "ยังไม่ได้ตั้งค่าคลังต้นทาง กรุณาติดต่อฝ่าย IT",
                return_not_configured_detail:
                    "ผู้ดูแลระบบ: ยังไม่ได้ตั้งค่าคลังสินค้าตีกลับ ตั้งค่า app.storage_for_order_return_good ในไฟล์ config.yml ของ API แล้วรีสตาร์ทระบบ",
                dest_not_configured:
                    "ยังไม่ได้ตั้งค่าคลังปลายทาง กรุณาติดต่อฝ่าย IT",
                dest_not_configured_detail:
                    "ผู้ดูแลระบบ: ยังไม่ได้ตั้งค่าคลังปลายทางสำหรับนำสินค้าดีเข้าคลัง ตั้งค่า app.storage_for_return_good_destination ในไฟล์ config.yml ของ API แล้วรีสตาร์ทระบบ",
                same_storage: "คลังต้นทางและคลังปลายทางเป็นคลังเดียวกัน",
                empty_list: "ไม่ได้เลือกรายการสินค้า",
                duplicate_product: "มีรายการสินค้าซ้ำในคำขอ"
            }
        },
		wh:{
			inventory: { not_found: "ไม่พบแถวสินค้าในคลัง หรือถูกลบไปแล้ว" }, // delete guard 404 (bo-api #842)

		},
		packing:{
			invalid_order_status : "สถานะออเดอร์ไม่ถูกต้อง",
			goods_is_added: "สินค้าถูกเพิ่มเข้าระบบครบแล้ว",
			goods_not_enough: "สินค้าไม่เพียงพอ",
		},
		upload: {
			presign_failed: "ไม่สามารถเตรียมอัปโหลดได้",
			file_too_large: "ไฟล์มีขนาดใหญ่เกินไป (สูงสุด 5MB)"
		},
		catalog: {
			product_code_taken: "รหัสสินค้าซ้ำ",
			coupon_code_taken: "รหัสคูปองซ้ำ",
			manual_sku_needs_code: "SKU แบบกำหนดสต็อกเองต้องมีรหัส SKU",
			manual_sku_quantity_negative: "จำนวนสต็อกที่กำหนดเองต้องไม่ติดลบ"
		},
		sku: {
			duplicate_code: "พบ SKU Code ซ้ำกัน",
			code_required: "กรุณากรอก SKU Code",
			invalid_quantity: "จำนวนสต็อกต้องไม่ติดลบ"
		},
		product: {
			fixed_price_required: "ราคาตายตัวต้องมากกว่า 0",
			option_group_empty: "กลุ่มตัวเลือกต้องมีค่าอย่างน้อย 1 ค่า",
			no_skus: "ต้องมีอย่างน้อย 1 SKU"
		},
		api: {
			network: "ไม่สามารถเชื่อมต่อระบบได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่",
			server: "ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง หรือแจ้งผู้ดูแลระบบ",
			unknown: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
			invalid_id: "ไม่พบรายการที่เลือก",
			invalid_body: "ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแล้วลองใหม่",
			name_th_required: "กรุณากรอกชื่อ (ไทย)",
			code_required: "กรุณากรอกรหัสสินค้า",
			price_gt0: "กรุณากรอกราคาให้มากกว่า 0",
			sku_price_gt0: "ราคา SKU ต้องมากกว่า 0",
			discount_value_gt0: "ส่วนลดแบบเปอร์เซ็นต์ต้องมากกว่า 0",
			category_has_products: "หมวดหมู่นี้ยังมีสินค้าอยู่ กรุณาย้ายสินค้าออกก่อนลบ",
			category_name_dup: "มีหมวดหมู่ชื่อนี้อยู่แล้วในหมวดหมู่หลักเดียวกัน",
			coupon_template_in_use: "Template นี้มีคูปองที่ใช้งานอยู่ จึงปิดใช้งานไม่ได้",
			not_found: "ไม่พบรายการที่เลือก (อาจถูกลบไปแล้ว)"
		},
		campaign: {
			invalid_date_range: "วันที่ไม่ถูกต้อง",
			no_targets: "กรุณาเลือกสินค้าอย่างน้อย 1 รายการ",
			invalid_value: "มูลค่าส่วนลดไม่ถูกต้อง",
			not_found: "ไม่พบแฟลชเซล",
			product_ids_invalid: "เลือกสินค้า 1–200 รายการ",
			product_not_in_campaign: "สินค้านี้ไม่ได้อยู่ในแฟลชเซล",
			name_required: "กรุณาระบุชื่อแคมเปญ"
		},
		promotion: {
			no_slots: "กรุณาเพิ่มช่องเลือกอย่างน้อย 1 ช่อง",
			no_options: "แต่ละช่องต้องมีตัวเลือกอย่างน้อย 1 รายการ",
			invalid_ref: "ตัวเลือกไม่ถูกต้อง",
			invalid_date_range: "วันที่ไม่ถูกต้อง"
		},
		cart: {
			promotion_ended: "โปรโมชันสิ้นสุดแล้ว",
			option_out_of_stock: "ตัวเลือกนี้สินค้าหมด",
			incomplete_selection: "กรุณาเลือกให้ครบทุกช่อง"
		}
    },

    bc_portal: "Web Portal",
    bc_package: "แพ็คเกจ",
    bc_voicemail: "ข้อความเสียง",
    bc_report: "ข้อมูลการโทร",
    bc_user: "ผู้ใช้งาน",
    bc_corporate: "องค์กร",
    bc_mlhg: "กลุ่ม Hunt",
    bc_pilot_number: "หมายเลของค์กร",
    bc_agent_number: "หมายเลขผู้ใช้งาน",
    bc_change_profile: "ข้อมูลส่วนตัว",
    bc_change_password: "เปลี่ยนรหัสผ่าน",
    bc_admin: "ผู้ดูแลระบบ",
    bc_platform_connect: "เชื่อมต่อกับแพลตฟอร์ม",
    bc_coupon: "คูปองส่วนลด",
    bc_coupon_detail: "รายการคูปองส่วนลด",

    profile: {
        forgot_password_success: "ส่งลิงก์ตั้งรหัสผ่านใหม่ไปที่อีเมลแล้ว",
        reset_password_success: "ตั้งรหัสผ่านใหม่เรียบร้อยแล้ว",
        profile: "ข้อมูลส่วนตัว",
        info: "ข้อมูลส่วนตัว",
        name: "ชื่อ",
        lname: "นามสกุล",
        phone: "เบอร์โทรศัพท์",
        email: "อีเมล์",
        change_password: "เปลี่ยนรหัสผ่าน",
        password_old: "รหัสผ่านเดิม",
        password_new: "รหัสผ่านใหม่",
        password_confirm: "ยืนยันรหัสผ่าน",
        change_profile_success: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
        change_password_success: "เปลี่ยนรหัสผ่านสำเร็จ",
        // การ์ดเชื่อมต่อ LINE บนหน้าข้อมูลส่วนตัว
        // (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §5)
        line_title: "การเชื่อมต่อ LINE",
        line_not_linked: "ยังไม่ได้เชื่อมต่อบัญชี LINE",
        line_linked: "เชื่อมต่อแล้ว",
        line_connect: "เชื่อมต่อ LINE",
        line_unlink: "ยกเลิกการเชื่อมต่อ",
        line_unlink_confirm:
            "ยกเลิกการเชื่อมต่อบัญชี LINE? คุณจะยังเข้าสู่ระบบด้วยรหัสผ่านได้",
        line_linked_at: "เชื่อมต่อเมื่อ",
        line_link_success: "เชื่อมต่อบัญชี LINE สำเร็จ",
        line_unlink_success: "ยกเลิกการเชื่อมต่อบัญชี LINE แล้ว",
        line_disabled: "ยังไม่เปิดใช้งาน"
    },
    menu: {
        user: "ผู้ใช้งาน",
        member: "สมาชิก",
		admin: "ผู้ดูแลระบบ",
		admin_product: "สินค้าและโปรโมชั่น",
		admin_product_v2: "สินค้า Platform",
		admin_platform_connect: "เชื่อมต่อระบบ",
		admin_skurandom: "สินค้าสุ่ม",
		sale_channel: "ช่องทางการขาย",
		product: "สินค้า",
		team: "ทีมขาย",
		order_status: "สถานะ",
		po: "ใบสั่งซื้อ",
		coupon: "คูปอง",
		coupon_log: "ประวัติคูปอง",
		app_catalog: "สินค้า",
		app_catalog_categories: "หมวดหมู่สินค้า",
		app_catalog_products: "จัดการสินค้า",
		app_catalog_promotions: "แฟลชเซล",
		app_catalog_bundles: "ชุดสินค้า",
		app_catalog_coupons: "คูปอง",
		app_catalog_platform_category_map: "จับคู่หมวด platform",
		app_catalog_storefront: "ตั้งค่าหน้าร้าน",
		app_catalog_storefront_home: "หน้าแรกเว็บ (Home)",
		app_catalog_storefront_collections: "คอลเลกชันหน้าเว็บ",
		app_catalog_shipping_tiers: "ค่าจัดส่ง",
		app_catalog_wms_products: "สินค้าคลัง (WMS)",
		// #301 shared stock — SKU ที่สต็อกไม่ตามคลัง เพราะแมป WMS ไม่ได้
		app_catalog_stock_unmatched: "SKU ที่ยังไม่ได้แมปคลัง",
		store_settings: "ตั้งค่าร้านค้า",
		seller: "ผู้ขาย",
		seller_orders: "คำสั่งซื้อร้านค้า",
		seller_payment_report: "รายงานการชำระเงิน",
		issue_report: "แจ้งปัญหา / Report Issue",
		releases: "เวอร์ชัน / Releases",
		member_coins_report: "รายงาน coin ค้าง",
		pinned_section: "เมนูปักหมุด",
    },
    payment_report: {
		col_provider: "ผู้ให้บริการ / ประเภท",
		col_refund: "การคืนเงิน",
		provider_2c2p: "2C2P",
		provider_123: "123 Service",
		group_card: "บัตรเครดิต/เดบิต",
		group_qr: "QR",
		group_wallet: "Wallet",
		group_banking: "Internet / Mobile Banking",
		group_counter: "ชำระที่เคาน์เตอร์",
		group_other: "อื่นๆ",
		refund_pending: "รอคืนเงิน",
		refund_refunded: "คืนเงินสำเร็จ",
		title: "รายงานการชำระเงิน 2C2P",
		filter_date_from: "ตั้งแต่วันที่",
		filter_date_to: "ถึงวันที่",
		filter_channel: "ช่องทาง",
		filter_status: "สถานะ",
		all: "ทั้งหมด",
		channel_shop: "หน้าร้าน (Storefront)",
		channel_member: "ระบบสมาชิก (LIFF)",
		channel_app: "แอปพลิเคชัน",
		status_success: "สำเร็จ",
		status_in_progress: "กำลังดำเนินการ",
		status_failed: "ล้มเหลว",
		btn_search: "ค้นหา",
		btn_export: "ส่งออก CSV",
		col_pay_channel: "ช่องทางชำระเงิน",
		col_tran_ref: "เลขอ้างอิง 2C2P",
		col_invoice: "เลขที่ใบแจ้งหนี้",
		col_channel: "ช่องทาง",
		col_member: "สมาชิก",
		col_recipient: "ผู้รับ",
		col_amount: "จำนวนเงิน",
		col_status: "สถานะ",
		col_resp_code: "Resp Code",
		col_resp_desc: "Resp Desc",
		col_backend_resp_code: "Backend Code",
		col_backend_resp_desc: "Backend Desc",
		col_attempt: "ครั้งที่",
		col_req_time: "เวลาทำรายการ",
		col_paid_time: "เวลาชำระเงิน",
		total_count: "จำนวนรายการ",
		total_amount: "ยอดรวม",
		no_data: "ไม่มีข้อมูล",
		page_range: "แสดง {from}–{to} จาก {total} รายการ",
		load_error: "โหลดข้อมูลไม่สำเร็จ"
    },
    seller_orders: {
		channel_shop: "เว็บร้านค้า",
		channel_member: "ระบบสมาชิก",
		channel_app: "แอปพลิเคชัน",
		all: "ทั้งหมด",
		filter_date_from: "ตั้งแต่วันที่",
		filter_date_to: "ถึงวันที่",
		filter_status: "สถานะ",
		filter_search: "ค้นหา",
		search_placeholder: "เลขที่ออเดอร์ / เบอร์โทร / ชื่อผู้รับ",
		btn_search: "ค้นหา",
		btn_view: "ดู",
		btn_cut_off: "ตัดรอบแพ็ค",
		col_order: "ออเดอร์",
		col_channel: "ช่องทาง",
		col_status: "สถานะ",
		col_payment_status: "สถานะชำระเงิน",
		col_amount: "ยอดชำระ",
		col_placed_at: "วันที่สั่งซื้อ",
		col_bo: "ออเดอร์ BO",
		col_actions: "จัดการ",
		col_image: "รูป",
		col_product: "สินค้า",
		col_qty: "จำนวน",
		col_unit_price: "ราคาต่อหน่วย",
		col_line_total: "รวม",
		col_invoice: "เลขที่ใบแจ้งหนี้",
		total_count: "จำนวนรายการ",
		no_data: "ไม่มีข้อมูล",
		load_error: "โหลดข้อมูลไม่สำเร็จ",
		detail_title: "รายละเอียดออเดอร์",
		detail_order: "ข้อมูลออเดอร์",
		detail_items: "รายการสินค้า",
		detail_address: "ที่อยู่จัดส่ง",
		detail_payment: "ข้อมูลการชำระเงิน",
		pay_success: "ชำระแล้ว",
		pay_in_progress: "กำลังดำเนินการ",
		pay_failed: "ล้มเหลว",
		pay_none: "ยังไม่ชำระ",
		status_100: "รอชำระเงิน",
		status_111: "รอตัดรอบส่งสินค้า",
		status_112: "รอแพ็คสินค้า",
		status_121: "กำลังขนส่ง",
		status_122: "จัดส่งสำเร็จ",
		status_130: "สำเร็จ",
		status_140: "ยกเลิก",
		cutoff_title: "ตัดรอบแพ็คตามช่องทาง",
		cutoff_channel: "ช่องทาง (จำนวนที่พร้อมตัดรอบ)",
		cutoff_payment_type: "ประเภทชำระเงิน",
		cutoff_shipping_provider: "ผู้ให้บริการขนส่ง (0 = ทั้งหมด)",
		cutoff_back_days: "ย้อนหลัง (วัน)",
		cutoff_zero_hint: "ใส่ 0 เพื่อเลือกทั้งหมด",
		btn_cancel: "ยกเลิก",
		btn_confirm_cut: "ยืนยันตัดรอบ",
		cutoff_success_title: "ตัดรอบสำเร็จ",
		cutoff_success_text: "สร้างรอบแพ็ค #{id} จำนวน {cnt} ออเดอร์ ({channel})",
		cutoff_error: "ตัดรอบไม่สำเร็จ",
		// ตัดรอบแพ็ครวมเว็บ/สมาชิก/แอป (design 2026-10-04 §6.6) — คู่กับ en.js
		filter_payment_type: "ประเภทชำระเงิน",
		col_payment_type: "ประเภทชำระเงิน",
		col_recipient: "ผู้รับ",
		col_packing_round: "รอบแพ็ค",
		chip_web: "เว็บ",
		chip_member: "สมาชิก",
		chip_app: "แอป",
		chip_total: "รวม",
		chip_unassigned: "ไม่ระบุช่องทาง",
		chip_unassigned_hint: "ออเดอร์ที่ยังไม่ได้ผูกช่องทางการขาย — จะถูกตัดรอบไปด้วย",
		chip_ambiguous: "ช่องทางถูกผูกซ้ำ แสดงได้เฉพาะยอดรวม",
		cutoff_title_all: "ตัดรอบแพ็ค เว็บ + สมาชิก + แอป",
		cutoff_scope_note: "ตัดรอบครั้งเดียวรวมทุกช่องทาง (เว็บ สมาชิก แอป) ไม่ต้องเลือกช่องทางหรือขนส่ง",
		cutoff_back_days_label: "ย้อนหลัง (วัน)",
		cutoff_table_channel: "ช่องทาง",
		cutoff_table_count: "จำนวนออเดอร์",
		cutoff_total: "รวมที่จะตัดรอบ",
		cutoff_none: "ไม่มีออเดอร์ที่พร้อมตัดรอบในช่วงที่เลือก",
		cutoff_confirm_text: "ยืนยันตัดรอบแพ็ค {cnt} ออเดอร์? ออเดอร์จะย้ายเข้าห้องแพ็คและย้อนกลับไม่ได้จากหน้านี้",
		cutoff_success_all: "สร้างรอบแพ็ค #{id} จำนวน {cnt} ออเดอร์ (เว็บ {web} / สมาชิก {member} / แอป {app}) · กำลังสร้างเลข Tracking ไปรษณีย์ไทย",
		cutoff_warn_no_wms: "มี {cnt} ออเดอร์ที่ยังไม่แมปคลังสินค้า — ตรวจที่เมนู SKU ที่ยังไม่ได้แมปคลัง",
		btn_go_packing: "ไปห้องแพ็ค",
		preview_error: "โหลดจำนวนออเดอร์ที่พร้อมตัดรอบไม่สำเร็จ",
		// แท็บสถานะ + แผงตัวกรอง (design 2026-10-05 §5.5) — คู่กับ en.js
		tab_all: "ทั้งหมด",
		tab_to_ship: "ที่ต้องจัดส่ง",
		tab_shipping: "กำลังจัดส่ง",
		tab_completed: "สำเร็จ",
		tab_cancelled: "ยกเลิก",
		tab_returns: "ตีกลับ",
		btn_filter: "ตัวกรอง",
		filter_title: "ตัวกรอง",
		filter_clear_all: "ล้างทั้งหมด",
		filter_apply: "นำไปใช้",
		filter_reset: "ล้างตัวกรอง",
		found_n: "พบคำสั่งซื้อ {n} รายการ",
		period_all: "ช่วงเวลา: ทั้งหมด",
		period_hint: "รายการและจำนวนรอตัดรอบนับตามช่วงเวลานี้",
		f_sub_status: "สถานะคำสั่งซื้อ",
		f_date_type: "ชนิดวันที่",
		date_created: "วันที่สั่งซื้อ",
		date_paid: "วันที่ชำระเงิน",
		date_shipping: "อัปเดตขนส่งล่าสุด",
		f_order_q: "เลขออเดอร์ / เลขพัสดุ",
		f_customer_q: "ชื่อ / เบอร์ลูกค้า",
		f_product_q: "ชื่อสินค้า / รหัส / SKU",
		f_channels: "ช่องทาง",
		f_pay_state: "สถานะชำระเงิน",
		f_shipping: "ขนส่ง",
		f_packing: "รอบแพ็ค",
		pay_state_paid: "ชำระแล้ว",
		pay_state_unpaid: "ยังไม่ชำระ",
		pay_state_cod: "เก็บเงินปลายทาง",
		packing_none: "ยังไม่เข้ารอบ",
		packing_in: "เข้ารอบแล้ว",
		f_wms_unmapped: "เฉพาะที่ยังไม่แมปคลังสินค้า",
		chip_chat: "แชท",
		status_114: "จัดส่งบางส่วน",
		status_115: "รอขนส่งรับพัสดุ",
		status_141: "ตีกลับ",
		status_142: "เคลมสินค้า",
		status_143: "กำลังตีกลับ",
		chip_scope_hint: "นับเฉพาะออเดอร์ที่เข้าระบบหลังบ้านแล้ว ภายในช่วงย้อนหลังที่เลือก — อาจน้อยกว่าตัวเลขแท็บ",
		empty_tab: "ไม่มีคำสั่งซื้อในแท็บนี้",
		empty_filtered: "ไม่พบคำสั่งซื้อที่ตรงกับตัวกรอง",
		wms_truncated: "แสดงเฉพาะ 2,000 ออเดอร์แรกที่ยังไม่แมปคลัง",
		// Owner 2026-10-15: tracking column, 2C2P card label, inline order detail.
		col_tracking: "เลข Tracking",
		copy: "คัดลอก",
		copied: "คัดลอก {value} แล้ว",
		copy_failed: "คัดลอกไม่สำเร็จ",
		pay_type_card_2c2p: "บัตรเครดิต/เดบิต (2C2P)",
		// Owner 2026-10-26: the real 2C2P channel details (payment.channel).
		pay_ch_card: "บัตร",
		pay_ch_issuer: "ธนาคารผู้ออกบัตร",
		pay_ch_approval: "รหัสอนุมัติ",
		pay_ch_tran_ref: "เลขอ้างอิง 2C2P",
		pay_ch_reference: "Reference No.",
		pay_ch_time: "เวลาทำรายการ (2C2P)",
		pay_ch_result: "ผลจาก 2C2P",
		pay_ch_codes: "รหัสช่องทาง",
		detail_retry: "ลองใหม่",
		detail_customer_note: "หมายเหตุจากลูกค้า",
		detail_shipping: "การจัดส่ง",
		detail_carrier_status: "สถานะขนส่ง",
		detail_paid_at: "ชำระเมื่อ",
		detail_amount_items: "ค่าสินค้า",
		detail_discount: "ส่วนลด",
		detail_shipping_cost: "ค่าส่ง",
		detail_no_items: "ไม่มีรายการสินค้า",
		detail_wms_items: "รายการแพ็ค (คลัง)",
		detail_no_wms_items: "ยังไม่มีรายการแพ็ค (ออเดอร์ยังไม่เข้าระบบหลังบ้าน หรือยังไม่แมปคลัง)",
		detail_timeline: "ไทม์ไลน์",
		detail_hide: "ซ่อนรายละเอียด",
		tl_created: "สั่งซื้อ",
		tl_paid: "ชำระเงินแล้ว",
		tl_cancelled: "ยกเลิก",
		// spec 2026-10-16 seller-order-cancel-actor-reason §5: who cancelled + why, seller cancel
		cancel_by_customer: "ยกเลิกโดยลูกค้า",
		cancel_by_staff: "ยกเลิกโดยพนักงาน",
		cancel_by_staff_named: "ยกเลิกโดยพนักงาน ({name})",
		cancel_by_system: "ยกเลิกอัตโนมัติ",
		cancel_block_title: "การยกเลิก",
		cancel_actor: "ผู้ยกเลิก",
		cancel_type: "ประเภท",
		cancel_reason: "เหตุผล",
		cancel_time: "เวลา",
		cancel_btn: "ยกเลิกคำสั่งซื้อ",
		cancel_dialog_title: "ยกเลิกคำสั่งซื้อ {order}",
		cancel_type_label: "ประเภทการยกเลิก",
		cancel_reason_placeholder: "-- เหตุผลการยกเลิก --",
		cancel_note_label: "เหตุผลการยกเลิก",
		cancel_note_placeholder: "ระบุเหตุผล (เห็นเฉพาะพนักงาน ไม่แสดงให้ลูกค้า)",
		cancel_note_too_long: "เหตุผลยาวเกิน 255 ตัวอักษร",
		cancel_confirm_title: "ยืนยันการยกเลิกคำสั่งซื้อ?",
		cancel_confirm_text: "คำสั่งซื้อ {order} จะถูกยกเลิก (รวมออเดอร์ใน Backoffice ที่ผูกอยู่ ถ้ามี) ย้อนกลับไม่ได้",
		cancel_confirm_btn: "ยืนยันการยกเลิก",
		cancel_close: "ปิด",
		cancel_success: "ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว",
		cancel_error: "ยกเลิกคำสั่งซื้อไม่สำเร็จ",
		cancel_text_auto_expired_24h: "ไม่ชำระเงินภายใน 24 ชั่วโมง",
		cancel_text_auto_max_attempts: "ชำระเงินไม่สำเร็จเกินจำนวนครั้งที่กำหนด",
		cancel_text_payment_timeout: "หมดเวลาชำระเงิน",
		cancel_text_payment_failed: "ชำระเงินไม่สำเร็จ",
		cancel_text_staff_cancel_customer_request: "ลูกค้าแจ้งยกเลิก",
		cancel_text_staff_cancel_store: "ร้านค้ายกเลิก",
		cancel_text_staff_cancel_shipping: "ปัญหาการขนส่ง",
		cancel_text_staff_cancel_payment: "ปัญหาการชำระเงิน",
		cancel_text_staff_cancel_other: "ยกเลิกโดยพนักงาน"
    },
    // BO order overview (route BOOrdersOverview, staff only #441) — spec 2026-10-07 §6.7
    orders_new: {
		title: "ภาพรวมรายการสั่งซื้อ",
		tab_all: "ทั้งหมด",
		tab_unpaid: "รอชำระเงิน",
		tab_to_ship: "ที่ต้องจัดส่ง",
		tab_shipping: "กำลังจัดส่ง",
		tab_completed: "สำเร็จ",
		tab_cancelled: "ยกเลิก",
		tab_returns: "ตีกลับ",
		btn_filter: "ตัวกรอง",
		filter_title: "ตัวกรอง",
		filter_clear_all: "ล้างทั้งหมด",
		filter_apply: "นำไปใช้",
		filter_cancel: "ยกเลิก",
		filter_reset: "ล้างตัวกรอง",
		found_n: "พบคำสั่งซื้อ {n} รายการ",
		period: "ช่วงเวลา: {from} – {to}",
		f_sub_status: "สถานะคำสั่งซื้อ",
		f_date: "ช่วงวันที่",
		date_created: "วันที่สร้าง",
		date_payment: "วันที่ชำระเงิน",
		f_keyword: "เลขออเดอร์ / เบอร์โทร / ชื่อ / เลขพัสดุ",
		kw_order: "หมายเลขสั่งซื้อ",
		kw_phone: "เบอร์โทรศัพท์",
		kw_tracking: "เลขพัสดุ",
		kw_name: "ชื่อผู้รับ",
		f_user: "พนักงาน",
		f_platform: "แพลตฟอร์ม",
		f_sale_channel: "ช่องทางการขาย",
		f_sale_channel_type: "ประเภทช่องทาง",
		f_payment_type: "ประเภทชำระเงิน",
		f_packing: "สถานะแพ็ค",
		platform_default: "มาดามฟิน + MDFStore (ค่าเริ่มต้น)",
		packing_all: "ทั้งหมด",
		packing_closed: "ปิดรายการแล้ว",
		packing_open: "ยังไม่ปิดรายการ",
		packing_not_opened: "รอแพ็ค",
		all: "ทั้งหมด",
		view: "ดูรายละเอียด",
		col_platform: "แพลตฟอร์ม",
		range_too_long: "ช่วงวันที่ต้องไม่เกิน 35 วัน และวันเริ่มต้องไม่หลังวันสิ้นสุด",
		date_ignored_hint: "ค้นด้วยคำค้นจะไม่กรองตามช่วงวันที่",
		truncated: "แสดงได้สูงสุด {n} รายการ — ตัวเลขบนแท็บอาจไม่ครบ ให้แคบช่วงวันที่ลง",
		empty_tab: "ไม่มีคำสั่งซื้อในแท็บนี้",
		empty_filtered: "ไม่พบคำสั่งซื้อที่ตรงกับตัวกรอง",
		load_error: "โหลดรายการสั่งซื้อไม่สำเร็จ",
		platform_all: "ทั้งหมด",
		selection: "แสดง: {platform} · {tab}",
		platform_load_error: "โหลดข้อมูลแพลตฟอร์มนี้ไม่สำเร็จ",
		partial_load: "โหลดไม่สำเร็จบางแพลตฟอร์ม: {names} — ตัวเลขแถวทั้งหมดไม่รวมแพลตฟอร์มเหล่านี้",
		truncated_platforms: "แสดงได้สูงสุดต่อแพลตฟอร์ม — {names} อาจไม่ครบ ให้แคบช่วงวันที่ลง",
		page_size: "แสดงต่อหน้า",
		page_size_option: "{n} รายการ",
		menu: "เมนู",
		act_change_shipping: "เปลี่ยนช่องทางการจัดส่ง",
		act_change_tracking: "แก้ไขหมายเลขพัสดุ",
		act_cancel: "ยกเลิกคำสั่งซื้อ",
		copy: "คัดลอก",
		copied: "คัดลอกแล้ว: {value}",
		copy_failed: "คัดลอกไม่สำเร็จ",
		// §14.4 R31 round 6: inline order detail
		detail_hide: "ซ่อนรายละเอียด",
		items: "รายการสินค้า",
		wms_items: "สินค้าที่ต้องแพ็ค (WMS)",
		payment_proof: "หลักฐานการชำระเงิน",
		no_items: "ไม่มีรายการสินค้า",
		no_wms_items: "ไม่มีรายการแพ็ค",
		detail_retry: "ลองใหม่",
		recipient: "ผู้รับ",
		shipping: "จัดส่ง",
		payment: "ชำระเงิน",
		amount_items: "ยอดสินค้า",
		amount_pay: "ยอดชำระ",
		created_by: "โดย",
		shipping_cost: "ค่าส่ง",
		cancel_reason: "เหตุผลการยกเลิก",
		// §15.3 R36 round 7: slip preview + in-place payment check
		payment_check: "ตรวจสอบการชำระเงิน",
		no_slip: "ไม่มีหลักฐานการชำระเงิน",
		confirm_payment_ok: "ยืนยันว่าชำระเงินถูกต้อง?",
		confirm_payment_fail: "ยืนยันว่าชำระเงินไม่ถูกต้อง? (ออเดอร์จะถูกยกเลิก)",
		preview_slip: "ดูรูปใหญ่",
		// Shopee cancel reconcile §11 F1
		cancel_requested: "ขอยกเลิก (รอตอบ)",
		platform_status_stale: "สถานะจากแพลตฟอร์มครั้งล่าสุด อาจเก่ากว่าของจริง",
		// §19 R44/R45 round 11: packing info in the detail + fulfilment stage columns
		pk_opened_by: "ผู้เปิด Order แพ็ค",
		pk_opened_at: "เวลาเปิด",
		pk_closed_at: "เวลาปิด",
		pk_line: "สายที่แพ็ค",
		stage_wait_cutoff: "รอตัดรอบ\nส่งสินค้า",
		stage_wait_open: "รอส่งสินค้า",
		stage_packing: "กำลังแพ็ค",
		stage_wait_pickup: "รอขนส่ง\nเข้ารับ",
		stage_in_transit: "กำลังขนส่ง",
		f_stage: "ขั้นตอน",
		// §20 R47–R49: tracking timeline button + modal in the detail
		tracking_view: "ดู Tracking",
		tracking_title: "ไทม์ไลน์การขนส่ง",
		tracking_updated: "อัปเดตล่าสุด {at}",
		tracking_loading: "กำลังโหลดข้อมูลการขนส่ง…",
		tracking_empty: "ยังไม่มีข้อมูลการขนส่ง",
		tracking_error: "โหลดข้อมูลการขนส่งไม่สำเร็จ",
		tracking_latest: "ล่าสุด"
    },
    checkout_settings: {
		title: "นโยบายการสั่งซื้อ",
		subtitle: "ตั้งค่ากติกาการสั่งซื้อสำหรับลูกค้าหน้าร้าน (www + member + แอป)",
		cod_max_pending_label: "จำนวนออเดอร์เก็บเงินปลายทางที่ค้างได้สูงสุดต่อสมาชิก",
		cod_max_pending_help: "จำนวนคำสั่งซื้อเก็บเงินปลายทางที่ลูกค้ายังไม่ได้รับสินค้า ที่สมาชิก 1 คนมีค้างได้พร้อมกัน (นับรวมออเดอร์ที่ส่งไปเบอร์เดียวกัน). นับสถานะ รอชำระเงิน/รอตัดรอบส่งสินค้า/รอแพ็คสินค้า/จัดส่งบางส่วน/รอขนส่งรับพัสดุ/กำลังขนส่ง — จัดส่งสำเร็จ/สำเร็จ/ยกเลิก/ตีกลับ ไม่นับ. เมื่อถึงจำนวนนี้ บนเว็บและ LINE ตัวเลือกเก็บเงินปลายทางจะเป็นสีเทาพร้อมเหตุผล ส่วนในแอปมือถือ ลูกค้ายังเลือกได้แต่จะได้รับข้อความแจ้งเมื่อกดสั่งซื้อ (แอปยังไม่ทำเป็นสีเทา) ลูกค้ายังชำระด้วยวิธีอื่นได้เสมอ (0 = ไม่จำกัด, ค่าเริ่มต้น 3)",
		otp_daily_cap_label: "จำนวน OTP SMS สูงสุดต่อวัน (ทั้งระบบ)",
		otp_daily_cap_help: "เพดานรวมของจำนวน OTP SMS ที่ทั้งระบบจะส่งได้ต่อวัน นับรวมทุกเบอร์และทุก IP (0 = ไม่จำกัด). เป็นด่านกันค่าใช้จ่ายขั้นสุดท้ายจากการยิง SMS ถล่ม เมื่อถึงเพดานแล้วคำขอ OTP ที่เหลือจะถูกบล็อกจนถึงวันถัดไป ค่าเริ่มต้น 500",
		cod_reject_threshold_label: "จำนวนครั้งปฏิเสธรับ COD สูงสุด",
		cod_reject_threshold_help: "บล็อกการสั่งเก็บเงินปลายทางของเบอร์นั้นเมื่อมีประวัติปฏิเสธรับสินค้า (ตีกลับ) ถึงจำนวนที่กำหนด (0 = ปิดการบล็อก, ค่าเริ่มต้น 3). ยังสั่งแบบชำระเงินล่วงหน้าได้ตามปกติ แอดมินเคลียร์ประวัติเพื่อปลดบล็อกได้ที่เมนูจัดการสมาชิก",
		points_per_100_label: "คะแนนสะสมต่อทุก 100 บาท",
		points_rate_custom_toggle: "กำหนดอัตราเอง",
		points_rate_unset_label: "ยังไม่ตั้งค่า — ใช้อัตราตามระดับสมาชิก",
		points_per_100_help: "คะแนนที่สมาชิกได้รับต่อยอดชำระทุก 100 บาท คำนวณตามยอดจริง เช่น ตั้ง 100 → สั่งซื้อ 150 บาท ได้ 150 คะแนน; มีผลกับคำสั่งซื้อที่สำเร็จหลังจากตั้งค่า ยังไม่ตั้งค่า = ใช้อัตราตามระดับสมาชิก, 0 = ปิดการให้คะแนน",
		btn_save: "บันทึก",
		saved: "บันทึกการตั้งค่าเรียบร้อย"
	},
    cashback_settings: {
		title: "Cash Back (เงินคืน)",
		subtitle: "ตั้ง % เงินคืนระดับร้าน และให้โปรโมชั่นชุดสินค้าตั้งค่าของตัวเองทับได้",
		enabled_label: "เปิดใช้งาน Cash Back",
		enabled_help: "ปิดอยู่ = ไม่คำนวณเงินคืนให้ลูกค้าเลย แต่ % ที่ตั้งไว้ยังถูกเก็บไว้ เปิดเมื่อไหร่ก็ใช้ค่าเดิมทันที",
		default_percent_label: "% Cash Back ของร้าน",
		default_percent_help: "ค่าเริ่มต้นที่ใช้กับโปรโมชั่นที่ไม่ได้ตั้ง % ของตัวเอง (0.00–100.00 ทศนิยม 2 ตำแหน่ง)",
		hint: "โปรโมชั่นที่ตั้ง % ไว้จะใช้ค่าของโปรโมชั่นแทน (ไม่บวกเพิ่ม) · ยังไม่ให้ coin จริงจนกว่าระบบ coin จะเปิด",
		btn_save: "บันทึก",
		saved: "บันทึกการตั้งค่า Cash Back เรียบร้อย",
		promo_label: "Cash Back %",
		promo_hint: "0 = ใช้ค่าของร้าน · มากกว่า 0 = ใช้ค่านี้แทนค่าร้าน (ไม่บวกเพิ่ม)",
		badge: "Cash Back",
		effective_off: "ปิด Cash Back อยู่ — ยังไม่มีผลกับลูกค้า",
		effective_promo: "มีผลจริง {percent}% (ค่าของโปรโมชั่นนี้)",
		effective_default: "มีผลจริง {percent}% (ค่าของร้าน)"
	},
    app_version_settings: {
        title: "เวอร์ชันแอป / บังคับอัปเดต",
        subtitle: "กำหนดเวอร์ชันแอปขั้นต่ำที่ต้องอัปเดตก่อนใช้งาน และเวอร์ชันล่าสุดที่แนะนำให้อัปเดต แยก Android / iOS",
        android: "Android",
        ios: "iOS",
        min_label: "เวอร์ชันขั้นต่ำ (บังคับ)",
        min_help: "ต่ำกว่าเลขนี้ = ลูกค้าต้องอัปเดตก่อนจึงจะใช้งานแอปได้ · เว้นว่าง = ไม่บังคับ",
        latest_label: "เวอร์ชันล่าสุด (แนะนำ)",
        latest_help: "ต่ำกว่าเลขนี้ = แจ้งเตือนให้อัปเดต กดข้ามได้ · เว้นว่าง = ไม่แจ้ง",
        store_url_label: "ลิงก์ร้านค้า (Play Store / App Store)",
        message_th_label: "ข้อความแจ้งเตือน (ไทย)",
        message_en_label: "ข้อความแจ้งเตือน (อังกฤษ)",
        btn_save: "บันทึก",
        confirm_raise_min: "ลูกค้าที่ใช้เวอร์ชันต่ำกว่า {versions} จะใช้งานแอปไม่ได้จนกว่าจะอัปเดต ยืนยัน?",
        saved: "บันทึกการตั้งค่าเวอร์ชันแอปเรียบร้อย",
        hint: "ใช้เลข x.y.z เท่านั้น (ไม่นับ build) · เว้นว่าง = ปิด · ตั้งได้หลังแอปเวอร์ชันที่รองรับขึ้นสโตร์แล้วเท่านั้น · iOS ไม่มีลิงก์ App Store = ไม่บังคับฝั่ง iOS",
        placeholder_example: "เช่น {example}",
        load_failed: "โหลดการตั้งค่าเวอร์ชันแอปไม่สำเร็จ จึงยังแก้ไข/บันทึกไม่ได้ (กันการล้างค่าที่ตั้งไว้โดยไม่ตั้งใจ)",
        retry: "ลองอีกครั้ง",
        err: {
            invalid_version: "รูปแบบเวอร์ชันไม่ถูกต้อง ใช้ x.y.z เช่น 1.5.0",
            min_gt_latest: "เวอร์ชันขั้นต่ำต้องไม่สูงกว่าเวอร์ชันล่าสุด",
            store_url_https: "ลิงก์ต้องขึ้นต้นด้วย https://",
            message_too_long: "ข้อความยาวเกิน 300 ตัวอักษร"
        }
    },
    coin_terms: {
		title: "ถ้อยคำ coin",
		subtitle: "ข้อความที่ลูกค้าเห็นเกี่ยวกับ coin — ชื่อหน่วย ข้อความสั้น และเงื่อนไขฉบับเต็ม แก้ที่นี่ได้เลยโดยไม่ต้องรอ deploy",
		name_th_label: "ชื่อหน่วย (ไทย)",
		name_en_label: "ชื่อหน่วย (อังกฤษ)",
		name_help: "คำที่ใช้เรียกหน่วยนี้กับลูกค้า เช่น coin / แต้ม",
		note_th_label: "ข้อความสั้น (ไทย)",
		note_en_label: "ข้อความสั้น (อังกฤษ)",
		note_help: "ข้อความใต้กล่องใช้ coin ตอนชำระเงินและในหน้า coin — สั้น อ่านจบในบรรทัดเดียว",
		terms_th_label: "เงื่อนไขฉบับเต็ม (ไทย)",
		terms_en_label: "เงื่อนไขฉบับเต็ม (อังกฤษ)",
		terms_help: "ข้อความธรรมดาเท่านั้น (ใส่ HTML ไม่ได้) · ขึ้นบรรทัดใหม่ 1 ครั้ง = ย่อหน้าใหม่",
		placeholder_hint: "ใส่ตัวแทนค่าได้ 2 ตัว ระบบจะแทนค่าจริงให้ตอนแสดงกับลูกค้า — {tok_months} = อายุ coin (เดือน), {tok_max} = สัดส่วนใช้สูงสุด (%) · พิมพ์ชื่อผิดจะแสดงเป็นวงเล็บปีกกาตามที่พิมพ์ · กด \"ดูตัวอย่าง\" เพื่อดูค่าจริง",
		version_line: "เวอร์ชัน {version} · แก้ล่าสุด {date}",
		version_never: "ยังไม่เคยแก้ — ใช้ข้อความตั้งต้นของระบบ",
		btn_preview: "ดูตัวอย่าง",
		btn_save: "บันทึกถ้อยคำ",
		saved: "บันทึกถ้อยคำ coin เรียบร้อย",
		no_change: "ไม่มีข้อความที่แก้ไข จึงไม่ได้บันทึก",
		hint: "ระบบจะเพิ่มเลขเวอร์ชันให้เองเมื่อเงื่อนไขฉบับเต็มเปลี่ยน · บันทึกเฉพาะช่องที่แก้ ช่องที่ไม่แตะค่าเดิมยังอยู่",
		preview_title: "ตัวอย่างที่ลูกค้าเห็น",
		preview_th: "ภาษาไทย",
		preview_en: "ภาษาอังกฤษ",
		preview_name_head: "ชื่อหน่วย",
		preview_note_head: "ข้อความสั้น",
		preview_terms_head: "เงื่อนไขฉบับเต็ม",
		preview_empty: "ยังไม่มีข้อความ",
		preview_close: "ปิด",
		err_form: "มีช่องที่กรอกไม่ถูกต้อง กรุณาแก้ตามข้อความสีแดงใต้ช่องนั้น",
		err_bad_text: "ระบบไม่รับข้อความนี้ — ชื่อหน่วยต้องไม่ว่าง ความยาวต้องไม่เกินที่กำหนด และห้ามมีแท็ก HTML",
		err: {
			empty: "ต้องกรอกชื่อหน่วย",
			too_long: "ข้อความยาวเกินที่กำหนด",
			tag: "ห้ามใส่แท็ก HTML (เช่น <b>, <script>) — ใช้ข้อความธรรมดาเท่านั้น",
			not_text: "ค่าที่ได้ไม่ใช่ข้อความ กรุณาโหลดหน้านี้ใหม่"
		}
	},
    mdfstore_channel: {
		title: "ช่องทางการขาย MDFStore",
		subtitle: "กำหนดช่องทางการขายให้แต่ละแหล่งที่มาของคำสั่งซื้อ MDFStore คำสั่งซื้อที่ sync มาจากเว็บร้านค้า ระบบสมาชิก และแอปพลิเคชัน จะถูกระบุช่องทางการขายที่เลือกไว้ในระบบ Backoffice",
		source_web: "เว็บร้านค้า (Web)",
		source_web_help: "ช่องทางการขายสำหรับคำสั่งซื้อที่สั่งผ่านเว็บร้านค้า (www)",
		source_member: "ระบบสมาชิก (Member)",
		source_member_help: "ช่องทางการขายสำหรับคำสั่งซื้อที่สั่งผ่านระบบสมาชิก",
		source_app: "แอปพลิเคชัน (App)",
		source_app_help: "ช่องทางการขายสำหรับคำสั่งซื้อที่สั่งผ่านแอปพลิเคชันมือถือ",
		select_placeholder: "เลือกช่องทางการขาย",
		no_options: "ไม่พบช่องทางการขายประเภท MDFStore กรุณาสร้างช่องทางการขายที่เมนู \"ช่องทางการขาย\" โดยเลือกประเภทเป็น \"MDFStore\" ก่อน",
		btn_save: "บันทึก",
		saved: "บันทึกช่องทางการขายเรียบร้อย"
	},
    cod_rejections: {
		menu: "ประวัติปฏิเสธรับ COD",
		title: "ประวัติปฏิเสธรับสินค้า COD",
		subtitle: "รายการเบอร์โทรที่มีประวัติปฏิเสธรับสินค้าเก็บเงินปลายทาง (ตีกลับ) — บล็อกเมื่อถึง {threshold} ครั้ง",
		btn_refresh: "รีเฟรช",
		col_phone: "เบอร์โทร",
		col_member: "สมาชิก",
		col_count: "จำนวนครั้ง",
		col_last: "ปฏิเสธล่าสุด",
		col_status: "สถานะ",
		col_action: "จัดการ",
		col_invoice: "เลขที่คำสั่งซื้อ",
		col_created: "วันที่สั่ง",
		col_rejected: "วันที่ตีกลับ",
		guest: "ลูกค้าทั่วไป (guest)",
		blocked: "ถูกบล็อก",
		ok: "ปกติ",
		btn_clear: "เคลียร์ประวัติ",
		clear_title: "เคลียร์ประวัติ / ปลดบล็อก",
		clear_msg: "ยืนยันเคลียร์ประวัติปฏิเสธรับของสำหรับเบอร์ {phone}? หลังจากนี้เบอร์นี้จะสั่ง COD ได้อีกครั้ง (ประวัติเดิมยังถูกเก็บไว้เพื่อการตรวจสอบ)",
		clear_success: "เคลียร์ประวัติเรียบร้อย",
		empty: "ยังไม่มีเบอร์ที่มีประวัติปฏิเสธรับสินค้า"
	},
    storefront: {
		hero_title: "แบนเนอร์สไลด์ (Hero)",
		hero_subtitle: "สไลด์ที่แสดงบนหน้าแรกของหน้าร้าน (www + member)",
		popup_title: "ป๊อปอัปเมื่อเข้าครั้งแรก",
		popup_subtitle: "ป๊อปอัปที่แสดงให้ผู้เข้าชมครั้งแรก",
		btn_add_slide: "เพิ่มสไลด์",
		edit_slide: "แก้ไขสไลด์",
		no_slides: "ยังไม่มีสไลด์",
		col_order: "ลำดับ",
		col_image: "รูปภาพ",
		col_caption_th: "ข้อความ (ไทย)",
		col_caption_en: "ข้อความ (อังกฤษ)",
		col_link: "ลิงก์ URL",
		col_enabled: "เปิดใช้งาน",
		popup_enabled: "เปิดใช้งาน",
		show_on_www: "แสดงบนร้านค้า (www)",
		show_on_member: "แสดงบน Member",
		field_image_required: "กรุณาอัปโหลดรูปภาพ",
		save_success: "บันทึกเรียบร้อยแล้ว",
		delete_title: "ยืนยันการลบ?",
		delete_msg: "สไลด์นี้จะถูกลบอย่างถาวร",
		delete_popup_msg: "ป๊อปอัปนี้จะถูกลบอย่างถาวร",
		delete_success: "ลบเรียบร้อยแล้ว",
		btn_delete: "ลบ",
		btn_cancel: "ยกเลิก",
		btn_add_popup: "เพิ่มป๊อปอัป",
		edit_popup: "แก้ไขป๊อปอัป",
		no_popups: "ยังไม่มีป๊อปอัป",
		col_title: "ชื่อเรียก",
		col_active: "ใช้งาน",
		activate_success: "อัปเดตป๊อปอัปที่ใช้งานแล้ว"
    },
    storefront_home: {
		title: "จัดการเนื้อหาหน้าแรก",
		subtitle: "แก้ไขข้อความ รูปภาพ และลิงก์ทุกจุดบนหน้าแรกของเว็บ แต่ละส่วนบันทึกแยกกัน",
		save: "บันทึก",
		saved: "บันทึกแล้ว",
		save_failed: "บันทึกไม่สำเร็จ",
		add_item: "เพิ่มรายการ",
		remove_item: "ลบ",
		move_up: "เลื่อนขึ้น",
		move_down: "เลื่อนลง",
		sec_topbar: "แถบประกาศบนสุด",
		sec_promobar: "แถบโปรโมชัน",
		sec_header: "ส่วนหัวเว็บ (โลโก้/เมนู)",
		sec_hero: "แบนเนอร์หลัก (Hero)",
		sec_campaigns: "แคมเปญ/คูปอง",
		sec_bestsellers: "สินค้าขายดี 5 อันดับ",
		sec_banner1: "แบนเนอร์แคมเปญใหญ่",
		sec_new_arrival: "สินค้าใหม่",
		sec_new_arrival2: "สินค้าใหม่ (แถบที่ 2)",
		sec_essence: "The Essence of Style",
		sec_collections: "คอลเลกชันแนะนำ",
		sec_footer: "ส่วนท้ายเว็บ (Footer)",
		f_text: "ข้อความ",
		f_title: "หัวข้อ",
		f_subtitle: "หัวข้อรอง",
		f_copy: "คำบรรยาย",
		f_eyebrow: "ป้ายกำกับ",
		f_details: "รายละเอียด (ขึ้นบรรทัดใหม่ได้)",
		f_price: "ราคา/ขนาด",
		f_cta_label: "ข้อความปุ่ม",
		f_cta_link: "ลิงก์ปุ่ม",
		f_image: "รูปภาพ",
		f_image_left: "รูปด้านซ้าย",
		f_image_product: "รูปสินค้า",
		f_image_app: "รูปแบนเนอร์สำหรับแอป",
		f_image_left_app: "รูปด้านซ้ายสำหรับแอป",
		f_image_product_app: "รูปสินค้าสำหรับแอป",
		app_image_hint: "ใช้เฉพาะในแอปมือถือ (สัดส่วนภาพต่างจากเว็บ) รูปสำหรับเว็บด้านบนไม่ได้รับผลกระทบ",
		f_link: "ลิงก์",
		f_label: "ข้อความ",
		f_label_en: "ชื่อ (EN)",
		f_label_th: "ชื่อ (ไทย)",
		f_title_en: "หัวข้อ (EN)",
		f_title_th: "หัวข้อ (ไทย)",
		label_th_hint: "เว้นว่างได้ — ระบบใช้คำแปลมาตรฐานถ้ามี",
		f_logo: "โลโก้ (ข้อความ)",
		f_amount: "ส่วนลด",
		f_code: "โค้ด/หมายเหตุ",
		f_theme: "โทนสี",
		f_platform: "แพลตฟอร์ม",
		f_product: "สินค้า",
		theme_dark: "เข้ม",
		theme_light: "สว่าง",
		theme_gift: "ของขวัญ",
		search_product: "พิมพ์เพื่อค้นหาสินค้า",
		max_products: "เลือกได้สูงสุด 5 รายการ",
		nav_items: "เมนูนำทาง",
		socials: "โซเชียลลิงก์",
		newsletter: "จดหมายข่าว",
		newsletter_title: "หัวข้อจดหมายข่าว",
		newsletter_subtitle: "คำอธิบายจดหมายข่าว",
		newsletter_placeholder: "ข้อความในช่องกรอก",
		newsletter_cta: "ปุ่มสมัคร",
		col_links: "คอลัมน์ลิงก์",
		col_shop: "คอลัมน์ Shop",
		col_about: "คอลัมน์ About",
		col_help: "คอลัมน์ Help",
		brand: "ชื่อแบรนด์",
		copyright: "ข้อความลิขสิทธิ์",
		card: "การ์ด",
		slot: "ช่อง",
		bestseller_hint: "เลือกได้สูงสุด 5 สินค้า ลำดับมีผล (ช่อง 1 = อันดับแรก)",
		image_stores_key: "ระบบเก็บเฉพาะ object key ส่วนภาพตัวอย่างใช้ CDN URL",
		updated_meta: "แก้ไขล่าสุด {time} โดยผู้ใช้ #{by}"
	},
    // www collections + discovery sets (spec 2026-10-13-www-nav-i18n-collections §5.2)
    storefront_collection: {
        title: "คอลเลกชันหน้าเว็บ",
        subtitle: "จัดคอลเลกชันและเซตทดลองที่แสดงบนหน้าเว็บ /collections และ /discovery-sets",
        tab_collections: "คอลเลกชัน",
        tab_discovery: "เซตทดลอง (Discovery Sets)",
        create: "สร้างคอลเลกชัน",
        create_title: "สร้างคอลเลกชัน",
        edit_title: "แก้ไขคอลเลกชัน",
        empty: "ยังไม่มีคอลเลกชัน",
        col: {
            order: "ลำดับ",
            cover: "ภาพปก",
            name: "ชื่อ (TH / EN)",
            slug: "slug",
            items: "จำนวนรายการ",
            status: "สถานะ",
            updated: "อัปเดตล่าสุด",
            actions: "จัดการ"
        },
        f: {
            name_th: "ชื่อ (ไทย)",
            name_en: "ชื่อ (EN)",
            slug: "slug",
            description_th: "คำอธิบาย (ไทย)",
            description_en: "คำอธิบาย (EN)",
            cover: "ภาพปก",
            items: "สินค้า/ชุดสินค้า",
            is_active: "เปิดใช้งาน",
            add_product: "เพิ่มสินค้า",
            add_bundle: "เพิ่มชุดสินค้า",
            search_product: "ค้นหาสินค้า (รหัส/ชื่อ)",
            pick_bundle: "เลือกชุดสินค้า"
        },
        slug_hint: "ใช้ a-z, 0-9 และ - เท่านั้น เช่น glam-collection (ระบบเสนอจากชื่อ EN)",
        items_hint: "ลำดับในรายการ = ลำดับบนหน้าเว็บ รายการที่ไม่พร้อมขายจะไม่แสดงบนหน้าเว็บ",
        items_counter: "{count}/{max}",
        no_items: "ยังไม่มีรายการ",
        type_product: "สินค้า",
        type_bundle: "ชุดสินค้า",
        unavailable: "ไม่พร้อมขาย",
        active: "เปิด",
        inactive: "ปิด",
        page_link: "หน้าเว็บ",
        copy_url: "คัดลอกลิงก์",
        copied: "คัดลอกลิงก์แล้ว",
        open_page: "เปิดหน้าเว็บ",
        edit: "แก้ไข",
        delete: "ลบ",
        move_up: "เลื่อนขึ้น",
        move_down: "เลื่อนลง",
        remove: "นำออก",
        save: "บันทึก",
        cancel: "ยกเลิก",
        confirm: "ยืนยัน",
        confirm_delete: "ลบคอลเลกชัน \"{name}\" ใช่หรือไม่? ลิงก์ /collections/{slug} จะใช้ไม่ได้",
        saved: "บันทึกแล้ว — หน้าเว็บอัปเดตภายใน 1 นาที",
        deleted: "ลบคอลเลกชันแล้ว",
        discovery_hint: "รายการเดียว แสดงบนหน้า /discovery-sets ไม่มี slug ให้แก้",
        err: {
            slug_taken: "slug นี้ถูกใช้แล้ว",
            slug_reserved: "slug \"discovery-sets\" สงวนไว้สำหรับหน้าเซตทดลอง",
            schema_missing: "ต้องรัน SQL 2026-10-13-storefront-collection.sql ก่อน",
            stale: "มีคนแก้ไขรายการนี้ไปแล้ว — โหลดข้อมูลล่าสุดแล้ว กรุณาตรวจสอบและบันทึกอีกครั้ง",
            too_many_items: "เพิ่มได้สูงสุด 60 รายการ",
            forbidden: "เฉพาะผู้ดูแลระบบ (admin) เท่านั้นที่แก้ไขได้",
            load: "โหลดข้อมูลไม่สำเร็จ",
            copy_failed: "คัดลอกไม่สำเร็จ",
            fix_fields: "กรุณาแก้ไขช่องที่มีเครื่องหมายสีแดง"
        },
        rule: {
            required: "จำเป็นต้องกรอก",
            max_length: "ยาวเกินกำหนด",
            format: "ใช้ a-z, 0-9 และ - (2–60 ตัว) ห้ามขึ้นต้น/ลงท้ายด้วย -",
            reserved: "slug นี้สงวนไว้สำหรับระบบ",
            taken: "slug นี้ถูกใช้แล้ว",
            too_many: "เพิ่มได้สูงสุด 60 รายการ",
            range: "ค่าไม่ถูกต้อง",
            invalid: "ข้อมูลไม่ถูกต้อง"
        }
    },
    app_catalog: {
		btn_add_category: "เพิ่มหมวดหมู่",
		btn_add_product: "เพิ่มสินค้า",
		btn_add_campaign: "สร้างแฟลชเซล",
		// แฟลชเซล page (spec 2026-10-05-flash-sale-campaign-page §6.3)
		flash_sale_new_title: "สร้างแฟลชเซล",
		flash_sale_edit_breadcrumb: "แก้ไขแฟลชเซล",
		flash_sale_edit_title: "แก้ไขแฟลชเซล : {id}",
		flash_sale_info: "ข้อมูลแคมเปญ",
		flash_sale_name: "ชื่อแคมเปญ",
		flash_sale_period: "เวลาที่เริ่มใช้งาน",
		flash_sale_period_hint: "เวลาประเทศไทย (GMT+7)",
		flash_sale_discount_type: "ประเภทส่วนลด",
		flash_sale_products: "สินค้าที่เข้าร่วม ({n})",
		flash_sale_add_products: "เพิ่มสินค้า",
		flash_sale_save_first: "บันทึกข้อมูลแคมเปญก่อนจึงจะเพิ่มสินค้าได้",
		flash_sale_products_empty: "ยังไม่มีสินค้าในแฟลชเซลนี้",
		flash_sale_selected: "เลือกแล้ว {n} รายการ",
		flash_sale_clear_selection: "ล้างที่เลือก",
		flash_sale_in_campaign: "อยู่ในแคมเปญแล้ว",
		flash_sale_add_result: "เพิ่ม {added} รายการ (ข้าม {skipped} ที่มีอยู่แล้ว)",
		flash_sale_remove_confirm: "นำสินค้านี้ออกจากแฟลชเซล?",
		flash_sale_col_normal_price: "ราคาปกติ",
		flash_sale_col_sale_price: "ราคาแฟลชเซล",
		flash_sale_col_remaining: "คงเหลือ",
		flash_sale_col_products: "สินค้า",
		flash_sale_flash_conflict: "⚡ flash ราย SKU ทับ {n} SKU",
		flash_sale_flash_shopee: "⚡ Shopee ใช้ราคา {price} แทน",
		flash_sale_flash_manual: "⚡ ตั้งเอง ใช้ราคา {price} แทน",
		flash_sale_overlap: "ทับกับ: {name} #{id}",
		flash_sale_overlap_hint: "ระบบจะใช้แคมเปญที่ลดมากที่สุด",
		flash_sale_overlap_warn: "มีสินค้า {n} รายการอยู่ในแฟลชเซลอื่นช่วงเวลาเดียวกัน",
		flash_sale_need_products: "เพิ่มสินค้าก่อนเปิดใช้งาน",
		flash_sale_unsaved_confirm: "มีการแก้ไขที่ยังไม่บันทึก ออกจากหน้านี้?",
		flash_sale_sold_out: "หมด",
		flash_sale_sku_closed: "ปิด SKU",
		flash_sale_not_found: "ไม่พบแฟลชเซลนี้",
		flash_sale_col_sku: "SKU",
		flash_sale_leave: "ออกจากหน้านี้",
		flash_sale_remove: "เอาออก",
		flash_sale_view_skus: "ดู SKU",
		flash_sale_name_hint: "คลิกชื่อสินค้าเพื่อดู SKU",
		flash_sale_view: "ดูรายละเอียด",
		flash_sale_app_disabled: "ปิดขาย",
		flash_sale_search_placeholder: "ค้นหาชื่อ / รหัสสินค้า",
		flash_sale_back_to_list: "กลับไปหน้ารายการ",
		flash_sale_image_hint: "คลิกรูปเพื่อดู SKU",
		phase_draft: "แบบร่าง",
		phase_upcoming: "รอเริ่ม",
		phase_ongoing: "กำลังลด",
		phase_expired: "หมดเวลา",
		phase_ended: "ปิดแล้ว",
		btn_add_coupon_template: "สร้าง Template คูปอง",
		image_upload_hint: "คลิกหรือลากไฟล์มาวาง (JPG/PNG, max 5MB)",
		delete_title: "ยืนยันการลบ?",
		delete_msg: "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
		delete_success: "ลบเรียบร้อยแล้ว",
		deactivate_title: "ยืนยันการปิดใช้งาน?",
		deactivate_msg: "คูปองนี้จะถูกปิดใช้งานและไม่สามารถใช้งานได้อีก",
		deactivate_success: "ปิดใช้งานเรียบร้อยแล้ว",
		btn_delete: "ลบ",
		btn_deactivate: "ปิดใช้งาน",
		btn_cancel: "ยกเลิก",
		save_success: "บันทึกเรียบร้อยแล้ว",
		field_required: "กรุณากรอกข้อมูล",
		no_data: "ไม่มีข้อมูล",
		select_anchor_first: "กรุณาเลือกสินค้าหลักก่อน",
		status_draft: "ฉบับร่าง",
		status_active: "เปิดใช้งาน",
		status_ended: "สิ้นสุดแล้ว",
		discount_type_percent: "ส่วนลดเปอร์เซ็นต์",
		discount_type_fixed: "ส่วนลดจำนวนเงิน",
		discount_type_shipping_free: "ส่งฟรี",
		campaign_kind_percent: "ลด %",
		campaign_kind_fixed: "ลดราคาตายตัว",
		edit_category: "แก้ไขหมวดหมู่",
		edit_product: "แก้ไขสินค้า",
		edit_campaign: "แก้ไขแคมเปญ",
		// หัวข้อหน้าแก้ไขพร้อม id (owner 2026-10-05) — แยกจาก edit_* ด้านบน
		// เพราะ edit_product ใช้เป็นเมนูในตารางสินค้าด้วย · placeholder: {id}
		edit_category_title: "แก้ไขหมวดหมู่ : {id}",
		edit_product_title: "แก้ไขสินค้า : {id}",
		edit_campaign_title: "แก้ไขโปรโมชัน : {id}",
		edit_bundle_title: "แก้ไขชุดสินค้า : {id}",
		edit_coupon_template: "แก้ไข Template คูปอง",
		col_image: "รูปภาพ",
		// /seller/products large-image preview (owner 2026-10-15) · placeholder: {name}
		image_preview_open: "ดูรูปขนาดใหญ่: {name}",
		image_preview_close: "ปิด",
		image_preview_loading: "กำลังโหลดรูป…",
		image_preview_error: "โหลดรูปไม่สำเร็จ",
		col_name_th: "ชื่อ (ไทย)",
		col_name_en: "ชื่อ (อังกฤษ)",
		col_sort_order: "ลำดับ",
		// category channel visibility (spec 2026-10-05 §6)
		col_show_web: "เว็บ",
		col_show_member: "สมาชิก",
		col_show_app: "แอป",
		visibility_label: "แสดงบน",
		visibility_hint: "ปิดสวิตช์เพื่อซ่อนหมวดจากเมนูทุกช่องทาง สินค้ายังซื้อได้ตามปกติ",
		visibility_hidden_all: "ซ่อนทุกช่องทาง",
		visibility_saved: "บันทึกการแสดงผลแล้ว",
		visibility_failed: "บันทึกการแสดงผลไม่สำเร็จ",
		visibility_not_ready: "รอเปิดใช้งาน (ต้องรัน SQL ก่อน)",
		// single switch (owner follow-up 2026-10-05)
		col_show: "แสดง",
		visibility_hidden: "ซ่อน",
		visibility_mixed: "ตั้งค่าบางช่องทาง",
		col_code: "รหัสสินค้า",
		col_price: "ราคา",
		col_app_enable: "สถานะการขาย",
		col_app_tag: "Tag",
		col_cod: "COD",
		col_visibility: "แสดงผล",
		col_detail: "รายละเอียด",
		col_category: "หมวดหมู่",
		col_app_discount: "ส่วนลด",
		col_discount_start: "เริ่มลด",
		col_discount_end: "สิ้นสุดลด",
		col_kind: "ประเภท",
		col_value: "มูลค่า",
		col_starts_at: "เริ่ม",
		col_ends_at: "สิ้นสุด",
		col_date_range: "ช่วงเวลา",
		col_targets: "สินค้าเป้าหมาย",
		search_products: "ค้นหาสินค้า",
		select_category: "เลือกหมวดหมู่",
		section_basic_info: "ข้อมูลพื้นฐาน",
		section_images: "รูปภาพ",
		section_skus: "SKU",
		section_discount: "ส่วนลด",
		sku_code: "รหัส SKU",
		sku_name: "ชื่อ SKU",
		// #246 + #257 รหัส SKU ถูก gen จาก man_pn ของสินค้าคลังที่เลือกใน modal (ต่อด้วย +)
		// ห้ามพิมพ์เอง — man_pn คือรหัสที่ตัว auto-map ฝั่ง BE อ่านกลับได้
		// (#257 ย้ายปลายทางจาก sku_name มาเป็น sku_code — ชื่อ SKU พิมพ์เองได้แล้ว)
		sku_wms_edit: "แก้ไขรหัส SKU จากสินค้าคลัง",
		sku_wms_modal_title: "เลือกสินค้าคลัง (WMS) ของ SKU นี้",
		sku_wms_select_placeholder: "ค้นหาสินค้าคลัง (รหัสสินค้า man_pn / ชื่อ)",
		sku_wms_add: "เพิ่มเข้ารายการ",
		sku_wms_remove: "ลบออกจากรายการ",
		sku_wms_confirm: "ตกลง",
		sku_wms_cancel: "ยกเลิก",
		sku_wms_empty: "ยังไม่ได้เลือกสินค้าคลัง — รหัส SKU จะเป็นค่าว่าง",
		sku_wms_qty: "จำนวน",
		sku_wms_qty_hint: "จำนวนชิ้นที่ต้องหยิบต่อ 1 SKU — รหัส SKU จะบวกรหัสซ้ำตามจำนวน (เช่น 2 ชิ้น = A+A)",
		sku_wms_duplicate: "สินค้าคลังนี้อยู่ในรายการแล้ว — เพิ่มจำนวนเป็น {n} ชิ้น",
		sku_wms_qty_max: "ใส่ได้สูงสุด {max} ชิ้นต่อสินค้าคลัง 1 รายการ",
		sku_wms_load_failed: "โหลดรายการสินค้าคลังไม่สำเร็จ",
		sku_wms_preview: "รหัส SKU ที่จะได้ (ต่อรหัสสินค้าด้วย +)",
		// #257 mdfpf_product_sku.sku_code เป็น varchar(100) — เกินแล้วกดตกลงไม่ได้
		sku_code_too_long: "รหัส SKU ยาวเกิน {max} ตัวอักษร — กรุณาลดจำนวนสินค้าคลังที่แมปไว้",
		sku_wms_single_source: "แมปสินค้าคลัง (WMS) ที่นี่ที่เดียว ไม่ต้องไปทำที่หน้าสินค้า Platform อีก",
		sku_price: "ราคา",
		sku_quantity: "จำนวน",
		add_sku: "เพิ่ม SKU",
		sku_images: "รูป SKU",
		manage_images: "จัดการรูป",
		promo_bundle_title: "ชุดโปรโมชัน",
		btn_add_bundle: "สร้างชุดโปรโมชัน",
		edit_bundle: "แก้ไขชุดโปรโมชัน",
		promo_kind: "ประเภท",
		promo_kind_sku: "เลือกจาก SKU",
		promo_kind_wms: "เลือกจากสินค้าคลัง (WMS)",
		promo_price_mode: "รูปแบบราคา",
		promo_price_sum: "รวมราคาตัวเลือก",
		promo_price_fixed: "ราคาตายตัว",
		promo_fixed_price: "ราคาตายตัว",
		image_mode_label: "การแสดงภาพหลัก",
		image_mode_main: "แสดงภาพหลัก",
		image_mode_sku: "แสดงภาพตาม sku",
		image_mode_hint: "แสดงภาพหลัก: ภาพหลักจะคงเดิม (ภาพปกชุดสินค้า) แม้ลูกค้าจะเลือกตัวเลือก/SKU  แสดงภาพตาม sku: ภาพหลักจะเปลี่ยนตามภาพของตัวเลือกที่เลือก",
		market_label: "ตลาด",
		market_domestic: "ในประเทศ",
		market_international: "ต่างประเทศ",
		market_both: "ทั้งสองตลาด",
		market_hint: "กำหนดว่าลูกค้าตลาดไหนมองเห็นโปรโมชันนี้ (ค่าเริ่มต้น: ในประเทศ)",
		bonus_points_label: "คะแนนพิเศษ (bonus points)",
		bonus_points_hint: "คะแนนสะสมพิเศษที่ลูกค้าได้รับเพิ่มต่อ 1 เซ็ต (0 = ใช้ค่าจาก SKU)",
		market_filter_all: "ทุกตลาด",
		slot: "ช่องเลือก",
		add_slot: "เพิ่มช่อง",
		duplicate_slot: "คัดลอกช่อง",
		bulk_flash_label: "ตั้ง Flash Sale ให้ทุกตัวเลือก:",
		bulk_flash_apply: "ใส่ให้ทุกตัวเลือก",
		bulk_flash_applied: "ใส่ Flash Sale ให้ {count} ตัวเลือกแล้ว",
		bulk_flash_empty: "กรุณาตั้งราคา Flash หรือช่วงเวลาก่อน",
		slot_label: "ชื่อช่อง",
		option: "ตัวเลือก",
		add_option: "เพิ่มตัวเลือก",
		option_label: "ชื่อตัวเลือก",
		option_image: "รูป",
		option_upload_image: "อัปโหลด",
		option_change_image: "เปลี่ยน",
		option_remove_image: "ลบ",
		option_price: "ราคา",
		option_display_name: "ชื่อที่แสดง",
		option_flash_price: "ราคาแฟลชเซล",
		option_flash_window: "ช่วงเวลาแฟลชเซล",
		search_wms_product: "ค้นหาสินค้าคลัง",
		anchor_product: "สินค้าอ้างอิง",
		coupon_code: "รหัสคูปอง",
		coupon_discount_type: "ประเภทส่วนลด",
		coupon_discount_value: "มูลค่าส่วนลด",
		coupon_max_discount: "ส่วนลดสูงสุด",
		coupon_min_purchase: "ยอดขั้นต่ำ",
		coupon_expiry_days: "วันหมดอายุ (วัน)",
		coupon_valid_from: "เริ่มใช้ได้",
		coupon_valid_to: "ใช้ได้ถึง",
		coupon_eligibility: "เงื่อนไข",
		eligibility_any: "สมาชิกทุกคน",
		eligibility_new_member: "สมาชิกใหม่ (welcome)",
		eligibility_birthday: "วันเกิด",
		eligibility_level_up: "เลื่อนระดับ",
		eligibility_manual: "แจกเอง (manual)",
		eligibility_public_code: "โค้ดสาธารณะ (ลูกค้ากรอกเอง)",
		public_code_hint: "ลูกค้าจะพิมพ์โค้ดนี้ตอนชำระเงิน · ตัวพิมพ์ใหญ่ A-Z 0-9",
		col_issued_quota: "ใช้ไป/โควตา",
		err_public_code_invalid: "โค้ดสาธารณะต้องเป็น A-Z หรือ 0-9 ยาว 4-20 ตัว",
		err_public_code_expiry_days: "โค้ดสาธารณะต้องกำหนดวันหมดอายุอย่างน้อย 1 วัน",
		err_public_code_discount_value: "มูลค่าส่วนลดต้องมากกว่า 0",
		err_public_code_points_cost: "โค้ดสาธารณะใช้แต้มแลกไม่ได้ (แต้มที่ใช้ต้องเป็น 0)",
		err_public_code_valid_window: "วันที่ 'ใช้ได้ถึง' ต้องหลังวันที่ 'เริ่มใช้ได้'",
		err_public_code_taken: "มีโค้ดสาธารณะนี้ที่เปิดใช้งานอยู่แล้ว",
		err_public_code_conflicts_campaign: "โค้ดนี้ซ้ำกับโค้ดคูปองแคมเปญที่ยังใช้งานอยู่",
		coupon_points_cost: "แต้มที่ใช้",
		coupon_max_use_per_member: "ใช้ได้ต่อคน",
		coupon_total_quota: "โควต้ารวม",
		coupon_is_active: "สถานะ",
		enabled: "เปิด",
		disabled: "ปิด",
		deactivate_coupon_confirm: "ปิดใช้งานคูปองนี้?",
		campaign_delete_warning: "ลบแคมเปญนี้จะไม่สามารถกู้คืนได้",
		sku_stock_source: "แหล่งสต็อก",
		sku_stock_auto: "อัตโนมัติ (ซิงค์)",
		sku_stock_manual: "กำหนดเอง",
		sku_stock_auto_hint: "ซิงค์อัตโนมัติจากแพลตฟอร์ม",
		// #257 คอลัมน์แฟลชเซลซ่อนไว้ ถ้าสินค้านี้ยังไม่เคยตั้งแฟลชเซล
		sku_show_flash: "แสดงแฟลชเซล",
		sku_flash_price: "ราคาแฟลชเซล (SKU)",
		sku_flash_window: "ช่วงเวลาแฟลชเซล (SKU)",
		sku_bonus_points: "คะแนนพิเศษ",
		product_price_mode: "รูปแบบราคา",
		product_price_per_sku: "ราคาแยกตาม SKU",
		product_price_fixed: "ราคาตายตัว",
		product_fixed_price_hint: "ราคานี้จะถูกใช้เป็นราคาของทุก SKU",
		section_option_groups: "ตัวเลือกสินค้า",
		add_option_group: "+ เพิ่มกลุ่มตัวเลือก",
		option_group_name: "ชื่อกลุ่มตัวเลือก",
		option_group_values: "ค่าตัวเลือก",
		generate_sku_matrix: "สร้าง SKU จากตัวเลือก",
		matrix_regenerate_confirm: "มี SKU เดิมอยู่แล้ว ต้องการสร้างใหม่? (SKU ที่ไม่ตรงกับตัวเลือกใหม่จะถูกลบ)",
		option_group_placeholder: "เช่น สี, ขนาด",
		option_value_placeholder: "เช่น แดง, ดำ",
		section_bundle_images: "รูปภาพบันเดิล",
		wms_product_title: "สินค้าคลัง (WMS)",
		wms_product_sku: "SKU",
		wms_product_barcode: "รหัส SKU",
		wms_product_stock: "สต็อกหน้าร้าน",
		wms_product_stock_saved: "บันทึกสต็อกเรียบร้อย",
		wms_product_import_btn: "ดึงจาก Backoffice",
		wms_product_import_title: "ดึงสินค้าจาก Backoffice",
		wms_product_import_confirm: "นำเข้า",
		wms_product_import_success: "นำเข้าสินค้าเรียบร้อยแล้ว",
		wms_product_search_placeholder: "ค้นหาชื่อ / บาร์โค้ด",
		wms_product_search_btn: "ค้นหา",
		wms_product_refresh: "รีเฟรช",
		wms_product_sync_btn: "ซิงค์ข้อมูล",
		wms_product_sync_success: "ซิงค์ข้อมูลเรียบร้อยแล้ว",
		// 2026-10-03 — หน้าต่าง "ดึงสินค้าจาก Backoffice" แสดงรายการทั้งหมดแบบแบ่งหน้า
		wms_product_price: "ราคา",
		wms_product_imported: "นำเข้าแล้ว",
		wms_product_total: "ทั้งหมด {count} รายการ",
		section_giveaways: "ของแถม / Giveaways",
		add_giveaway: "เพิ่มของแถม",
		giveaway_qty: "จำนวน",
		flash_badge: "Flash",
		flash_only_filter: "เฉพาะที่ลดพิเศษ",
		// mdf-bo-api#583 — SKU ที่บันทึก wms_map ไว้ "ครึ่งเดียว": รหัส SKU เป็น
		// combo (A+B) แต่ map ได้ไม่ครบทุกรหัสคลัง ⇒ หน้าจอดูเหมือนแมปแล้ว แต่
		// ห้องแพ็คจะหยิบของไม่ครบ
		wms_unmatched_badge: "WMS ไม่ครบ",
		wms_unmatched_column: "WMS",
		wms_unmatched_filter: "เฉพาะที่ WMS ไม่ครบ",
		wms_unmatched_filter_hint: "กรองเฉพาะรายการในหน้านี้",
		// Owner rule 2026-10-15: SKU ที่ไม่มีชื่อตัวเลือก ถือว่าไม่สมบูรณ์ ห้ามเปิดขาย
		incomplete_sku_badge: "ไม่สมบูรณ์ (ไม่มีชื่อตัวเลือก)",
		incomplete_sku_tooltip: "มี {n} SKU ที่ยังไม่มีชื่อตัวเลือก — หน้าร้านจะไม่แสดง SKU นี้ และเปิดขายสินค้าไม่ได้จนกว่าจะตั้งชื่อ",
		incomplete_sku_filter: "เฉพาะไม่สมบูรณ์ (ไม่มีชื่อตัวเลือก)",
		sku_name_required: "กรุณาตั้งชื่อตัวเลือกก่อนเปิดขาย",
		wms_unmatched_tooltip_sku: "{code}: ขาด {missing} จาก {expected} รหัสคลัง",
		wms_unmatched_tooltip_parts: "ไม่พบในคลัง: {parts}",
		wms_unmatched_tooltip_unknown: "ไม่ทราบว่ารหัสไหน — เปิดหน้าแก้ไขเพื่อดู SKU นี้",
		wms_unmatched_tooltip_more: "และอีก {count} รหัส",
		// ---- #301 shared stock (spec 2026-10-01 §8/§11) ----
		// SKU ที่แมปคลังครบ = จำนวนถูกคำนวณจาก WMS ใหม่ทุก 20 วินาที แก้ที่หน้านี้ไม่ได้
		// (พิมพ์ไปก็ถูกเขียนทับภายในนาทีเดียว) · SKU ที่แมปไม่ครบยังตั้งจำนวนเองเหมือนเดิม
		sku_quantity_from_wms: "จาก WMS",
		sku_quantity_from_wms_hint: "จำนวนนี้มาจากคลัง (WMS) อัตโนมัติ — แก้ที่หน้าคลังสินค้า",
		sku_quantity_from_wms_hint_detail: "ตัวเลขนี้คำนวณจาก WMS (คงเหลือ {available} − รอตัด {pending}) — แก้ที่ WMS",
		sku_quantity_manual_hint: "SKU นี้ยังไม่ได้แมปสินค้าคลัง จำนวนตั้งเอง",
		sku_quantity_ignored: "ระบบไม่รับจำนวนของ {n} SKU ที่ดึงสต็อกจาก WMS ({codes}) — ตัวเลขมาจากคลังอัตโนมัติ",
		stock_unmatched_title: "SKU ที่ยังไม่ได้แมปคลัง",
		stock_unmatched_count: "{n} SKU ยังตั้งจำนวนเอง",
		stock_unmatched_hint: "SKU เหล่านี้ไม่ได้ดึงสต็อกจากคลัง (WMS) จำนวนจะค้างที่ค่าที่ตั้งไว้เองจนกว่าจะแมปครบ",
		stock_unmatched_empty: "ไม่พบ SKU ที่แมปคลังไม่ครบ",
		stock_unmatched_load_failed: "โหลดรายการไม่สำเร็จ — ตรวจสอบว่า API /catalog/stock/unmatched ขึ้นแล้ว",
		stock_unmatched_col_product: "สินค้า",
		stock_unmatched_col_reason: "สาเหตุ",
		stock_unmatched_col_missing: "รหัสคลังที่ขาด",
		stock_unmatched_col_message: "รายละเอียด",
		stock_unmatched_missing_count: "ขาด {n} รหัส",
		stock_unmatched_code_unmapped: "ยังไม่ได้แมปคลัง",
		stock_unmatched_code_unmatched: "แมปแล้วแต่ไม่พบของในคลัง",
		stock_unmatched_code_unknown: "ไม่ทราบสาเหตุ",
		stock_unmatched_banner: "มี SKU ที่ WMS ไม่ครบ {n} รายการในหน้านี้",
		stock_unmatched_banner_link: "ดูรายการทั้งหมด",
		stock_unmatched_truncated: "การสแกนชนเพดานจำนวนแถว ตัวเลขด้านล่างจึงเป็นค่าต่ำสุด — แมป SKU ที่แสดงอยู่แล้วโหลดใหม่",
		sync_to_bo_btn: "ซิงก์ไป Backoffice",
		sync_to_bo_success: "ส่งสินค้าหน้าร้านไป Backoffice เรียบร้อยแล้ว",
		sync_to_bo_in_progress: "กำลังซิงก์อยู่ กรุณารอสักครู่",
		sync_to_bo_log_title: "ประวัติการซิงก์",
		sync_to_bo_log_hint: "คลิกเพื่อดูประวัติการซิงก์",
		// ---- seller UI revamp 2026-10-03 (design §5 i18n table) ----
		// docs/specs/2026-10-03-seller-ui-revamp-design.md §5. Appended as one block
		// so the two FE halves of this change cannot collide in this file.
		// คีย์ชุดนี้ต้องมีครบเท่ากันทั้ง th.js และ en.js
		col_sale_status: "สถานะการขาย",
		sale_status_ready: "พร้อมขาย",
		sale_status_not_ready: "ไม่พร้อมขาย",
		sale_status_hint_disabled: "ปิดการขายอยู่",
		sale_status_hint_no_stock: "ไม่มีสต็อกพร้อมขาย",
		col_toggle: "เปิด-ปิด",
		sale_on: "เปิดการขาย",
		sale_off: "ปิดการขาย",
		// ใต้สวิตช์สถานะการขายในหน้าแก้ไขสินค้า (ProductEdit.vue)
		sale_enable_hint: "ปิดแล้วสินค้าจะไม่แสดงในแอปและเว็บ ลูกค้าซื้อไม่ได้",
		toggle_on_success: "เปิดการขายแล้ว",
		toggle_off_success: "ปิดการขายแล้ว",
		toggle_failed: "เปลี่ยนสถานะการขายไม่สำเร็จ",
		flash_active_tooltip: "กำลังลดพิเศษ (Flash Sale) อยู่",
		action_preview: "ดูหน้าร้าน",
		expand_skus_empty: "ยังไม่มี SKU",
		expand_load_failed: "โหลดรายละเอียดไม่สำเร็จ",
		bundle_options_empty: "ยังไม่มีตัวเลือก",
		col_available_qty: "คงเหลือ",
		// ---- แก้ราคา/จำนวนในตารางด้วยดินสอ 2026-10-03 ----
		// docs/specs/2026-10-03-seller-inline-price-qty-edit-design.md §4
		// ต่อท้ายเป็นบล็อกเดียว คีย์ต้องมีครบเท่ากันทั้ง th.js และ en.js
		col_sellable_qty: "จำนวนสินค้าพร้อมขาย",
		// หัวคอลัมน์หน้าจัดการสินค้า ขึ้นบรรทัดใหม่ตรงคำ (2026-10-15)
		col_sellable_qty_header: "จำนวนสินค้า\nพร้อมขาย",
		inline_edit_price: "แก้ไขราคา",
		inline_edit_qty: "แก้ไขจำนวน",
		inline_save: "บันทึก",
		inline_cancel: "ยกเลิก",
		inline_saved: "บันทึกแล้ว",
		inline_save_failed: "บันทึกไม่สำเร็จ",
		inline_price_invalid: "ราคาต้องมากกว่า 0",
		inline_qty_invalid: "จำนวนต้องเป็น 0 หรือมากกว่า",
		inline_qty_wms_refused: "จำนวนของ SKU นี้มาจาก WMS แก้ที่นี่ไม่ได้",
		inline_price_fixed_hint: "สินค้านี้ใช้ราคาเดียวทั้งรายการ แก้ที่หน้าแก้ไขสินค้า",
		inline_price_flash_hint: "กำลังลดพิเศษจาก Shopee ราคาปกติที่แก้จะมีผลหลังโปรฯ จบ",
		inline_hint_edit_in_rows: "กดดินสอแล้วแก้ราคา/จำนวนของแต่ละ SKU ด้านล่าง",
		// owner bo-stg 2026-10-03: กดดินสอจำนวนแล้วช่องแก้ไม่ได้เลยทุก SKU
		inline_qty_all_wms: "จำนวนทั้งหมดมาจาก WMS — แก้ที่ระบบคลัง หรือถอดการแมปที่หน้าแก้ไขสินค้า",
		inline_qty_from_wms_hint: "จำนวนมาจาก WMS — แก้ที่ระบบคลัง หรือถอดการแมป WMS ที่หน้าแก้ไขสินค้าถ้าต้องการตั้งเอง",
    },
    shipping_tier: {
		title: "ตารางค่าจัดส่ง",
		btn_add: "เพิ่มขั้นค่าจัดส่ง",
		edit_title: "แก้ไขขั้นค่าจัดส่ง",
		col_range: "ช่วงยอดสั่งซื้อ",
		col_min: "ยอดขั้นต่ำ",
		col_fee: "ค่าจัดส่ง (฿)",
		col_active: "เปิดใช้งาน",
		label_min: "ยอดขั้นต่ำ (฿)",
		label_fee: "ค่าจัดส่ง (฿)",
		label_active: "เปิดใช้งาน",
		save_success: "บันทึกเรียบร้อยแล้ว",
		delete_title: "ยืนยันการลบ?",
		delete_msg: "การดำเนินการนี้ไม่สามารถย้อนกลับได้",
		delete_success: "ลบเรียบร้อยแล้ว",
		no_data: "ไม่มีข้อมูล",
		field_required: "กรุณากรอกข้อมูล",
		err_min_negative: "ยอดขั้นต่ำต้องไม่น้อยกว่า 0",
		err_fee_negative: "ค่าจัดส่งต้องไม่น้อยกว่า 0",
		err_dup_min: "มีขั้นค่าจัดส่งที่ยอดขั้นต่ำนี้อยู่แล้ว",
		err_floor_protected: "ไม่สามารถลบขั้นพื้นฐาน (฿0) ได้",
		ge_prefix: "≥ ",
		range_to: " – ",
		arrow: " → "
    },
    auth: {
		unverify: "ผู้ใช้งานยังไม่ได้ยืนยันตัวตน",
        block: "ผู้ใช้งานถูกระงับ",
        signin: "เข้าสู่ระบบ",
        signout: "ออกจากระบบ",
        username: "อีเมล์หรือชื่อผู้ใช้งาน",
        email: "อีเมล์",
        password: "รหัสผ่าน",
        forgetpassword: "ลืมรหัสผ่าน",
        resetpassword: "รีเซ็ตพาสเวิร์ด",
        confirm_reset_password: "ยืนยันการรีเซ็ตพาสเวิร์ดหมายเลข ",
        forgot_password_success: "ลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
        reset_password_success: "เปลี่ยนรหัสผ่านสำเร็จ",
        // ปุ่มเข้าสู่ระบบด้วย LINE ที่หน้า /login
        // (spec docs/specs/2026-10-03-bo-staff-line-login-design.md §5)
        or: "หรือ",
        line_signin: "เข้าสู่ระบบด้วย LINE",
        line_connecting: "กำลังเชื่อมต่อกับ LINE…"
    },

    name: "ชื่อ",
    description: "คำอธิบาย",
    location_x: "ตำแหน่ง (X)",
    location_y: "ตำแหน่ง (Y)",
    group_name: "ชื่อกลุ่ม",
    email: "อีเมล์",
    email_optional: "อีเมล์ (ไม่ระบุ)",
    created: "วันที่สร้าง",
    payment_at: "วันที่ชำระเงิน",
    search: "ค้นหา",
    save: "บันทึก",
    back: "กลับ",
    new: "สร้าง",
    status: "สถานะ",
    download: "ดาวน์โหลด",
    downloadall: "ดาวน์โหลดทั้งหมด",
    product_search: "ค้นหาสินค้า",
    welcome: "ยินดีต้อนรับ",
    myprofile: "ข้อมูลส่วนตัว",
    changepassword: "เปลี่ยนรหัสผ่าน",
    // สวิตช์ภาษาในเมนูผู้ใช้ (spec 2026-10-06 bo-language-toggle-user-menu L4) — คู่กับอีกไฟล์
    // ฟอร์มบันทึกข้อมูล — spec 2026-10-07-bo-form-draft-clear-design.md §3 F3
    form_draft: {
        clear: "ล้างฟอร์ม",
        clear_confirm_title: "ล้างข้อมูลในฟอร์ม?",
        clear_confirm_text: "ข้อมูลที่กรอกไว้ทั้งหมดในหน้านี้จะหายไป",
        cleared: "ล้างฟอร์มแล้ว",
    },
    // Shopee cancel reconcile §11 F2/F3 (BO orders page, admin)
    shopee_census: {
        btn_check: "ตรวจสอบกับ Shopee",
        hint: "ถาม Shopee ถึงออเดอร์ที่ BO ยกเลิกหรือมีคำขอยกเลิก ตามวันที่สร้างในช่วงข้างบน",
        checking: "กำลังถาม Shopee … (ช่วง 7 วัน ≈ 15 วินาที)",
        range_missing: "เลือกช่วงวันที่ก่อนตรวจสอบกับ Shopee",
        range_too_long_title: "ช่วงวันที่ยาวเกินไป",
        range_too_long_text: "ตรวจสอบกับ Shopee ได้ครั้งละไม่เกิน {max} วัน (ตอนนี้ {days} วัน)",
        load_error: "ตรวจสอบกับ Shopee ไม่สำเร็จ",
        title: "ผลตรวจสอบกับ Shopee {from} – {to}",
        total: "ตรวจ {n} รายการ",
        reopen: "ผลตรวจ Shopee ล่าสุด",
        show_all: "แสดงทั้งหมด",
        empty: "ไม่มีรายการที่ต้องดู",
        empty_all: "ไม่มีออเดอร์ในช่วงนี้",
        not_on_page: "ออเดอร์ #{id} ไม่อยู่ในหน้ารายการตอนนี้",
        col_order: "เลขออเดอร์",
        col_bo_status: "สถานะ BO",
        col_platform_status_bo: "Shopee ใน BO",
        col_platform_status_now: "Shopee ตอนนี้",
        col_packing: "แพ็ค",
        col_cancel_by: "ผู้ยกเลิก",
        col_class: "ผลตรวจ",
        cancel_by_staff: "พนักงาน BO #{id}",
        download_csv: "ดาวน์โหลด CSV",
        csv_failed: "ดาวน์โหลด CSV ไม่สำเร็จ",
        selected_n: "เลือก {n} รายการ",
        repair_dry: "ซ่อมที่เลือก (ตรวจสอบก่อน)",
        repair_too_many: "ซ่อมได้ครั้งละไม่เกิน {max} รายการ",
        dry_title: "ผลตรวจสอบก่อนซ่อม (ยังไม่เปลี่ยนข้อมูล)",
        done_title: "ผลการซ่อม",
        will_apply: "จะซ่อม {n} รายการ",
        applied_n: "ซ่อมแล้ว {n} รายการ",
        skipped_n: "ข้าม {n} รายการ",
        nothing_to_apply: "ไม่มีรายการที่ซ่อมได้",
        repair_confirm_btn: "ยืนยันซ่อม {n} รายการ",
        repair_confirm_title: "ยืนยันซ่อม {n} รายการ?",
        repair_confirm_text: "สถานะใน BO จะเปลี่ยนตาม Shopee ตอนนี้ และไม่มีปุ่มย้อนกลับ",
        apply_error: "ซ่อมไม่สำเร็จ",
        back: "กลับไปที่ผลตรวจ",
        close: "ปิด",
        action_uncancel: "ปลดยกเลิก",
        action_cancel: "ยกเลิกตาม Shopee",
        action_platform_status_only: "อัปเดตสถานะ Shopee",
        action_other: "อื่น ๆ",
        class_ok_cancelled: "ตรงกัน (ยกเลิก)",
        class_ok_live: "ตรงกัน",
        class_stale_cancel_live: "BO ยกเลิกแต่ Shopee เดินต่อ",
        class_stale_cancel_live_staff: "BO ยกเลิกโดยพนักงานแต่ Shopee เดินต่อ",
        class_pending_request: "คำขอยกเลิกค้าง",
        class_pending_request_bo_cancelled: "คำขอยกเลิกค้าง (BO ยกเลิกแล้ว)",
        class_missing_cancel: "Shopee ยกเลิกแต่ BO ไม่รู้",
        class_unpaid_or_gone: "ไม่พบ-ยังไม่ชำระ",
        class_other: "อื่น ๆ",
        class_fetch_error: "ดึงไม่ได้",
        skip_skipped_packing: "เข้ารอบแพ็คแล้ว ต้องตรวจเอง",
        skip_skipped_return_episode: "มีประวัติตีกลับ/คืนสินค้า",
        skip_skipped_shopee_cancelled_before: "Shopee เคยยกเลิกออเดอร์นี้แล้ว",
        skip_skipped_row_changed: "ข้อมูลเปลี่ยนระหว่างซ่อม ให้ตรวจใหม่",
        skip_skipped_cancel_not_by_platform: "ยกเลิกโดยพนักงานหรือแหล่งอื่น ไม่ซ่อมอัตโนมัติ",
        skip_skipped_platform_cancel_already_recorded: "บันทึกการยกเลิกจาก Shopee ไว้แล้ว",
        skip_not_found: "ไม่พบออเดอร์",
        skip_fetch_error: "ถาม Shopee ไม่สำเร็จ",
        skip_internal_error: "ระบบขัดข้อง",
        skip_now_class: "ตอนนี้เป็น: {cls}",
        skip_unknown: "ข้าม ({reason})",
    },
    // /wms/product เปิด/ปิดการใช้งานสินค้า WMS — spec 2026-10-07-wms-product-active-design.md §3 F4 · bo-fn #416 — คู่กับ en.js
    wms_product_active: {
        active_filter: "สถานะการใช้งาน",
        active: "กำลังใช้งาน",
        inactive: "ปิดใช้งาน",
        active_all: "ทั้งหมด",
        col_active: "ใช้งาน",
        inactive_badge: "ปิดใช้งาน",
        menu: "เมนู",
        confirm_disable: "ปิดการใช้งาน {name}?",
        confirm_disable_text: "สินค้าจะหายจากทุกหน้าคลัง/แพ็ค (ประวัติยังอยู่)",
        confirm_enable: "เปิดการใช้งาน {name}?",
        confirm_enable_text: "สินค้าจะกลับมาแสดงในทุกหน้าคลัง/แพ็ค",
        stock_left: "คงเหลือในคลัง {n} ชิ้น",
        toggled_on: "เปิดการใช้งานแล้ว",
        toggled_off: "ปิดการใช้งานแล้ว",
        toggle_failed: "เปลี่ยนสถานะการใช้งานไม่สำเร็จ",
        scan_inactive: "สินค้านี้ปิดใช้งานแล้ว",
        column_missing: "ระบบยังไม่รองรับการปิดใช้งานสินค้า (ยังไม่ได้รัน SQL เพิ่มคอลัมน์ is_active) กรุณาแจ้งผู้ดูแลระบบ",
        // #424 §8 F8: suffix on an order-entry SKU mapped to a disabled WMS product
        order_option_disabled: "ปิดใช้งาน",
    },
    // รหัส Msg จาก API (bo-api #834) ที่หน้าเดิมแปลด้วย $t(err.response.data.Msg) — ชี้ไปที่ข้อความด้านบน
    WMS_PRODUCT_INACTIVE: "@:wms_product_active.scan_inactive",
    WMS_PRODUCT_ACTIVE_COLUMN_MISSING: "@:wms_product_active.column_missing",
    // รหัส Msg จาก API: DELETE /wms/inventory/:id ปฏิเสธแถวที่ balance <> 0 (spec 2026-10-07-wms-inventory-delete-guard)
    WMS_INVENTORY_BALANCE_NOT_ZERO: "ลบไม่ได้ แถวนี้ยังมียอดคงเหลือ ต้องเบิกออกหรือย้ายก่อน",
    language: {
        toggle_label: "เปลี่ยนภาษา",
    },
    menu_pref: {
        title: "ตั้งค่าเมนู",
        list_title: "เมนูในแถบด้านข้าง",
        description: "เลือกเมนูที่ต้องการให้แสดงในแถบด้านข้าง เมนูที่ปักหมุดจะแสดงเสมอ",
        col_menu: "เมนู",
        col_show: "แสดง",
        col_pin: "ปักหมุด",
        note_root_only: "การซ่อน/ปักหมุดทำได้ระดับเมนูหลักเท่านั้น เมนูย่อยจะแสดงตามเมนูหลัก",
        empty: "ไม่มีเมนูที่แสดงได้",
        saved: "บันทึกการตั้งค่าเมนูสำเร็จ",
        save_failed: "บันทึกการตั้งค่าเมนูไม่สำเร็จ",
        product_wait_ship: "สินค้ารอส่ง",
        express: "ขนส่งด่วน",
        express_list: "รายการขนส่งด่วน",
        express_form: "สร้างขนส่งด่วน"
    },
    page_notfound: "ขออภัย ไม่พบหน้าที่คุณต้องการ",
    page_notfound_desc:
        "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
    actions: "เมนู",
    data: "ข้อมูล",
    to: "ถึง",
    of: "จาก",
    row_select: "ข้อมูลที่ถูกเลือก",
    yes: "ใช่",
    no: "ไม่ใช่",
    ok: "ตกลง",
    cancel: "ยกเลิก",
	confirm_cancel: "ยืนยันการยกเลิก",
    upload_file: "เพิ่มไฟล์",
    bg_admin: "ตั้งค่าผู้ดูแลระบบ",
    comportal: "ตั้งค่าผู้ใช้งาน",
    add: "เพิ่ม",
    action: "จัดการ",
    amount: "จำนวนเงิน",
    note: "หมายเหตุ",
    select: "เลือก",
    date: "วันที่",
    date_type: "ประเภทวันที่",
    created_date: "วันที่สร้าง",
    created_at: "สร้างเมื่อ",
    created_by: "สร้างโดย",
    total: "ทั้งหมด",
    close: "ปิด",
    edit: "แก้ไข",
    delete: "ลบ",
    birthday: "วันเกิด",
    birthday_set: "ระบุวันเกิด",
    birthday_clear: "ล้างวันเกิด",
    birthday_modal_title: "เลือกวันเกิด (พ.ศ.)",
    birthday_modal_hint: "วัน เดือน ปี (ปีพุทธศักราช) — ระบบจะบันทึกเป็นปี ค.ศ.",
    birthday_invalid: "วันเกิดไม่ถูกต้อง",
    day: "วัน",
    month: "เดือน",
    year_be: "ปี (พ.ศ.)",
    please_select: "กรุณาเลือก",
	please_select_payment_method_type:"กรุณาเลือกประเภทการชำระเงิน",
	please_select_sale_channel_type:"กรุณาเลือกประเภทช่องทางการขาย",
	please_select_shipping_provider_type:"กรุณาเลือกบริษัทขนส่ง",
    create: "สร้าง",
    confirm: "ยืนยัน",
    packing_regen_tracking: "สร้างเลขแทร็กกิ้งใหม่",
    packing_regen_tracking_confirm: "ยืนยันสร้างเลขแทร็กกิ้งสำหรับออเดอร์ที่ยังไม่มีเลข ในรอบแพ็ค",
    packing_regen_tracking_success: "สร้างเลขแทร็กกิ้งเรียบร้อย",
    packing_regen_tracking_result: "สร้างเลขแทร็กกิ้งให้ {count} ออเดอร์ที่ยังไม่มีเลข",
    create_success: "สร้างข้อมูลสำเร็จ",
    delete_confirm: "ยืนยันการลบข้อมูล",
    delete_confirm_text: "คุณต้องการลบข้อมูล ",
    delete_confirm_question: "คุณต้องการลบข้อมูล ",
    delete_success: "ลบข้อมูลสำเร็จ",
    delete_fail: "ลบข้อมูลไม่สำเร็จ",
    edit_success: "แก้ไขข้อมูลสำเร็จ",
    edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",
    update_success: "แก้ไขข้อมูลสำเร็จ",
    update_failed: "แก้ไขข้อมูลไม่สำเร็จ",
    phone_invalid: "เบอร์โทรไม่ถูกต้อง (10 หลัก ขึ้นต้นด้วย 0)",
    update_fail: "แก้ไขข้อมูลไม่สำเร็จ",
    enabled: "เปิดใช้งาน",
    disabled: "ปิดใช้งาน",
    refresh: "รีเฟรช",

    // Inventory
    inventory_transfer: "เบิกสินค้าจากคลังหลัก",
    inventory_transfer_to_line: "เบิกสินค้าเข้าสายแพ็ค",
    inventory_out: "เบิกสินค้า",
    inventory_in: "นำเข้าสินค้า",

	phone: "เบอร์โทรศัพท์",

    // =================================================================
    // WMS Module
    // =================================================================
    wms: {
        name: "ระบบคลังสินค้า",
        menu: {
            inventory: "คลังสินค้า",
            inventory_dashboard: "Dashboard",
            inventory_list: "รายการสินค้าคงเหลือ",
            inventory_list_detail: "รายการสินค้าคงเหลือแยกตามคลัง",
			inventory_history_product_list: "ประวัติรายการสินค้า",
			inventory_history_storage_list: "รายการสรุปคลังสินค้า",
            inventory_history: "ประวัติคลังสินค้า",
            inventory_summary_packing: "รายงานสรุปยอดการแพ็คสินค้า",
            partner: "บริษัทผู้ผลิต",
            product: "สินค้า",
            product_v2: "สินค้า V2 (Stock Sync)",
            available_product: "สินค้าคงเหลือ",
            storage: "ตำแหน่งจัดเก็บสินค้า",
            promotion: "โปรโมชั่น",
            return_warehouse: "คลังสินค้าตีกลับ",
            // /wms/inventory/transfertoline — ไม่มีเมนูใน sidebar (เข้าจากปุ่มใน
            // ShippingForm.vue / ShippingFormByLine.vue) แต่ route ชี้คีย์นี้มาตลอด
            // จึง breadcrumb/แท็บโชว์ "wms.menu.inventory_to_line" ดิบ ๆ
            // ใช้คำเดียวกับ inventory_transfer_to_line ที่มีอยู่แล้ว
            inventory_to_line: "เบิกสินค้าเข้าสายแพ็ค",
            // #437 รายงานสินค้าที่ส่งแล้วแต่ยังไม่ตัดสต็อก
            shipped_no_deduct: "สินค้าที่ส่งแล้วแต่ยังไม่ตัดสต็อก",
        },

        return_move_title: "ย้ายไปห้องแพ็คขายปลีก",
        return_move_qty: "จำนวนที่ต้องการย้าย",
        return_available: "คงเหลือในคลังตีกลับ",
        return_move_success: "ย้ายไปห้องแพ็คขายปลีกแล้ว",
        return_move_exceed: "จำนวนเกินยอดคงเหลือ",
        return_move_main_button: "นำสินค้าดีเข้าคลัง",
        return_move_main_title: "นำสินค้าดีเข้าคลัง",
        return_move_main_src: "คลังต้นทาง",
        return_move_main_dest: "คลังปลายทาง",
        return_move_main_notice: "ยอดที่แสดงคือยอดคงเหลือทั้ง{storage} ณ ขณะนี้ ไม่ได้จำกัดตามช่วงวันที่ที่กรองไว้ในรายงาน จึงมักไม่ตรงกับตัวเลขในตารางด้านหลัง",
        return_move_main_total: "รวมทั้งหมด",
        return_move_main_selected: "เลือกแล้ว",
        return_move_main_empty: "ไม่มีสินค้าคงเหลือในคลังตีกลับ",
        return_move_main_confirm: "ยืนยันการนำเข้าคลังปลายทาง",
        return_move_main_success: "นำสินค้าเข้าคลังปลายทางแล้ว",
        return_move_main_none: "ไม่มีสินค้าถูกย้าย — ยอดคงเหลือของรายการที่เลือกถูกย้ายไปก่อนหน้านี้แล้ว",
        return_move_main_result_title: "ผลการนำสินค้าเข้าคลัง",
        return_move_main_result_note: "จำนวนด้านล่างคือจำนวนที่ระบบย้ายจริง ซึ่งอาจต่างจากที่แสดงตอนเลือก ถ้ายอดคงเหลือเปลี่ยนระหว่างนั้น",
        return_move_main_moved: "จำนวนที่ย้ายจริง",
        return_move_main_moved_ok: "ย้ายแล้ว",
        return_move_main_skipped: "ข้าม — ยอดคงเหลือเป็น 0 แล้ว",
        return_move_main_select_all: "ติ๊กทั้งหมด",
        return_move_main_clear_all: "ยกเลิกติ๊กทั้งหมด",
        return_move_main_all_selected_hint: "ติ๊กครบทุกรายการแล้ว จึงซ่อนการติ๊กรายสินค้าไว้ กด \"ยกเลิกติ๊กทั้งหมด\" เพื่อกลับมาเลือกทีละรายการ",
		history_type: "ประเภท",
        created_at: "วันที่",
        staff: "พนักงาน",
        bill_number: "หมายเลขบิล",
        bill_image: "รูปภาพบิล",
        threshold: "จำนวนต่ำสุดที่สามารถสั่งซื้อได้",

        inventory_main: "คลังสินค้าหลัก",
        inventory_src: "คลังสินค้าต้นทาง",
        inventory_dst: "คลังสินค้าปลายทาง",
        inventoryin_list: "รายการสินค้านำเข้า",
        inventoryout_list: "รายการเบิกสินค้า",
        inventorytransfer_list: "รายการย้ายสินค้า",
        // Prodcut
        product_name: "ชื่อสินค้า",
        partner: "บริษัทผู้ผลิต",
        package_name: "หน่วยสินค้า",
        barcode: "Barcode",
        product_width: "กว้าง",
        product_height: "ยาว",
        product_depth: "สูง",
        product_weight: "น้ำหนัก",
		product_pn:"SKU",

        // Partner
        company_name: "ชื่อบริษัท",
        address: "ที่อยู่",
        contact_name: "ชื่อผู้ติดต่อ",
        contact_tel: "เบอร์โทรผู้ติดต่อ",

        // Inventory
        inventory_in: "เพิ่ม",
        inventory_out: "เบิก",

        amount: "จำนวน",
        cost: "ราคา",
        note: "หมายเหตุ",
        product: "สินค้า",
        product_promotion: "สินค้าและโปรโมชั่น",
        corporate: "บริษัท",
        storage: "ตำแหน่งจัดเก็บสินค้า",
        balance: "คงเหลือ",
        overall_amount: "จำนวนทั้งหมด",
        overall_cost: "มูลค่า",
        taxid: "หมายเลขผู้เสียภาษี",
        tel: "เบอร์โทรศัพท์",
        email: "อีเมล์",
        storage_name: "ชื่อ",
        storage_desc: "คำอธิบาย",
        x: "X",
        y: "Y",

        width: "กว้าง (cm)",
        height: "สูง (cm)",
        depth: "ลึก (cm)",
        weight: "น้ำหนัก (g)",
        cost: "ต้นทุน",
        // ปุ่มบนหน้า /admin/product_platform ที่สั่งคำนวณต้นทุนของทุก SKU ใหม่
        recompute_cost: "คำนวณต้นทุน SKU ใหม่",
        recompute_cost_done: "คำนวณแล้ว {scanned} SKU · อัปเดต {updated} · ไม่รู้ต้นทุน {missing}",
        // skipped: true = API ยังไม่มีคอลัมน์ต้นทุนให้เขียน จึงไม่ได้คำนวณอะไรเลย
        // ห้ามแสดงเป็น "คำนวณแล้ว 0 SKU" เพราะอ่านเหมือนคลังว่าง
        recompute_cost_skipped: "ยังไม่ได้รัน migration ต้นทุน SKU (คอลัมน์ยังไม่มี)",

        // Available Product
        product_id: "รหัสสินค้า",
        stock: "สินค้าในคลัง",
        packing: "กำลังแพ็ค",
        packing_detail: "รายละเอียดที่กำลังแพ็ค",
        packing_total_orders: "จำนวนออเดอร์ทั้งหมด",
        packing_total_quantity: "จำนวนสินค้าทั้งหมด",
        packing_by_platform: "ตามแพลตฟอร์ม",
        packing_by_sale_channel: "ตามช่องทางการขาย",
        packing_order_count: "จำนวนออเดอร์",
        packing_quantity: "จำนวนสินค้า",
        platform: "แพลตฟอร์ม",
        sale_channel: "ช่องทางการขาย",
        stock_sync_status: "ซิงค์สต็อก",
        stock_alarm_status: "แจ้งเตือนสต็อก",
        stock_sync_threshold: "ปรับยอดเป็น 0 เมื่อต่ำกว่าค่าที่กำหนด",
        stock_sync_percentage: "ซิงค์ %",
        stock_alarm_threshold: "แจ้งเตือนเมื่อต่ำกว่าค่าที่กำหนด",
        stock_settings: "ตั้งค่าสต็อก",

        // Packing Order Drill-down
        packing_orders_title: "ออเดอร์ที่กำลังแพ็ค",
        packing_orders_subtitle: "รายการออเดอร์",
        packing_orders_empty: "ไม่มีรายการออเดอร์",
        packing_orders_order_number: "หมายเลขออเดอร์",
        packing_orders_order_id: "Order ID",
        packing_orders_platform_order_id: "Platform Order ID",
        packing_orders_created_at: "วันที่สั่ง",
        packing_orders_recipient: "ผู้รับ",
        packing_orders_status: "สถานะ",
        packing_orders_tracking: "หมายเลขพัสดุ",
        packing_orders_product_qty: "จำนวนสินค้านี้",
        packing_orders_view_order: "ดูออเดอร์",
    },

    // =================================================================
    // Backoffice Module
    // =================================================================

        backoffice: "ระบบจัดการร้านค้า",
        orders: "รายการสั่งซื้อ",
        products: "สินค้า",
        product_random: "สินค้าสุ่ม",
        packings: "การจัดส่ง",
        order_return: "สินค้าตีกลับ",
        payments: "การชำระเงิน",
        reports: "รายงาน",
        customer_information: "ข้อมูลลูกค้า",
        customer: "ลูกค้า",
        platform_connect: "เชื่อมต่อแพลตฟอร์ม",

        product_information: "ข้อมูลสินค้า",

		seller_note:"หมายเหตุ",


        order_form: "สั่งซื้อสินค้า",
        order_status: "สถานะ",
        order_number: "หมายเลขสั่งซื้อ",
        order_user: "พนักงาน",
        order_detail: "รายละเอียดการสั่งซื้อ",
        order_form: "สร้างรายการสั่งซื้อ",
        order_count: "จำนวนรายการสั่งซื้อ",

		order_status_unpaid : "รอชำระเงิน",
		order_status_awaiting_shipment: "รอตัดรอบส่งสินค้า",
		order_status_awaitingcollection : "รอส่งสินค้า",
		order_status_partiallyshipping  : "จัดส่งบางส่วน",
		order_status_awaiting_transit : "รอขนส่งรับพัสดุ",
		order_status_intransit : "กำลังขนส่ง",
		order_status_delivered : "จัดส่งสำเร็จ",
		order_status_completed : "สำเร็จ",
		order_status_claim : "เคลมสินค้า",
		order_status_cancelled : "ยกเลิก",
		order_status_returned : "สินค้าตีกลับ",
		order_status_claimed: "เคลมสินค้า",
        order_status_returning : "อยู่ระหว่างตีกลับ",
        order_status_intransit_completed : "กำลังขนส่ง , สำเร็จ",

        return_in_transit_tab: "กำลังตีกลับ",
        return_started_at: "เริ่มตีกลับเมื่อ",
        return_source: "แหล่งที่มา",
        return_source_spx: "SPX",
        return_source_thaipost: "ไปรษณีย์ไทย",
        return_source_lazada: "Lazada",
        return_source_manual: "กำหนดเอง",
        return_source_unknown: "ไม่ทราบ",
        return_age_days: "ค้างมา {n} วัน",

        // #189 จำลอง fulfillment (staging, MDFStore orders)
        sim_delivered: "จำลอง: จัดส่งสำเร็จ",
        sim_failed: "จำลอง: จัดส่งไม่สำเร็จ",
        sim_returned: "จำลอง: สินค้าตีกลับ",
        sim_confirm_title: "ยืนยันการจำลองสถานะ (staging)?",
        sim_success: "จำลองสถานะสำเร็จ",
        platform_mdfstore: "MDFStore",

		payment_slip : "สลิปการชำระเงิน",
		payment_channel : "ช่องทางการชำระเงิน",
		payment_method : "ช่องทางการชำระเงิน",
		payment_check : "ตรวจสอบการชำระเงิน",

		platform : "Platform",
        sale_channel: "ช่องทางการขาย",
        sale_channel_type: "ประเภทช่องทางการขาย",
		recipient_name: "ชื่อผู้รับ",
		recipent_address: "ที่อยู่ผู้รับ",
		recipent_district: "ตำบล / แขวง",
		recipent_city: "อำเภอ / เขต",
		recipent_province: "จังหวัด",
		recipent_zipcode: "รหัสไปรษณีย์",
		recipient_phone: "เบอร์โทรผู้รับ",

		report_by_team: "รายงานตามทีมขาย",
		report_by_sale_channel: "รายงานตามช่องทางการขาย",
		report_by_user: "รายงานตามพนักงานขาย",
		report_by_product: "รายงานตามสินค้า",
		report_by_user_product: "รายงานตามพนักงานขายและสินค้า",
		report_by_sale_channel_and_product: "รายงานต้นทุน / กำไรตามสินค้า",
		report_wms_summary:"รายงานสรุปจำนวนสินค้า",
		report_wms_product_summary:"รายงานสรุปจำนวนสินค้าแยกตามสินค้าและโปรโมชั่น",
		report_wms_field_summary:"รายงานสรุปจำนวนสินค้าแยกตามประเภทข้อมูล",
		report_commission:"รายงานค่าคอมมิชชั่นตัวแทน",
		report_order_return:"รายงานสินค้าตีกลับ",

		// รายงานต้นทุน (#265 · bo-api #594 §7.4)
		report_product_cost: "รายงานต้นทุน",
		cost_report: {
			view_platform: "ตาม Platform",
			view_channel: "ตามช่องทางการขาย",
			unknown_channel: "ไม่ระบุ",
			unknown_product: "ไม่ทราบสินค้า",
			unknown_sku: "ไม่ทราบ SKU",
			orders: "จำนวนออเดอร์",
			qty: "จำนวนชิ้น",
			sales: "ยอดขาย",
			cost: "ต้นทุน",
			margin: "กำไร",
			margin_pct: "% กำไร",
			expense: "รายจ่าย",
			net_profit: "กำไรสุทธิ",
			expense_note: "รายจ่ายจากบัญชีที่ผูกกับแพลตฟอร์ม (ไม่รวมรายจ่ายที่ไม่ได้ระบุแพลตฟอร์ม)",
			missing_cost_sku: "SKU ที่ไม่รู้ต้นทุน",
			cost_missing: "ต้นทุนไม่ครบ",
			unit_price: "ราคาต่อหน่วย",
			unit_cost: "ต้นทุนต่อหน่วย",
			export: "ส่งออก Excel",
			too_many_lines: "ข้อมูลเกิน 50,000 บรรทัด กรุณาลดช่วงวันที่",
			all: "ทั้งหมด",
			// keys beyond §7.4 — column headers and the two disclaimers §11.5 /
			// §11.8 tell us to print on the screen itself
			name: "ชื่อ",
			sku_code: "รหัส SKU",
			seller_sku: "Seller SKU",
			platform_product_id: "รหัสสินค้าบนแพลตฟอร์ม",
			search: "ค้นหา",
			// ข้อความใน modal ที่บังหน้าจอระหว่างรอผลรายงาน / ไฟล์ส่งออก
			loading: "กำลังโหลดข้อมูล…",
			// §13.7 — รอบ 2 กลับด้านข้อความเดิม ต้นทุนเป็น snapshot ไม่ใช่ค่าปัจจุบันแล้ว
			cost_note: "ต้นทุนเป็นค่าที่บันทึกไว้ ณ ตอนสร้างออเดอร์ · ถ้าแก้ต้นทุนแล้วต้องการให้รายงานย้อนหลังเปลี่ยนตาม ให้กด \"คำนวณต้นทุนออเดอร์ใหม่\"",
			sales_note: "ยอดขาย = ราคาต่อหน่วย × จำนวน ของรายการสินค้า (ไม่รวมส่วนลดระดับออเดอร์และค่าส่ง)",
			cost_columns_missing: "ยังไม่ได้ติดตั้งคอลัมน์ต้นทุนของออเดอร์ (sql/2026-09-23-order-item-cost-snapshot.sql) ตัวเลขต้นทุนทั้งหมดเป็น 0",
			// §13.7 — ปุ่มคำนวณต้นทุนออเดอร์ใหม่ + ป้ายของบรรทัดที่ไม่มี SKU
			backfill: "คำนวณต้นทุนออเดอร์ใหม่ (ช่วงที่เลือก)",
			backfill_confirm: "คำนวณต้นทุนของออเดอร์ {from} ถึง {to} ใหม่จากต้นทุนปัจจุบัน? รายงานย้อนหลังในช่วงนี้จะเปลี่ยนตาม",
			backfill_done: "อ่าน {scanned} บรรทัด · อัปเดต {updated} · ต้นทุนไม่ครบ {missing} · หาสูตรไม่ได้ {unresolved}",
			dynamic_sku_note: "บรรทัดที่ไม่มี SKU (ออเดอร์หลังบ้าน/MT) รวมเป็นแถวเดียว ดูรายบรรทัดได้ในไฟล์ Excel แผ่น orders",
			sku_from_order: "SKU จากออเดอร์",
			yes: "ใช่",
			// errors — คีย์ตรงกับรหัสที่ API ส่งมาใน Msg (bo-api #594 §6.1)
			// ผู้ใช้ต้องไม่เห็นรหัสดิบ เช่น "cost_report_range_too_wide"
			errors: {
				cost_report_bad_view: "ตัวเลือกมุมมองไม่ถูกต้อง กรุณาเลือก Platform หรือช่องทางการขาย",
				// BE ตอบ 400 รหัสนี้เมื่อ time_from/time_to หายไปหรือแปลงไม่ได้
				// และ rangeErrorCode ฝั่ง FE ก็ใช้คีย์เดียวกัน ข้อความจึงเป็นประโยคเดียว
				cost_report_bad_range: "ช่วงวันที่ไม่ถูกต้อง",
				// 7 ไม่ใช่ 92 ของ API — หน้านี้จำกัดช่วงไว้ 7 วัน (COST_REPORT_MAX_DAYS)
			// และปฏิเสธช่วงที่กว้างกว่านั้นตั้งแต่ก่อนยิงคำขอ
			cost_report_range_too_wide: "ช่วงวันที่เกิน 7 วัน",
				cost_report_too_many_lines: "ข้อมูลเกิน 50,000 บรรทัด กรุณาลดช่วงวันที่",
				product_cost_forbidden: "คุณไม่มีสิทธิ์ดูข้อมูลต้นทุน",
				unknown: "ดึงรายงานต้นทุนไม่สำเร็จ"
			}
		},

		time_from: "เริ่มต้น",
		time_to: "สิ้นสุด",
		valid_from: "วันเริ่มต้นใช้งาน",
		valid_to: "วันสิ้นสุดใช้งาน",
		all: "ทั้งหมด",
		type: "ประเภท",
		bank: "ธนาคาร",
		bank_account: "เลขที่บัญชี",
		bank_branch: "สาขา",
		detail: "รายละเอียด",
		product: "สินค้า",
		price: "ราคา",
		image: "รูปภาพ",
		tag: "Tags",
		quantity: "จำนวน",
		product_form:"จัดการสินค้า",
		product_code:"รหัสสินค้า",
		product_category:"หมวดหมู่สินค้า",
		is_comboset: "เป็นชุดสินค้า",
		visibility: "การแสดงผล",
		visibility_all: "แสดงทั้งหมด",
		visibility_company_only: "เฉพาะบริษัท",
		visibility_agent_only: "เฉพาะตัวแทน",
		price_tiers: "ราคาตามจำนวน",
		price_tiers_hint: "ตั้งราคาพิเศษเมื่อสั่งซื้อจำนวนมาก (ไม่ใช้กับผู้ใช้ตัวแทน)",
		tier_min_qty: "จำนวนขั้นต่ำ",
		tier_price: "ราคา/ชิ้น",
		add_tier: "เพิ่ม Tier",
		bulk_discount: "ส่วนลดจำนวน",
		status_required: "กรุณาเลือกสถานะ",
		variable_duplicate: "ชื่อ Variable ซ้ำกัน",
		option_duplicate: "ชื่อ Option ซ้ำกัน",
		tier_min_qty_invalid: "จำนวนขั้นต่ำต้องเป็นจำนวนเต็มและมากกว่า 0",
		tier_price_invalid: "ราคาต้องมากกว่า 0",
		tier_min_qty_duplicate: "จำนวนขั้นต่ำซ้ำกับ Tier อื่น",
		app_section: "แอป (หน้าขายสินค้า)",
		app_enable: "แสดงในแอป",
		app_tag: "แท็กแอป",
		app_discount: "ส่วนลดแอป (บาท)",
		app_discount_start: "เริ่มลดราคา",
		app_discount_end: "สิ้นสุดลดราคา",
		// #17 ตัวกรอง/สถานะในหน้า Admin/ProductTables.vue
		product_status_active: "ใช้งาน",
		product_status_inactive: "ไม่ใช้งาน",
		app_filter_on: "ขายในแอป",
		app_filter_off: "ไม่ขายในแอป",
		team: "ทีมขาย",
		department: "แผนก",
		fname: "ชื่อ",
		lname: "นามสกุล",
		nick_name: "ชื่อเล่น",
		password_old: "รหัสผ่านเดิม",
		password: "รหัสผ่าน",
		password_confirm: "ยืนยันรหัสผ่าน",
		password_not_match: "รหัสผ่านไม่ตรงกัน",
		packing_number: "หมายเลขตัดรอบแพ็ค",
		packing_user: "ผู้ตัดรอบ",
		packing_date: "วันที่แพ็ค",
		line_packing: "สายที่แพ็ค",
		please_select_sale_channel: "กรุณาเลือกช่องทางการขาย",
		please_select_payment_method: "กรุณาเลือกช่องทางการชำระเงิน",
		payment_success: "ชำระเงินถูกต้อง",
		payment_fail: "ชำระเงินไม่ถูกต้อง",
		shipping: "ส่งสินค้า",
		shipping_provider: "บริษัทขนส่ง",
		shipping_provider_special: "ขนส่งพิเศษ (ฝากรถบริษัท)",
		shipping_provider_special_hint: "พัสดุไปกับรถส่งของบริษัท ไม่มีเลขแทร็กกิ้งของขนส่งภายนอก",
		barcode: "บาร์โค้ด",
		scanbarcode: "คลิ๊กเพื่อสแกน Barcode",
		packing_all_scanned: "สินค้าครบแล้ว",
		barcode_type: "ประเภท Barcode",
		barcode_type_tracking: "Tracking Number",
		barcode_type_platform_order_id: "Platform Order ID",
        product_pn: "รหัสสินค้า",
		tracking_number:"หมายเลขพัสดุ",
		order_information:"ข้อมูลรายการสั่งซื้อ",
		product_image:"รูปภาพสินค้า",
		product_name:"ชื่อสินค้า",
		product_pickup:"จำนวนสินค้า",
		cancel_confirm:"ยืนยันการยกเลิกรายการสั่งซื้อ",
		cancel_confirm_question:"คุณต้องการยกเลิกรายการสั่งซื้อหมายเลข",
		cancel_order_success: "ยกเลิกรายการสั่งซื้อเรียบร้อยแล้ว",
		please_select_cancel_reason: "กรุณาเลือกประเภทเหตุผลที่ยกเลิก",
		please_input_cancel_reason: "กรุณากรอกเหตุผลที่ยกเลิก",

		shipping_return: "คืนสินค้า",


		user_group:"กลุ่มผู้่ใช้งาน",


		// Report
		order_amount :"จำนวนรายการสั่งซื้อ",
		payment_amount:"รวมจำนวนเงิน",
		payment_amount_net:"รวมจำนวนเงิน (สุทธิ)",
		product_amount:"จำนวนสินค้า",
		discount:"ส่วนลด",
		payment_method_type:"ประเภทการชำระเงิน",
		sort_type:"การเรียงลำดับ",
		change_tracking_success :"เปลี่ยนหมายเลขพัสดุสำเร็จ",
		change_shipping_success: "เปลี่ยนขนส่งสำเร็จ",
		price_per_unit:"ราคาต่อหน่วย",
		platform_order_id:"หมายเลขสั่งซื้อ Platform (OrderID)",
		processing:"กำลังประมวลผล...",
		packing_order_back_day :"ตัดรอบย้อนหลัง (วัน)",
        product_promotion: "สินค้าและโปรโมชั่น",
		coupon: "คูปอง",
		coupon_discount_type : "ประเภทส่วนลด",
		coupon_amount_mininum : "จำนวนขั้นต่ำ",
		coupon_discount_value : "ส่วนลด",
		date : "วันที่",
		product_name : "ชื่อสินค้า",
		amount_packing : "จำนวนที่แพ็ค",
		per_each_cost : "ราคาต้นทุนต่อหน่วย",
		per_each_promotion_price : "ราคาขายต่อหน่วย",
		sum_cost : "ต้นทุนรวม",
		sum_sale_price : "ยอดขายรวม",
		sum_shipping_cost : "ค่าขนส่งรวม",
		sale_amount : "จำนวนรายการขาย",
		profit : "กำไร",
		sale_channel_name : "ช่องทางการขาย",
		shipping_cost : "ต้นทุนค่าขนส่ง",
		return_success : "ตีกลับสินค้าสำเร็จ",
		return_fail : "ตีกลับสินค้าผิดพลาด",
		shipping_quantity : "จำนวนสินค้าที่จัดส่ง",
		return_good_quantity: "สินค้าดี",
		return_broken_quantity: "ชำรุด",
		return_lost_quantity: "สูญหาย",
		return_other_reson_quantity: "อื่นๆ",
        po_form: "ใบสั่งซื้อ",
        running_from: "หมายเลขเริ่มต้น",
        running_to: "หมายเลขสิ้นสุด",

    member: {
        line_user_id: "LINE User ID",
        birthday: "วันเกิด",
        sex: "เพศ",
        total_spending: "ยอดซื้อรวม",
        address: "ที่อยู่",
        province: "จังหวัด",
        district: "อำเภอ",
        subdistrict: "ตำบล",
        postcode: "รหัสไปรษณีย์",
        coupons: "คูปอง",
        coupon_code: "รหัสคูปอง",
        coupon_status: "สถานะ",
        used: "ใช้แล้ว",
        unused: "ยังไม่ใช้",
        created_at: "วันที่สร้าง",
        used_at: "วันที่ใช้",
        no_coupons: "ไม่พบคูปอง",
        error_loading_coupons: "เกิดข้อผิดพลาดในการโหลดคูปอง"
    },

    webcam_recording: "การบันทึกจากเว็บแคม",
    waiting_for_packaging: "รอแพ็ค",
    camera_settings: "ตั้งค่ากล้อง",
    select_camera: "เลือกกล้อง",
    connect_camera: "เชื่อมต่อกล้อง",
    camera_preview: "ตัวอย่างกล้อง",
    no_camera_found: "ไม่พบกล้อง",
    camera_not_supported: "เบราว์เซอร์ของคุณไม่รองรับการใช้งานเว็บแคม",
    start_recording: "เริ่มบันทึก",
    stop_recording: "หยุดบันทึก",
    recording_in_progress: "กำลังบันทึก...",
    recording_stopped: "หยุดบันทึกแล้ว",
    upload_recording: "อัพโหลดการบันทึก",
    recording_uploaded: "อัพโหลดการบันทึกสำเร็จ",
    error_uploading_recording: "เกิดข้อผิดพลาดในการอัพโหลดการบันทึก",
    no_recording_available: "ไม่มีการบันทึกที่สามารถใช้งานได้",
    invalid_file_type: "ประเภทไฟล์ไม่ถูกต้อง",
    file_too_large: "ไฟล์มีขนาดใหญ่เกินไป",
    recording_duration: "ระยะเวลาการบันทึก",
    max_recording_duration: "ระยะเวลาการบันทึกสูงสุดคือ 5 นาที",
    recording_timer: "ตัวจับเวลา",
    start_timer: "เริ่มจับเวลา",
    stop_timer: "หยุดจับเวลา",
    reset_timer: "รีเซ็ตตัวจับเวลา",
    camera_device: "อุปกรณ์กล้อง",
    video_quality: "คุณภาพวิดีโอ",

    // =================================================================
    // Platform Statement Module
    // =================================================================
    platform_statement: {
        export_fail: "ส่งออกไม่สำเร็จ",
        name: "งบการเงิน Platform",
        menu: "งบการเงิน Platform",
        list: "รายการงบการเงิน",
        upload: "อัพโหลดงบการเงิน",
        detail: "รายละเอียดงบการเงิน",
        summary: "รายงานสรุป",

        statement_number: "เลขที่งบการเงิน",
        statement_date: "วันที่งบการเงิน",
        settlement_date: "วันที่โอนเงิน",
        platform: "แพลตฟอร์ม",
        platform_shop_id: "รหัสร้านค้า",

        total_orders: "จำนวนออเดอร์",
        total_sales_amount: "ยอดขายรวม",
        total_platform_fee: "ค่าธรรมเนียม Platform",
        total_commission: "ค่าคอมมิชชั่น",
        total_shipping_fee: "ค่าจัดส่ง",
        total_other_fee: "ค่าใช้จ่ายอื่นๆ",
        net_amount: "ยอดรับสุทธิ",

        platform_order_id: "รหัสออเดอร์ Platform",
        related_order_id: "รหัสออเดอร์ที่เกี่ยวข้อง",
        order_date: "วันที่สั่งซื้อ",
        order_created_time: "เวลาที่สร้างออเดอร์",
        order_settled_time: "เวลาที่ปิดออเดอร์",
        transaction_type: "ประเภทธุรกรรม",
        currency: "สกุลเงิน",
        order_amount: "ยอดสั่งซื้อ",
        total_revenue: "รายได้รวม",

        // Seller Discounts
        subtotal_after_seller_discounts: "ยอดหลังหักส่วนลดผู้ขาย",
        subtotal_before_discounts: "ยอดก่อนหักส่วนลด",
        seller_discounts: "ส่วนลดผู้ขาย",

        // Refunds
        refund_subtotal_after_seller_discounts: "คืนเงินหลังหักส่วนลดผู้ขาย",
        refund_subtotal_before_seller_discounts: "คืนเงินก่อนหักส่วนลดผู้ขาย",
        refund_of_seller_discounts: "คืนส่วนลดผู้ขาย",

        // Fees
        platform_fee: "ค่าธรรมเนียม Platform",
        commission: "คอมมิชชั่น",
        transaction_fee: "ค่าธรรมเนียมการทำธุรกรรม",
        credit_card_installment_fee: "ค่าธรรมเนียมผ่อนบัตรเครดิต",
        payment_fee: "ค่าธรรมเนียมการชำระเงิน",

        // Shipping
        shipping_fee: "ค่าจัดส่ง",
        seller_shipping_fee: "ค่าจัดส่งผู้ขาย",
        actual_shipping_fee: "ค่าจัดส่งจริง",
        platform_shipping_fee_discount: "ส่วนลดค่าจัดส่งจาก Platform",
        customer_shipping_fee: "ค่าจัดส่งลูกค้า",
        refund_customer_shipping_fee: "คืนค่าจัดส่งลูกค้า",
        actual_return_shipping_fee: "ค่าจัดส่งคืนจริง",
        shipping_fee_subsidy: "เงินอุดหนุนค่าจัดส่ง",
        seller_shipping_fee_discount: "ส่วนลดค่าจัดส่งผู้ขาย",

        // Affiliate
        affiliate_commission: "คอมมิชชั่นพันธมิตร",
        affiliate_commission_before_pit: "คอมมิชชั่นพันธมิตรก่อนหักภาษี",
        personal_income_tax_withheld: "ภาษีหัก ณ ที่จ่าย",
        affiliate_partner_commission: "คอมมิชชั่นพาร์ทเนอร์",
        affiliate_shop_ads_commission: "คอมมิชชั่นโฆษณาร้านค้า",
        affiliate_commission_deposit: "เงินฝากคอมมิชชั่นพันธมิตร",
        affiliate_commission_refund: "คืนคอมมิชชั่นพันธมิตร",

        // Service Fees
        sfp_service_fee: "ค่าบริการ SFP",
        live_specials_service_fee: "ค่าบริการ Live Specials",
        voucher_xtra_service_fee: "ค่าบริการ Voucher Xtra",
        eams_program_service_fee: "ค่าบริการโปรแกรม EAMS",
        brand_crazy_deals_flash_sale_fee: "ค่าธรรมเนียม Brand Crazy Deals Flash Sale",
        bonus_cashback_service_fee: "ค่าบริการโบนัสแคชแบ็ค",
        tiktok_paylater_program_fee: "ค่าธรรมเนียมโปรแกรม TikTok PayLater",
        commerce_growth_fee: "ค่าธรรมเนียมการเติบโตทางการค้า",
        infrastructure_fee: "ค่าโครงสร้างพื้นฐาน",
        campaign_resource_fee: "ค่าทรัพยากรแคมเปญ",
        other_fee: "ค่าใช้จ่ายอื่นๆ",

        // Adjustment
        adjustment: "การปรับยอด",
        adjustment_amount: "จำนวนเงินปรับยอด",

        // Customer Payment
        customer_payment: "การชำระเงินของลูกค้า",
        customer_refund: "คืนเงินลูกค้า",

        // Vouchers
        seller_co_funded_voucher_discount: "ส่วนลดคูปองร่วมทุนผู้ขาย",
        refund_of_seller_co_funded_voucher: "คืนคูปองร่วมทุนผู้ขาย",
        platform_discounts: "ส่วนลด Platform",
        refund_of_platform_discounts: "คืนส่วนลด Platform",
        platform_co_funded_voucher_discounts: "ส่วนลดคูปองร่วมทุน Platform",
        refund_of_platform_co_funded_voucher: "คืนคูปองร่วมทุน Platform",

        // Additional Info
        estimated_package_weight: "น้ำหนักพัสดุโดยประมาณ",
        actual_package_weight: "น้ำหนักพัสดุจริง",
        shopping_center_items: "สินค้า Shopping Center",
        customer_bank_for_payment: "ธนาคารลูกค้าสำหรับชำระเงิน",
        product_name: "ชื่อสินค้า",
        quantity: "จำนวน",
        sku: "รหัสสินค้า (SKU)",

        upload_file: "อัพโหลดไฟล์ Excel",
        select_platform: "เลือกแพลตฟอร์ม",
        drag_drop_file: "ลากไฟล์มาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์",
        supported_formats: "รองรับไฟล์: .xlsx, .xls",
        max_file_size: "ขนาดไฟล์สูงสุด: 50MB",

        upload_success: "อัพโหลดงบการเงินสำเร็จ",
        upload_fail: "อัพโหลดงบการเงินไม่สำเร็จ",
        delete_success: "ลบงบการเงินสำเร็จ",
        delete_fail: "ลบงบการเงินไม่สำเร็จ",
        delete_confirm: "ยืนยันการลบงบการเงิน",
        delete_confirm_text: "คุณต้องการลบงบการเงินนี้หรือไม่?",

        export_excel: "ส่งออก Excel",
        export_pdf: "ส่งออก PDF",
        generate_report: "สร้างรายงาน",

        search_by_statement_number: "ค้นหาด้วยเลขที่งบการเงิน",
        filter_by_platform: "กรองตามแพลตฟอร์ม",
        filter_by_date: "กรองตามวันที่",

        uploaded_by: "อัพโหลดโดย",
        uploaded_at: "อัพโหลดเมื่อ",
        uploaded_filename: "ชื่อไฟล์ที่อัพโหลด",

        financial_summary: "สรุปการเงิน",
        order_details: "รายละเอียดออเดอร์",

        type_order: "ออเดอร์",
        type_refund: "คืนเงิน",
        type_adjustment: "ปรับยอด",

        all_platforms: "แพลตฟอร์มทั้งหมด",

        no_data: "ไม่พบข้อมูล",
        loading: "กำลังโหลดข้อมูล...",

        date_range: "ช่วงเวลา",
        from_date: "จากวันที่",
        to_date: "ถึงวันที่",

        total_statements: "จำนวนงบการเงิน",
        total_fees: "ค่าธรรมเนียมรวม",
        fee_percentage: "เปอร์เซ็นต์ค่าธรรมเนียม",

        // Breakdown sections
        revenue_breakdown: "รายละเอียดรายได้",
        fee_breakdown: "รายละเอียดค่าธรรมเนียม",
        adjustment_breakdown: "รายละเอียดการปรับยอด",

        // Fee breakdown items
        total_transaction_fee: "ค่าธรรมเนียมการทำธุรกรรมรวม",
        total_affiliate_commission: "คอมมิชชั่นพันธมิตรรวม",
        total_affiliate_shop_ads: "คอมมิชชั่นโฆษณาร้านค้ารวม",
        total_service_fees: "ค่าบริการรวม",

        // Adjustment breakdown items
        total_adjustment: "การปรับยอดรวม",
        shipping_fee_adjustment: "การปรับยอดค่าจัดส่ง",
        logistics_reimbursement: "เงินชดเชยค่าขนส่ง",
        platform_compensation: "เงินชดเชยจาก Platform",
        platform_penalty: "ค่าปรับจาก Platform",
        other_adjustments: "การปรับยอดอื่นๆ",

        view_details: "ดูรายละเอียด",
        back_to_list: "กลับไปหน้ารายการ",

        lz_premium_package: "Premium Package",
        lz_payment_service_fee: "ค่าบริการชำระเงิน",
        lz_coupon_service_fee: "ค่าคูปองส่งเสริมการขาย",
        lz_commission_fee: "ธรรมเนียมการขายสินค้า",

        sp_adj_shipping_claim : "เคลมค่าจัดส่ง",
        sp_adj_other: "อื่นๆ",
        sp_adj_refund: "การคืนเงิน/คืนสินค้าหลลังคำสั่งซื้อสำเร็จ",
        sp_adj_shipping: "การปรับปรุงเกี่ยวกับขนส่ง",
        sp_shipping : "การจัดส่ง",
    },

    // =================================================================
    // Account Module
    // =================================================================
    account: {
        name: "บัญชี",
        menu: {
            items: "หมวดหมู่",
            records: "รายการบันทึก",
            reports: "รายงาน"
        },

        // Item fields
        item_name: "ชื่อหมวดหมู่",
        create_item: "สร้างหมวดหมู่",
        edit_item: "แก้ไขหมวดหมู่",

        // Tree + platform (2026-10-26)
        parent: "หมวดหมู่แม่",
        parent_none: "ไม่มี (เป็นหมวดหมู่หลัก)",
        parent_hint: "เลือกได้เฉพาะหมวดหมู่ประเภทเดียวกัน",
        platform: "แพลตฟอร์ม",
        platform_none: "ไม่ผูกแพลตฟอร์ม",
        platform_inherited: "สืบทอด",
        platform_inherited_from: "สืบทอดจาก {path}: {platform}",
        platform_hint: "รายจ่ายที่ผูกแพลตฟอร์ม (รวมหมวดหมู่ย่อย) จะถูกนำไปหักในรายงานต้นทุนของแพลตฟอร์มนั้น — รายจ่ายที่ไม่ผูกแพลตฟอร์มจะไม่นำมาคิด",
        platform_income_na: "หมวดหมู่รายรับผูกแพลตฟอร์มไม่ได้",
        add_sub: "เพิ่มหมวดหมู่ย่อย",
        path: "หมวดหมู่ (ตามลำดับชั้น)",
        search_category: "พิมพ์ค้นหาหมวดหมู่ระดับใดก็ได้",

        // Record fields
        create_record: "สร้างรายการ",
        edit_record: "แก้ไขรายการ",
        transaction_date: "วันที่ทำรายการ",
        amount: "จำนวนเงิน",
        reference_no: "เลขที่อ้างอิง",
        created_by: "สร้างโดย",

        // Types
        type: "ประเภท",
        income: "รายรับ",
        expense: "รายจ่าย",
        all: "ทั้งหมด",

        // Status
        active: "เปิดใช้งาน",
        inactive: "ปิดใช้งาน",

        // Common
        category: "หมวดหมู่",
        description: "คำอธิบาย",
        date_range: "ช่วงวันที่",
        date_from: "จากวันที่",
        date_to: "ถึงวันที่",
        transactions: "รายการ",
        user_name: "ผู้ใช้งาน",

        // Reports
        report_by_item: "ตามหมวดหมู่",
        report_by_user: "ตามผู้ใช้งาน",
        total_income: "รายรับรวม",
        total_expense: "รายจ่ายรวม",
        net_amount: "ยอดสุทธิ",
        balance: "ยอดคงเหลือ",
        total_amount: "ยอดรวม",
        count: "จำนวน",
        chart_by_date: "กราฟตามวันที่",
        no_data: "ไม่มีข้อมูล",

        // Batch creation
        batch_create: "สร้างรายการหลายรายการ",
        add_row: "เพิ่มแถว",
        duplicate_row: "คัดลอกแถว",
        total_rows: "จำนวนแถว",
        channel: "ช่องทาง",

        // Errors
        error_required_fields: "กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน",
        error_name_required: "กรุณากรอกชื่อหมวดหมู่",

        // Attachments
        attachments: "เอกสารแนบ",
        attach_file: "แนบไฟล์",
        upload: "อัพโหลด",
        download: "ดาวน์โหลด",
        no_attachments: "ยังไม่มีไฟล์แนบ",
        select_files: "เลือกไฟล์ (สูงสุด 10MB ต่อไฟล์)",
        file_too_large: "ไฟล์เกิน 10MB",
        files_pending: "ไฟล์ที่จะอัพโหลด",
        uploaded_files: "ไฟล์ที่อัพโหลดแล้ว",
        uploading: "กำลังอัพโหลด...",
        view: "ดู"
    },

    // Dashboard Menu
    menu_dashboard: "แดชบอร์ด",
    menu_dashboard_team: "แดชบอร์ดสถานะ",
    menu_dashboard_platform: "แดชบอร์ดแพลตฟอร์ม",

    // Dashboard V2
    dashboard_v2: "แดชบอร์ดแพลตฟอร์ม",
    dashboard_by_platform_channel: "แดชบอร์ดแพลตฟอร์ม",
    by_platform: "ตามแพลตฟอร์ม",
    by_channel: "ตามช่องทาง",
    by_user: "ตามผู้ใช้งาน",
    by_packer: "ตามผู้แพ็คสินค้า",
    top_products: "สินค้าขายดี",
    top_wms_products: "สินค้าคลังขายดี",
    total_orders: "จำนวนออเดอร์ทั้งหมด",
    total_amount: "ยอดรวม",
    total_pay_amount: "ยอดชำระรวม",
    platform: "แพลตฟอร์ม",
    channel: "ช่องทาง",
    user: "ผู้ใช้งาน",
    user_type: "ประเภทผู้ใช้งาน",
    packer: "ผู้แพ็คสินค้า",
    wms_product: "สินค้าคลัง",
    quantity: "จำนวน",
    refresh: "รีเฟรช",
    close: "ปิด",
    show_chart: "แสดงกราฟ",
    tab_by_platform: "ตามแพลตฟอร์ม",
    tab_by_channel: "ตามช่องทาง",
    tab_by_user: "ตามผู้คีย์ออเดอร์",
    tab_top_products: "สินค้าขายดี",
    tab_top_wms: "สินค้าคลังขายดี",
    tab_by_packer: "ตามผู้แพ็ค",
    tab_by_packer_storage: "ตามคลังสินค้าที่แพ็ค",
    chart_by_platform: "ยอดขายตามแพลตฟอร์ม",
    chart_by_channel: "ยอดขายตามช่องทาง",
    chart_by_user: "ยอดขายตามผู้คีย์",
    chart_top_products: "สินค้าขายดี",
    chart_top_wms: "สินค้าคลังขายดี",
    chart_by_packer: "ยอดขายตามผู้แพ็ค",
    count_all: "รวมทั้งหมด",
    export: "ส่งออก",
    // #223 — ปุ่มส่งออกสองปุ่มของ /admin/product · คีย์ระดับราก: export_excel
    // มีอยู่ใน namespace ห้าที่แต่ไม่เคยมีที่ราก จึงไม่ทับของเดิม
    export_excel: "ส่งออก Excel",
    export_json: "ส่งออก JSON",
    export_none: "ไม่มีข้อมูลให้ส่งออก",
    export_done: "ส่งออกแล้ว {count} รายการ",
    export_cell_limit_warning:
        "บางรายการมีข้อมูลมากเกินกว่าที่ Excel เก็บได้ในช่องเดียว จึงถูกละไว้ — กรุณาใช้การส่งออกแบบ JSON สำหรับ: {codes}",
    show_status_columns: "แสดงสถานะ",
    hide_status_columns: "ซ่อนสถานะ",
    save_image: "บันทึกรูปภาพ",
    chart_by_count: "กราฟตามจำนวน",
    chart_by_amount: "กราฟตามยอดเงิน",

    reprocess: {
        title: "ดึงข้อมูล Tracking ใหม่",
        status_filter: "สถานะ",
        platform: "Platform",
        platform_all: "ทั้งหมด",
        created_range: "ช่วงวันที่สร้าง",
        order_id: "หมายเลข Order",
        carrier: "ขนส่ง",
        tracking: "เลขพัสดุ",
        order_status: "สถานะ Order",
        shipping_status: "สถานะขนส่ง",
        updated_at: "อัพเดทล่าสุด",
        action: "การทำงาน",
        refresh: "รีเฟรช",
        refresh_selected: "รีเฟรชที่เลือก",
        refresh_ok: "รีเฟรชสำเร็จ",
        bulk_done: "รีเฟรชเสร็จสิ้น",
        total: "ทั้งหมด",
        process_all: "Process ทั้งหมดที่ค้นหา",
        batch_title: "ความคืบหน้าการรีเฟรช",
        batch_confirm_title: "ยืนยันการ Process ทั้งหมด?",
        batch_confirm_text: "ระบบจะวนรีเฟรชทุก order ที่ตรงตามเงื่อนไขปัจจุบัน — อาจใช้เวลาหลายนาที",
        batch_total: "ทั้งหมด",
        batch_processed: "ดำเนินการแล้ว",
        batch_remaining: "คงเหลือ",
        batch_success: "สำเร็จ",
        batch_fail: "ล้มเหลว",
        batch_running: "กำลังดำเนินการ",
        batch_current: "Order",
        batch_done: "เสร็จสิ้น",
        batch_errors: "Error ล่าสุด (สูงสุด 50 รายการ)",
        track_count_btn: "โควต้า Thaipost",
        track_count_title: "โควต้า Thaipost วันนี้",
        track_count_used: "ใช้ไปแล้ว",
        track_count_remaining: "คงเหลือ",
        track_count_limit: "Limit",
        track_count_date: "วันที่",
        track_count_updated: "อัพเดท",
        track_count_empty: "ยังไม่มีข้อมูล — ต้องเรียก refresh อย่างน้อย 1 ครั้งก่อน",
        fix_status: {
            title: "แก้ไขสถานะ Order",
            subtitle: "เปลี่ยนสถานะ order ที่เลือกหรือตรงตาม filter ปัจจุบันเป็น 'สำเร็จ' (130)",
            scope_selected: "เฉพาะที่เลือก",
            scope_filtered: "ทั้งหมดตาม filter ปัจจุบัน",
            source_statuses_label: "สถานะต้นทางที่อนุญาต",
            preview: "จะเปลี่ยน {count} order เป็น 'สำเร็จ' (130)",
            submit: "ยืนยันและดำเนินการ",
            confirm: "ยืนยันการแก้ไขสถานะ?",
        },
        thaipost_subscribe: {
            title: "Subscribe Tracking (Thaipost)",
            subtitle: "เฉพาะ order ที่ shipping_provider=Thaipost และมี tracking number",
            scope_selected: "เฉพาะที่เลือก",
            scope_filtered: "ทั้งหมดตาม filter ปัจจุบัน",
            preview: "จะ subscribe {count} tracking",
            submit: "ยืนยันและดำเนินการ",
            confirm: "ยืนยันการ subscribe?",
        },
        job: {
            in_progress: "กำลังประมวลผล...",
            finished: "เสร็จสิ้น",
            counters: {
                total: "ทั้งหมด",
                done: "ดำเนินการแล้ว",
                succeeded: "สำเร็จ",
                skipped: "ข้ามไป",
                failed: "ล้มเหลว",
            },
        },
    },
    member_admin: {
        title: "จัดการสมาชิก",
        list_title: "รายชื่อสมาชิก",
        member_type: "ประเภทสมาชิก",
        member_type_all: "ทั้งหมด",
        member_type_company: "บริษัท",
        member_type_agent: "ตัวแทน",
        member_type_platform: "Platform",
        detail: "ข้อมูลสมาชิก",
        search_placeholder: "ค้นหาด้วยชื่อ / เบอร์ / อีเมล",
        fname: "ชื่อ",
        phone: "เบอร์โทร",
        total_spending: "ยอดซื้อสะสม",
        in_transit_spending: "อยู่ระหว่างการส่ง",
        success_spending: "สำเร็จ",
        return_cancel_spending: "ตีกลับ+ยกเลิก",
        create_title: "เพิ่มสมาชิก",
        create_subtitle: "เพิ่มสมาชิกใหม่ด้วยตนเอง เบอร์โทรต้องไม่ซ้ำ",
        first_name: "ชื่อ",
        last_name: "นามสกุล",
        email: "อีเมล",
        birthday: "วันเกิด",
        age: "อายุ",
        sex: "เพศ",
        sex_male: "ชาย",
        sex_female: "หญิง",
        status_not_verify: "ยังไม่ยืนยัน",
        status_normal: "ปกติ",
        status_verified: "ยืนยันแล้ว",
        status_block: "ระงับการใช้งาน",
        status_registered_by_admin: "ลงทะเบียนโดยพนักงาน",
        personal_info: "ข้อมูลส่วนตัว",
        line_user_id: "LINE user ID",
        liff_level: "ระดับ LIFF",
        points_balance: "คะแนนคงเหลือ",
        address: "ที่อยู่",
        address_search: "ตำบล / อำเภอ / จังหวัด / รหัสไปรษณีย์",
        subdistrict: "ตำบล",
        district: "อำเภอ",
        province: "จังหวัด",
        postcode: "รหัสไปรษณีย์",
        required_phone: "กรุณากรอกเบอร์โทร",
        required_fname: "กรุณากรอกชื่อ",
        email_invalid: "รูปแบบอีเมลไม่ถูกต้อง",
        address_required: "กรุณากรอกที่อยู่ให้ครบ (ใช้ช่องค้นหาเพื่อระบุตำบล / อำเภอ / จังหวัด / รหัสไปรษณีย์)",
        export_excel: "ส่งออก Excel",
        export_failed: "ส่งออกไม่สำเร็จ",
        birthday_range: "วันเกิด (วัน/เดือน)",
        birthday_from: "ตั้งแต่ (วัน/เดือน)",
        birthday_to: "ถึง (วัน/เดือน)",
        birthday_md_hint: "MM-DD",
        birthday_clear: "ล้างวันเกิด",
        spending_min: "ยอดสะสมขั้นต่ำ",
        spending_max: "ยอดสะสมสูงสุด",
        spending_unset_hint: "0 = ไม่กรอง",
        spending_clear: "ล้างยอดสะสม",
        order_count: "จำนวนออเดอร์",
        order_count_min: "จำนวนออเดอร์ต่ำสุด",
        order_count_max: "จำนวนออเดอร์สูงสุด",
        order_count_clear: "ล้างจำนวนออเดอร์",
        created_range: "วันที่สมัคร",
        created_from: "ตั้งแต่",
        created_to: "ถึง",
        created_clear: "ล้างวันที่สมัคร",
        address_add: "เพิ่มที่อยู่",
        address_create_title: "เพิ่มที่อยู่จัดส่ง",
        address_edit_title: "แก้ไขที่อยู่จัดส่ง",
        address_search_hint: "เริ่มพิมพ์ ตำบล / อำเภอ / จังหวัด / รหัสไปรษณีย์",
        set_default: "ตั้งเป็นที่อยู่หลัก",
        calc_spending: "คำนวณยอดสะสม",
        calc_spending_title: "คำนวณยอดสะสมของสมาชิก",
        calc_spending_hint: "ระบบจะรวมยอด pay_amount จากออเดอร์ที่ไม่ถูกยกเลิก/ตีกลับ/เคลม ในช่วงเวลาที่เลือก แล้วอัปเดต total_spending ของสมาชิกแต่ละราย",
        calc_spending_run: "เริ่มคำนวณ",
        calc_spending_done: "คำนวณเสร็จสิ้น",
        calc_started: "เริ่มคำนวณแล้ว",
        calc_already_running: "กำลังคำนวณอยู่ — แสดงความคืบหน้า",
        calc_processing_date: "กำลังประมวลผลวันที่",
        calc_matching: "กำลังค้นหาสมาชิกที่ตรงกับเบอร์โทร",
        calc_phones_seen: "เบอร์",
        calc_of: "จาก",
        calc_updating: "กำลังอัปเดตสมาชิก",
        calc_error: "เกิดข้อผิดพลาดระหว่างคำนวณ",
        calc_duration: "ใช้เวลา",
        calc_running_hide: "กำลังคำนวณ…",
        calc_spending_window: "ช่วงเวลา",
        calc_spending_updated: "อัปเดตสมาชิก",
        calc_spending_total: "ยอดรวมที่คำนวณ",
        calc_date_from: "ตั้งแต่วันที่",
        calc_date_to: "ถึงวันที่",
        order_detail: "รายละเอียดคำสั่งซื้อ",
        order_date_from: "วันที่สร้าง ตั้งแต่",
        order_date_to: "ถึง",
        order_date_range: "ช่วงวันที่สร้างรายการสั่งซื้อ",
        recipient_name: "ผู้รับ",
        recipient_phone: "เบอร์ผู้รับ",
        recipient_address: "ที่อยู่จัดส่ง",
        sale_channel: "ช่องทางการขาย",
        os_unpaid: "รอชำระเงิน",
        os_awaiting_shipment: "รอตัดรอบส่งสินค้า",
        os_awaiting_collection: "รอแพ็คสินค้า",
        os_partially_shipping: "จัดส่งบางส่วน",
        os_awaiting_transit: "รอขนส่งรับพัสดุ",
        os_in_transit: "กำลังขนส่ง",
        os_delivered: "จัดส่งสำเร็จ",
        os_completed: "สำเร็จ",
        os_cancelled: "ยกเลิก",
        os_returned: "ตีกลับ",
        os_claim: "เคลมสินค้า",
        os_returning: "กำลังตีกลับ",
        match_phone: "ค้นหาด้วยเบอร์",
        orders_hint: "เลือกช่วงวันที่แล้วกดค้นหา เพื่อดึงออเดอร์ที่จับคู่กับเบอร์โทรของสมาชิกในช่วงเวลานั้น",
        payment_status: "การชำระเงิน",
        tracking: "Tracking",
        total: "ยอดรวม",
        platform: "แพลตฟอร์ม",
        created: "วันที่สร้าง",
        amount: "ยอด",
        pay_amount: "ยอดที่ต้องชำระ",
        shipping_cost: "ค่าจัดส่ง",
        discount: "ส่วนลด",
        platform_discount: "ส่วนลดแพลตฟอร์ม",
        promotions: "โปรโมชั่น",
        no_promotions: "ไม่มีข้อมูลโปรโมชั่น",
        promotion_amount: "ส่วนลดโปรโมชั่น",
        product: "สินค้า",
        quantity: "จำนวน",
        original_price: "ราคาเต็ม",
        sale_price: "ราคาขาย",
        seller_discount: "ส่วนลดผู้ขาย",
        wms_products: "สินค้าในคลัง (WMS)",
        no_wms_products: "ไม่มีข้อมูลสินค้าในคลัง",
        wms_product_name: "ชื่อสินค้า",
        barcode: "บาร์โค้ด",
        pickup_quantity: "จำนวนที่จัดเตรียม",
        default: "หลัก",
        tabs: {
            profile: "โปรไฟล์",
            addresses: "ที่อยู่",
            points: "พอยต์",
            coupons: "คูปอง",
            redemptions: "ประวัติแลก",
            orders: "คำสั่งซื้อ",
            notifications: "การแจ้งเตือน",
            sessions: "เซสชัน",
            events: "อีเวนต์",
            pdpa: "PDPA",
            legacy: "ลิงก์ระบบเก่า",
            affiliate: "Affiliate",
        }
    },
    member_coins: {
        tab: "Coin",
        balance: "Coin คงเหลือ",
        lifetime_earned: "Coin ที่ได้รับสะสม",
        adjust_btn: "ปรับ coin",
        adjust_title: "ปรับ coin ของสมาชิก",
        adjust_hint: "ใส่จำนวนเป็นบวกเพื่อเพิ่ม coin หรือเป็นลบเพื่อหัก coin ต้องระบุเหตุผลทุกครั้ง (บันทึกไว้ในประวัติพร้อมชื่อผู้ทำรายการ)",
        adjust_coins: "จำนวน coin (+ เพิ่ม / - หัก)",
        adjust_preview: "ยอดหลังปรับ (ประมาณการ)",
        adjust_note: "เหตุผล",
        adjust_note_placeholder: "เช่น ชดเชยกรณีจัดส่งล่าช้า",
        adjust_success: "ปรับ coin สำเร็จ",
        no_rows: "ไม่มีประวัติ coin",
        col_type: "ประเภท",
        col_coins: "coin",
        col_balance_after: "คงเหลือหลังรายการ",
        col_ref: "อ้างอิง",
        col_note: "หมายเหตุ",
        col_expires_at: "หมดอายุ",
        col_created_at: "เวลา",
        type_earn: "ได้รับ",
        type_burn: "ใช้",
        type_refund: "คืนให้",
        type_clawback: "เรียกคืน",
        type_expire: "หมดอายุ",
        type_adjust: "ปรับโดยพนักงาน",
        type_unknown: "ไม่ทราบประเภท",
        err: {
            coins_nan: "กรุณาระบุจำนวน coin เป็นจำนวนเต็ม",
            coins_zero: "จำนวน coin ต้องไม่เป็น 0",
            coins_range: "จำนวน coin ต้องไม่เกิน 100,000 ต่อรายการ",
            note_too_short: "กรุณาระบุเหตุผลอย่างน้อย 3 ตัวอักษร",
            bad_adjust: "ระบบไม่รับรายการนี้ กรุณาตรวจสอบจำนวน coin และเหตุผลอีกครั้ง",
            insufficient: "coin คงเหลือไม่พอสำหรับการหักจำนวนนี้"
        },
        liability: {
            title: "รายงาน coin ค้าง",
            month: "เดือน",
            export: "Export Excel",
            top_title: "20 สมาชิกที่มี coin คงเหลือสูงสุด",
            no_data: "ไม่มีข้อมูลในเดือนนี้",
            members_with_balance: "สมาชิกที่มี coin คงเหลือ",
            expiring_next_month: "coin ที่จะหมดอายุเดือนถัดไป",
            col_rank: "อันดับ",
            col_member: "สมาชิก",
            col_name: "ชื่อ",
            col_coin_balance: "coin คงเหลือ",
            opened_balance: "ยอดยกมา",
            earn: "ได้รับ",
            burn: "ใช้",
            refund: "คืนให้",
            clawback: "เรียกคืน",
            expire: "หมดอายุ",
            adjust: "ปรับโดยพนักงาน",
            closing_balance: "คงเหลือสิ้นเดือน"
        }
    },
    member_level: {
        title: "ระดับสมาชิก",
        btn_add: "เพิ่มระดับ",
        edit_title: "แก้ไขระดับ",
        no_data: "ไม่มีข้อมูลระดับสมาชิก",
        col_code: "รหัส",
        col_name: "ชื่อระดับ",
        col_min: "ยอดสะสมขั้นต่ำ",
        col_rate: "อัตราสะสมคะแนน",
        col_members: "จำนวนสมาชิก",
        col_free_shipping: "ฟรีค่าจัดส่ง",
        col_discount: "ส่วนลด (%)",
        col_color: "สี",
        pts_per_100: "คะแนน / 100฿",
        label_code: "รหัส (a-z, 0-9, _)",
        label_name_th: "ชื่อ (ไทย)",
        label_name_en: "ชื่อ (อังกฤษ)",
        label_min: "ยอดสะสมขั้นต่ำ (฿)",
        label_rate: "คะแนนต่อ 100฿",
        hint_rate: "เช่น 4 = ได้ 4 คะแนนต่อยอดชำระ 100฿",
        label_free_shipping: "ฟรีค่าจัดส่ง",
        label_discount: "ส่วนลด (%)",
        hint_discount: "ส่วนลดพิเศษต่อระดับ (0–100) — ยังไม่มีผลตอนชำระเงิน (สำหรับแสดงผล)",
        label_color: "สี",
        label_icon: "ไอคอน",
        label_benefits: "สิทธิประโยชน์ (JSON)",
        hint_base_locked: "ระดับพื้นฐานต้องมียอดขั้นต่ำ 0 เสมอ",
        field_required: "จำเป็นต้องกรอก",
        err_code: "ใช้ a-z, 0-9, _ ไม่เกิน 32 ตัวอักษร",
        err_dup_min: "มีระดับที่ใช้ยอดขั้นต่ำนี้แล้ว",
        err_benefits_json: "สิทธิประโยชน์ต้องเป็น JSON ที่ถูกต้อง",
        err_base_protected: "ไม่สามารถลบระดับพื้นฐานได้",
        delete_title: "ลบระดับสมาชิก?",
        delete_msg: "สมาชิกในระดับนี้จะถูกจัดระดับใหม่อัตโนมัติ",
        delete_success: "ลบระดับแล้ว",
        save_success: "บันทึกแล้ว",
        col_coin: "Coin (%)",
        col_privileges: "สิทธิประโยชน์",
        label_coin: "Coin (%)",
        hint_coin: "อัตรา coin cashback ของระดับนี้ (0–100) — 0 = ไม่ตั้งค่า ใช้ค่าเริ่มต้นของร้าน · โปรโมชั่นชุดสินค้ามีลำดับสูงกว่าระดับสมาชิก",
        hint_coin_unset: "ไม่ได้ตั้งค่า — ใช้ค่าเริ่มต้นของร้าน",
        privilege_count_hint: "เปิดใช้ {active} จาก {total} รายการ",
        label_privileges: "สิทธิประโยชน์ (รายการ)",
        hint_privileges: "ลำดับในรายการ = ลำดับที่ลูกค้าเห็น · ระบุข้อความไทยทุกรายการ · ปิดสวิตช์เพื่อซ่อนจากลูกค้าโดยไม่ต้องลบ",
        hint_benefits_legacy: "รูปแบบเดิม (กำลังเลิกใช้) — ข้อความที่ลูกค้าเห็นมาจากรายการสิทธิประโยชน์ด้านบนแล้ว",
        privilege_empty: "ยังไม่มีสิทธิประโยชน์ในระดับนี้",
        privilege_icon: "ไอคอน",
        privilege_label_th: "ข้อความ (ไทย)",
        privilege_label_en: "ข้อความ (อังกฤษ)",
        privilege_active: "เปิดใช้งาน",
        privilege_remove: "ลบรายการนี้",
        privilege_move_up: "เลื่อนขึ้น",
        privilege_move_down: "เลื่อนลง",
        btn_add_privilege: "เพิ่มสิทธิประโยชน์",
        privilege_diff: "เมื่อบันทึก: เพิ่ม {added} · แก้ไข {updated} · ลบ {removed}",
        privilege_icon_truck: "รถขนส่ง",
        privilege_icon_gift: "ของขวัญ",
        privilege_icon_star: "ดาว",
        privilege_icon_crown: "มงกุฎ",
        privilege_icon_headset: "บริการลูกค้า",
        privilege_icon_cake: "เค้กวันเกิด",
        privilege_icon_percent: "ส่วนลด",
        privilege_icon_coin: "เหรียญ / coin",
        warn_unknown_icon: "มีไอคอนที่ระบบไม่รู้จัก — บันทึกได้ แต่ลูกค้าจะเห็นไอคอนกลางแทน",
        err_cashback_percent: "Coin (%) ต้องอยู่ระหว่าง 0–100",
        err_cashback_range: "Coin (%) ต้องอยู่ระหว่าง 0–100",
        err_cashback_nan: "Coin (%) ต้องเป็นตัวเลข",
        err_privilege_label: "สิทธิประโยชน์ทุกรายการต้องมีข้อความภาษาไทย"
    },
    kol: {
        created_by: "โดย",
        name: "จัดการ KOL",
        menu: {
            staff: "พนักงาน",
            creators: "ครีเอเตอร์",
            assignments: "งานที่มอบหมาย",
            product_sends: "ส่งสินค้า",
            reports: "รายงาน",
            payout_batches: "ใบสรุปจ่ายเงิน"
        },
        staff: "พนักงาน",
        staff_name: "พนักงาน",
        creator_name: "ชื่อครีเอเตอร์",
        nickname: "ชื่อเล่น",
        code: "รหัส",
        channel_link: "ลิงก์ช่องทาง",
        follower_count: "ผู้ติดตาม",
        line_contact: "ไลน์ติดต่อ",
        tax_id: "เลขผู้เสียภาษี",
        bank_account: "เลขบัญชี",
        bank_name: "ธนาคาร",
        address: "ที่อยู่",
        brief_date: "วันที่บรีฟ",
        clip_type: "ประเภทคลิป",
        clip_count: "จำนวนคลิป",
        script_detail: "รายละเอียดสคริปต์",
        hashtags: "แฮชแท็ก",
        cart_product: "สินค้าในตะกร้า",
        quantity: "จำนวน",
        color_variant: "สี/ตัวเลือก",
        order_number: "เลขคำสั่งซื้อ",
        tracking_number: "เลขพัสดุ",
        product_received_date: "วันที่ได้รับสินค้า",
        status: "สถานะ",
        review_status: "สถานะรีวิว",
        quality_grade: "เกรดคุณภาพ",
        commercial_usage: "ใช้เชิงพาณิชย์",
        post_date: "วันที่โพสต์",
        original_file_link: "ไฟล์ต้นฉบับ",
        link_fb: "ลิงก์ Facebook",
        link_lemon8: "ลิงก์ Lemon8",
        link_ig: "ลิงก์ Instagram",
        link_tiktok: "ลิงก์ TikTok",
        gencode: "Gencode",
        duration_days: "ระยะเวลา (วัน)",
        expiry_date: "วันหมดอายุ",
        ads_tiktok: "โฆษณา TikTok",
        payment_amount: "จำนวนเงิน",
        tax_type: "ประเภทภาษี",
        payment_status: "สถานะการชำระ",
        payment_date: "วันที่ชำระ",
        note: "หมายเหตุ",
        total_assignments: "งานทั้งหมด",
        total_payment: "ยอดชำระทั้งหมด",
        total_pending: "รอดำเนินการ",
        total_completed: "เสร็จสิ้น",
        status_pending: "รอดำเนินการ",
        status_briefed: "บรีฟแล้ว",
        status_product_sent: "ส่งสินค้าแล้ว",
        status_posted: "โพสต์แล้ว",
        status_completed: "เสร็จสิ้น",
        payment_unpaid: "ยังไม่ชำระ",
        payment_paid: "ชำระแล้ว",
        create_staff: "เพิ่มพนักงาน",
        edit_staff: "แก้ไขพนักงาน",
        create_creator: "เพิ่มครีเอเตอร์",
        edit_creator: "แก้ไขครีเอเตอร์",
        create_assignment: "สร้างงาน",
        edit_assignment: "แก้ไขงาน",
        select_staff: "เลือกพนักงาน",
        creator_name: "ครีเอเตอร์",
        select_creator: "เลือกครีเอเตอร์",
        select_status: "เลือกสถานะ",
        brief_date_from: "วันที่บรีฟ (จาก)",
        brief_date_to: "วันที่บรีฟ (ถึง)",
        brief_info: "ข้อมูลบรีฟ",
        shipping_info: "การจัดส่ง",
        content_info: "คอนเทนต์",
        payment_info: "การชำระเงิน",
        change_status: "เปลี่ยนสถานะ",
        mark_paid: "ทำเครื่องหมายว่าชำระแล้ว",
        confirm_mark_paid: "ยืนยันการชำระเงิน",
        status: {
            pending: "รอดำเนินการ",
            briefed: "บรีฟแล้ว",
            product_sent: "ส่งสินค้าแล้ว",
            posted: "โพสต์แล้ว",
            completed: "เสร็จสิ้น",
        },
        payment: {
            paid: "ชำระแล้ว",
            unpaid: "ยังไม่ชำระ",
            no_payment: "ไม่มีค่าตอบแทน",
        },
        tab: {
            brief_info: "ข้อมูลบรีฟ",
            shipping: "การจัดส่ง",
            content: "คอนเทนต์",
            payment: "การชำระเงิน",
        },
        tax: {
            none: "ไม่มี",
        },
        timeline: "ไทม์ไลน์",
        load_products: "โหลดสินค้า",
        export_excel: "ส่งออก Excel",
        timeline_action: {
            created: "สร้างงาน",
            status_change: "เปลี่ยนสถานะ",
            payment_change: "เปลี่ยนสถานะการชำระเงิน",
            updated: "แก้ไขข้อมูล",
        },
        payout_batch_detail: "รายละเอียดรอบจ่ายเงิน",
        payout_progress: "ความคืบหน้า",
        payout_last_updated: "อัพเดทล่าสุด",
        payout_paid_at: "วันที่โอน",
        payout_paid_by: "ผู้โอน",
        payout_pay_item: "บันทึกการโอน",
        payout_unpay_item: "ยกเลิกการโอน",
        payout_view_slip: "ดูสลิป",
        payout_view_id_card: "บัตรประชาชน",
        payout_view_bookbank: "Bookbank",
        payout_documents: "เอกสารเพิ่มเติม",
        payout_upload_doc: "อัพโหลดเอกสาร",
        payout_create_from_filter: "สร้างจาก Filter",
        payout_filter_creator: "Creator",
        payout_filter_payment_status: "สถานะการโอน",
        payout_filter_date_range: "ช่วงวันที่งาน",
        payout_status_paid: "โอนแล้ว",
        payout_status_unpaid: "ยังไม่โอน",
    },

    usage: {
        title: "การใช้สต็อก",
        date_from: "วันที่เริ่มต้น",
        date_to: "วันที่สิ้นสุด",
        product_name: "ชื่อสินค้า",
        barcode: "บาร์โค้ด",
        balance: "สต็อกคงเหลือ",
        usage_quantity: "ปริมาณที่ใช้",
        order_count: "จำนวนออเดอร์",
        window: "ช่วงเวลา",
        days: "วัน",
        total_orders: "ออเดอร์ทั้งหมด",
        export_excel: "ส่งออก Excel",
        error_required: "กรุณาเลือกช่วงวันที่",
        error_order: "วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มต้น",
        error_too_long: "ช่วงวันที่ต้องไม่เกิน 31 วัน",
        processing: "กำลังประมวลผล...",
        processing_hint: "กำลังคำนวณยอดการใช้สินค้าจากออเดอร์ กรุณารอสักครู่",
    },

    forecast: {
        title: "พยากรณ์สต็อก",
        days: "วัน",
        refresh: "รีเฟรช",
        product_name: "สินค้า",
        barcode: "บาร์โค้ด",
        current_stock: "คงเหลือ",
        usage: "ใช้ไป",
        show_zero: "แสดงที่ใช้เป็น 0",
        export_excel: "ส่งออก Excel",
        daily_avg: "เฉลี่ย/วัน",
        days_can_sale: "ขายได้อีก (วัน)",
        status: "สถานะ",
        status_ok: "ปกติ",
        status_low: "เหลือน้อย",
        status_critical: "วิกฤต",
        status_out: "หมด"
    },

    agent_commission: {
        name: "ค่าคอมตัวแทน",
        menu: {
            settings: "โปรไฟล์ค่าคอม",
            rounds: "รอบค่าคอม",
            round_detail: "รายละเอียดรอบ",
            remittance: "นำเข้ายอดโอน COD",
        },
        settings_title: "ตั้งค่าอัตราค่าคอมตัวแทน",
        profiles_title: "โปรไฟล์ค่าคอม",
        new_profile: "เพิ่มโปรไฟล์",
        profile_name: "ชื่อโปรไฟล์",
        set_default: "ตั้งเป็นค่าเริ่มต้น",
        default_badge: "ค่าเริ่มต้น",
        agent_count: "จำนวนตัวแทน",
        select_profile_hint: "เลือกโปรไฟล์จากรายการ หรือเพิ่มโปรไฟล์ใหม่",
        empty_profiles: "ยังไม่มีโปรไฟล์",
        delete_profile_confirm: "ยืนยันการลบโปรไฟล์นี้",
        cannot_delete_default: "ไม่สามารถลบโปรไฟล์ค่าเริ่มต้นได้",
        cannot_delete_in_use: "ไม่สามารถลบได้ เนื่องจากมีตัวแทนใช้งานอยู่",
        agents_tab: "ตัวแทน",
        agent_profile: "โปรไฟล์ค่าคอม",
        use_default: "ใช้ค่าเริ่มต้น (Default)",
        empty_agents_list: "ไม่มีตัวแทน",
        remittance_title: "นำเข้ายอดโอน COD",
        upload: "อัปโหลดไฟล์",
        carrier: "ขนส่ง",
        file_hint_xls: "รองรับไฟล์ .xlsx และ .csv (ไฟล์ .xls ให้บันทึกเป็น .xlsx ก่อนอัปโหลด)",
        remittance: {
            total: "ทั้งหมด",
            matched: "จับคู่แล้ว",
            unmatched: "ยังไม่จับคู่",
            duplicates_skipped: "ข้ามซ้ำ",
            processing: "กำลังประมวลผล",
            failed: "ล้มเหลว",
            done: "เสร็จสิ้น",
            match: "จับคู่",
            unmatch: "ยกเลิกการจับคู่",
            match_dialog_title: "จับคู่ออเดอร์",
            select_order: "ระบุเลขออเดอร์",
            match_success: "จับคู่สำเร็จ",
            tracking: "เลขพัสดุ",
            cod_amount: "ยอด COD",
            transfer_amount: "ยอดโอน",
            transfer_date: "วันที่โอน",
            no_unmatched: "ไม่มีรายการที่ยังไม่จับคู่",
            history: "ประวัติการนำเข้า",
            no_batches: "ยังไม่มีประวัติการนำเข้า",
            file_name: "ชื่อไฟล์",
        },
        payment_type_cod: "เก็บเงินปลายทาง (COD)",
        payment_type_transfer: "โอนเงิน",
        rounds_title: "รอบค่าคอมตัวแทน",
        tier: {
            min_amount: "ยอดขายขั้นต่ำ",
            max_amount: "ยอดขายสูงสุด",
            max_amount_hint: "เว้นว่างไว้ = ไม่จำกัด",
            percent: "เปอร์เซ็นต์ (%)",
            add_tier: "เพิ่มขั้น",
            save_tiers: "บันทึกการตั้งค่า",
        },
        round: {
            code: "รหัสรอบ (YYYY-MM)",
            period: "ช่วงเวลา",
            period_start: "เริ่มต้น",
            period_end: "สิ้นสุด",
            status: "สถานะ",
            total_sales: "ยอดขายรวม",
            total_commission: "ค่าคอมรวม",
            agent_count: "จำนวนตัวแทน",
            order_count: "จำนวนออเดอร์",
            created_at: "วันที่สร้าง",
            note: "หมายเหตุ",
            select_month: "เลือกเดือน",
            preview: "ดูตัวอย่าง",
            create: "สร้างรอบ",
            delete: "ลบ / เปิดใหม่",
            confirm_delete: "ยืนยันการลบรอบนี้",
            confirm_delete_msg: "การลบจะยกเลิกการนับออเดอร์ทั้งหมดในรอบนี้ ออเดอร์จะกลับเข้าสู่คิวสำหรับรอบต่อไป ต้องการดำเนินการต่อหรือไม่?",
            status_closed: "ปิดแล้ว",
            preview_title: "ตัวอย่างการคำนวณ",
        },
        agent: {
            agent_name: "ชื่อตัวแทน",
            total_sales: "ยอดขาย",
            tier_percent: "เปอร์เซ็นต์",
            commission_amount: "ค่าคอม",
            order_count: "จำนวนออเดอร์",
            view_orders: "ดูออเดอร์",
        },
        order: {
            order_number: "เลขออเดอร์",
            pay_amount: "ยอดชำระ",
            completed_at: "วันที่สำเร็จ",
            created_at: "วันที่สร้าง",
            order_status: "สถานะ",
            view_order: "ดูออเดอร์",
            payment_type: "ประเภทการชำระ",
        },
        validation: {
            percent_range: "เปอร์เซ็นต์ต้องอยู่ระหว่าง 0 ถึง 100",
            min_required: "กรุณาระบุยอดขายขั้นต่ำ",
            overlapping: "ช่วงยอดขายต้องไม่ทับซ้อนกัน",
            not_ascending: "ยอดขายขั้นต่ำต้องเรียงจากน้อยไปมาก",
            code_required: "กรุณาเลือกเดือน",
            name_required: "กรุณาระบุชื่อโปรไฟล์",
        },
        empty_tiers: "ยังไม่มีการตั้งค่าอัตราค่าคอม",
        empty_rounds: "ยังไม่มีรอบค่าคอม",
        empty_agents: "ไม่มีตัวแทนในรอบนี้",
        empty_orders: "ไม่มีออเดอร์",
        save_success: "บันทึกสำเร็จ",
        create_success: "สร้างรอบสำเร็จ",
        delete_success: "ลบรอบสำเร็จ",
        permission_label: "ค่าคอมตัวแทน / Agent Commission",
    },
    issue_report: {
        component: {
            MEMBER: "MEMBER — ระบบสมาชิก (mdf-member-fn + API)",
            APP: "APP",
            WEB: "WEB",
            BO: "BO",
        },
        component_desc: {
            MEMBER: "ระบบสมาชิก/หน้า member และ API หลังบ้านที่ใช้ร่วมกัน",
            APP: "แอปมือถือ",
            WEB: "เว็บ storefront",
            BO: "ระบบหลังบ้าน",
        },
        kind: {
            bug: "ปัญหา",
            feature: "ฟีเจอร์",
        },
        severity: {
            low: "ต่ำ",
            medium: "กลาง",
            high: "สูง",
        },
        work_status: {
            pending_review: "รอตรวจสอบ",
            in_progress: "กำลังแก้ไข",
            done: "แก้ไขแล้ว",
            cancelled: "ยกเลิก",
        },
        form: {
            title: "แจ้งปัญหา / เสนอฟีเจอร์",
            breadcrumb: "แจ้งปัญหา",
            my_reports: "รายการที่แจ้ง",
            kind: "ประเภท",
            component: "ส่วนของระบบ",
            subject: "หัวข้อ",
            subject_placeholder: "สรุปปัญหาหรือฟีเจอร์แบบสั้น ๆ",
            description: "รายละเอียด",
            description_placeholder: "อธิบายปัญหา ขั้นตอนการเกิด หรือสิ่งที่ต้องการให้ทำ",
            severity: "ระดับความรุนแรง",
            screenshot: "ภาพหน้าจอ (ถ้ามี)",
            attachments: "ภาพหน้าจอ (ถ้ามี)",
            add_attachments: "เพิ่มรูป",
            attach_limit: "รองรับ PNG/JPEG/WebP/GIF สูงสุด 5MB ต่อรูป",
            attach_limit_reached: "แนบได้สูงสุด 10 รูป",
            file_type_invalid: "ชนิดไฟล์ไม่รองรับ",
            wait_upload: "กรุณารอให้อัพโหลดรูปเสร็จก่อน",
            upload_screenshot: "อัพโหลดภาพหน้าจอ",
            uploading: "กำลังอัพโหลด...",
            remove: "ลบ",
            cancel: "ยกเลิก",
            submit: "ส่งรายงาน",
            success: "ส่งรายงานแล้ว ทีมงานจะตรวจสอบ",
            submit_error: "ไม่สามารถส่งรายงานได้ กรุณาลองใหม่",
            subject_required: "กรุณากรอกหัวข้อ",
            description_required: "กรุณากรอกรายละเอียด",
            component_required: "กรุณาเลือกส่วนของระบบ",
            file_too_large: "ไฟล์ใหญ่เกินขนาดที่กำหนด (สูงสุด 5MB)",
            upload_failed: "อัพโหลดภาพไม่สำเร็จ",
        },
        list: {
            title: "รายการที่แจ้ง",
            breadcrumb: "รายการที่แจ้ง",
            report_button: "แจ้งปัญหา",
            sync_now: "Sync สถานะ",
            sync_success: "ซิงค์สำเร็จ (สร้างใหม่ {created}, อัปเดตสถานะ {touched})",
            sync_error: "ไม่สามารถซิงค์ได้ กรุณาลองใหม่",
            scope_mine: "ของฉัน",
            scope_all: "ทั้งหมด",
            col_created_at: "วันที่แจ้ง",
            col_title: "หัวข้อ",
            col_reporter: "ผู้แจ้ง",
            col_component: "ส่วนของระบบ",
            col_severity: "ความรุนแรง",
            col_work_status: "สถานะ",
            col_attachments: "รูปแนบ",
            col_github: "GitHub",
            resolved_in: "แก้ไขแล้วใน {version}",
            no_data: "ยังไม่มีรายการแจ้ง",
            load_error: "ไม่สามารถโหลดรายการได้",
            total_count: "ทั้งหมด",
        },
    },
    release: {
        title: "ประวัติเวอร์ชัน",
        subtitle:
            "ประวัติเวอร์ชันของ API, App, Web และ Backoffice — ใหม่สุดอยู่บน แท็กที่ไฮไลต์คือส่วนที่เปลี่ยนจากรุ่นก่อนหน้า",
        breadcrumb: "เวอร์ชัน",
        no_data: "ยังไม่มีข้อมูลเวอร์ชัน",
        no_fixes: "ไม่มี issue ที่เชื่อมโยง",
        component: {
            api: "API",
            app: "APP",
            web: "WEB",
            bo: "BO",
        },
        component_desc: {
            api: "Backoffice API (mdf-bo-api)",
            app: "แอปมือถือ MadameFin (Flutter)",
            web: "เว็บหน้าร้าน (mdf-www)",
            bo: "Backoffice (mdf-bo-fn)",
        },
    },
    sync: {
        modal: {
            title_order: "ซิงค์ออเดอร์ {platform}",
            title_product: "ซิงค์สินค้า {platform}",
            status: {
                queued: "เข้าคิว",
                running: "กำลังซิงค์",
                done: "เสร็จสิ้น",
                failed: "ล้มเหลว",
            },
            progress: "{done} / {total} รายการ",
            progress_indeterminate: "ซิงค์แล้ว {done} รายการ",
            failed_count: "ล้มเหลว {failed} รายการ",
            view_orders: "ดูออเดอร์",
            view_products: "ดูสินค้า",
            close: "ปิด",
            busy: "มีงานซิงค์กำลังทำงานอยู่",
        },
        log: {
            button: "Sync Log",
            title: "Sync Log",
            breadcrumb: "Sync Log",
            filter_platform: "แพลตฟอร์ม",
            filter_type: "ประเภท",
            filter_status: "สถานะ",
            filter_date_from: "ตั้งแต่",
            filter_date_to: "ถึง",
            all: "ทั้งหมด",
            search: "ค้นหา",
            type_order: "ออเดอร์",
            type_product: "สินค้า",
            col_created_at: "เวลาที่สร้าง",
            col_platform: "แพลตฟอร์ม",
            col_type: "ประเภท",
            col_shop: "ร้านค้า",
            col_created_by: "ผู้สั่งซิงค์",
            col_status: "สถานะ",
            col_progress: "ความคืบหน้า",
            col_error: "ข้อผิดพลาด",
            col_duration: "ระยะเวลา",
            no_data: "ไม่พบประวัติการซิงค์",
            load_error: "ไม่สามารถโหลดประวัติการซิงค์ได้",
            total_count: "ทั้งหมด",
        },
    },
    // NOTE: ต้องไม่ชื่อ `platform` — มี key ระดับบนสุด `platform: "แพลตฟอร์ม"` อยู่ก่อนแล้ว
    // ถ้าตั้งชื่อซ้ำ object นี้จะทับ string (key หลังชนะ) แล้ว $t('platform') ทั่วระบบ
    // จะคืน object ออกมาแทนคำแปล (โผล่เป็น JSON ก้อนใหญ่ / header เป็น undefined)
    platform_integration: {
        makro: {
            title: "Makro PRO",
            instance_url: "Instance URL",
            api_key: "API Key",
            shop_id: "Shop ID",
            shop_name: "ชื่อร้าน",
            configured: "เชื่อมต่อแล้ว",
            not_configured: "ยังไม่ได้ตั้งค่า",
            credentialsConfigInfo: "ตั้งค่า credential ใน config.yml (platform.mirakl)",
            test_connection: "ทดสอบการเชื่อมต่อ",
            test_ok: "เชื่อมต่อสำเร็จ: {shop}",
            test_fail: "เชื่อมต่อไม่สำเร็จ: {reason}",
            offer_hint: "Offer ของ Makro มาจากสินค้า platform Makro ในหน้าสินค้า (จับคู่ WMS ที่นั่น)",
            push_offers: "ส่งสต็อก/ราคา",
            push_fail: "ส่งสต็อก/ราคาไม่สำเร็จ",
            offer_sku: "Offer SKU",
            push_offer: "ส่ง Offer เดี่ยว",
            offer_sku_required: "กรุณากรอก Offer SKU",
            push_offer_ok: "ส่ง Offer ไป Makro แล้ว",
            push_offer_fail: "ส่ง Offer ไม่สำเร็จ",
        },
        // amaze — Amaze (amaze-x) Seller Open API, Phase 0 (การ์ดสถานะ + ทดสอบ + sync)
        amaze: {
            title: "Amaze",
            configured: "เชื่อมต่อแล้ว",
            not_configured: "ยังไม่ตั้งค่า",
            env: "Environment",
            env_uat: "UAT",
            env_prod: "Production",
            shop_name: "ชื่อร้าน",
            amaze_id: "Amaze ID",
            account: "บัญชีที่ใช้",
            credentialsConfigInfo: "ตั้งค่า credential ใน config.yml (platform.amaze)",
            test_connection: "ทดสอบการเชื่อมต่อ",
            test_ok: "เชื่อมต่อสำเร็จ: {shop}",
            test_fail: "เชื่อมต่อไม่สำเร็จ: {reason}",
            sync_order: "Sync Order",
            sync_product: "Sync Product",
            date_format_detected: "รูปแบบวันที่: {format}",
            rate_limit: "เพดาน: {rps} req/วิ",
            rate_limit_hint:
                "เพดานนี้เป็นของคอนเทนเนอร์นี้เท่านั้น ไม่ใช่งบรวมของทุกบริการ (Amaze จำกัดรวมต่อ IP)",
            last_order_poll: "ดึงออเดอร์ล่าสุด: {time}",
            last_product_poll: "ดึงสินค้าล่าสุด: {time}",
            poller_never: "ยังไม่เคยดึง",
            poller_unknown: "ไม่ทราบ (อ่านสถานะไม่ได้)",
            poller_stalled: "poller ในบริการ Webhook อาจหยุดทำงาน",
        },
    },
    shipping_config: {
        menu: "ตั้งค่าการจัดส่ง",
        title: "ตั้งค่าการจัดส่งตามช่องทางการขาย",
        permission_label: "ตั้งค่าการจัดส่ง / Shipping Config",
        col_sale_channel: "ช่องทางการขาย",
        col_default: "ค่าเริ่มต้น",
        col_map: "การจับคู่ (ชำระเงิน → ขนส่ง)",
        col_updated: "แก้ไขล่าสุด",
        edit: "แก้ไข",
        add_channel: "เพิ่มช่องทาง",
        default_section: "ค่าเริ่มต้น",
        map_section: "การจับคู่ช่องทางชำระเงิน → ผู้ให้บริการขนส่ง",
        add_row: "เพิ่มแถว",
        payment_method: "ช่องทางชำระเงิน",
        provider: "ผู้ให้บริการขนส่ง",
        none: "ไม่กำหนด",
        dup_payment_err: "มีช่องทางชำระเงินซ้ำในการจับคู่",
        save: "บันทึก",
        cancel: "ยกเลิก",
        save_success: "บันทึกการตั้งค่าการจัดส่งเรียบร้อยแล้ว",
    },
    modern_trade: {
        name: "Modern Trade",
        permission_label: "Modern Trade",
        menu: {
            companies: "บริษัทคู่ค้า",
            receipts: "ใบรับสินค้า",
            sales_import: "ข้อมูลการขาย",
            consignment_payments: "รับเงินฝากขาย",
            stock: "คลังสินค้า MT",
            expiry_report: "รายงานวันหมดอายุ",
            products: "สินค้า",
            price_templates: "เทมเพลตราคา",
            sale_orders: "ใบสั่งซื้อ",
            settings: "ตั้งค่า",
            reports: "รายงาน",
            invoices: "ใบกำกับภาษี",
            report_sales: "รายงานยอดขาย",
            report_stock_value: "รายงานมูลค่าคงเหลือ",
            doc_format: "ตั้งค่ารูปแบบเอกสาร",
            audit: "บันทึกการตรวจสอบ",
        },
        company: {
            title: "บริษัทคู่ค้า",
            create: "เพิ่มบริษัท",
            edit: "แก้ไขบริษัท",
            name: "ชื่อบริษัท",
            tax_id: "เลขประจำตัวผู้เสียภาษี",
            branch_code: "รหัสสาขา",
            address: "ที่อยู่",
            contact_name: "ชื่อผู้ติดต่อ",
            contact_tel: "เบอร์โทรศัพท์",
            contact_email: "อีเมล",
            status: "สถานะ",
            active: "ใช้งาน",
            inactive: "ระงับ",
            delete_confirm: "ยืนยันการลบบริษัทนี้?",
            has_stock_cannot_delete: "ไม่สามารถลบบริษัทที่มีข้อมูลการเคลื่อนไหวได้ กรุณาเปลี่ยนสถานะเป็น 'ระงับ' แทน",
            duplicate_tax_id: "เลขผู้เสียภาษีและรหัสสาขาซ้ำกันในระบบ",
            tax_id_locked_hint: "ไม่สามารถแก้ไขเลขผู้เสียภาษีได้เนื่องจากมีข้อมูลการเคลื่อนไหวแล้ว",
            has_movements_cannot_edit: "ไม่สามารถแก้ไขเลขผู้เสียภาษี/รหัสสาขาได้ เนื่องจากมีข้อมูลการเคลื่อนไหวแล้ว",
            name_required: "กรุณากรอกชื่อบริษัท",
            tax_id_invalid: "เลขประจำตัวผู้เสียภาษีต้องมี 13 หลัก",
            price_profile: "โปรไฟล์ราคา",
            vat_included: "ราคาปลีกรวม VAT",
            gp_percent: "GP (%)",
            credit_term_days: "เครดิต (วัน)",
            price_template: "เทมเพลตราคา",
            no_template: "ไม่ผูกเทมเพลต",
        },
        receipt: {
            title: "ใบรับสินค้า",
            create: "สร้างใบรับสินค้า",
            po_number: "เลขที่ PO",
            po_file: "ไฟล์ PO",
            upload_po: "อัพโหลดเอกสาร PO",
            download_po: "ดาวน์โหลด PO",
            status: "สถานะ",
            status_draft: "ร่าง",
            status_received: "รับแล้ว",
            status_canceled: "ยกเลิก",
            note: "หมายเหตุ",
            received_at: "วันที่รับ",
            items: "รายการสินค้า",
            import_items: "นำเข้าสินค้า",
            delete_draft_confirm: "ยืนยันการลบใบรับสินค้าร่างนี้?",
            company_required: "กรุณาเลือกบริษัท",
            po_number_required: "กรุณากรอกเลขที่ PO",
            po_file_required: "กรุณาเลือกไฟล์ PO",
        },
        settings: {
            title: "ตั้งค่า Modern Trade",
            min_shelf_life_days: "อายุขั้นต่ำที่รับได้ (วัน)",
            min_shelf_life_hint: "สินค้าที่มีอายุคงเหลือน้อยกว่าค่านี้จะถูกปฏิเสธเมื่อรับเข้าคลัง",
            min_shelf_life_invalid: "กรุณากรอกอายุขั้นต่ำที่รับได้เป็นจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
            // #512 — ค่าที่ปุ่ม "สร้างออเดอร์เข้าห้องแพ็ค" บนใบส่งของพึ่งโดยตรง
            sale_channel: "ช่องทางการขายของออเดอร์ห้องแพ็ค",
            sale_channel_hint: "ออเดอร์ที่สร้างจากใบส่งของจะถูกบันทึกด้วยช่องทางการขายนี้ (ช่องทางประเภทตัวแทนใช้ไม่ได้ — ถังตัดรอบของห้องแพ็คกรองออก)",
            payment_method: "วิธีชำระเงินของออเดอร์ห้องแพ็ค",
            payment_method_hint: "ออเดอร์ที่สร้างจากใบส่งของจะถูกบันทึกด้วยวิธีชำระเงินนี้",
            select_placeholder: "เลือกจากรายการ",
            // ข้อความของค่าที่ "ตั้งไว้แล้วแต่ใช้ไม่ได้" แยกตามรหัสเหตุผลที่ GET ส่งมา
            // (sale_channel_issue / payment_method_issue) เพราะสามเหตุผลนี้ผู้ใช้ต้องทำ
            // คนละอย่าง — โดยเฉพาะ not_selectable ที่แถวยังอยู่ครบ ไม่มีใครลบอะไรทั้งนั้น
            // unusable_* = ตัวสำรองของรหัสที่ FE ยังไม่รู้จัก (BE เพิ่มรหัสใหม่ในอนาคต)
            issue: {
                deleted_option: "{name} (ถูกลบไปแล้ว)",
                deleted_warning: "ตั้งไว้ที่ {name} แต่ตัวเลือกนี้ถูกลบไปแล้ว ปุ่มสร้างออเดอร์เข้าห้องแพ็คจะใช้ไม่ได้จนกว่าจะเลือกใหม่แล้วกดบันทึก",
                missing_option: "{name} (ไม่พบในระบบ)",
                missing_warning: "ตั้งไว้ที่ {name} แต่ไม่พบรายการนี้ในระบบแล้ว (ถูกลบถาวรหรือเป็นรหัสที่ไม่มีอยู่จริง) ปุ่มสร้างออเดอร์เข้าห้องแพ็คจะใช้ไม่ได้จนกว่าจะเลือกใหม่แล้วกดบันทึก",
                not_selectable_option: "{name} (ประเภทตัวแทน ใช้กับ Modern Trade ไม่ได้)",
                not_selectable_warning: "ตั้งไว้ที่ {name} ซึ่งเป็นช่องทางการขายประเภทตัวแทน (Agent) รายการนี้ไม่ได้ถูกลบ ยังอยู่ในระบบครบถ้วน แต่ถังตัดรอบของห้องแพ็คกรองประเภทตัวแทนออก ห้องแพ็คจึงมองไม่เห็นออเดอร์ที่สร้างด้วยช่องทางนี้ ⇒ ปุ่มสร้างออเดอร์เข้าห้องแพ็คจะปฏิเสธจนกว่าจะเปลี่ยนไปใช้ช่องทางที่ไม่ใช่ตัวแทนแล้วกดบันทึก",
                unusable_option: "{name} (ใช้ไม่ได้)",
                unusable_warning: "ตั้งไว้ที่ {name} แต่ระบบแจ้งว่าใช้กับ Modern Trade ไม่ได้ ปุ่มสร้างออเดอร์เข้าห้องแพ็คจะใช้ไม่ได้จนกว่าจะเลือกใหม่แล้วกดบันทึก",
            },
            unset_warning: "ยังไม่ได้ตั้งค่า ปุ่มสร้างออเดอร์เข้าห้องแพ็คจะขึ้นว่า “ยังไม่ได้ตั้งค่า” จนกว่าจะเลือกแล้วกดบันทึก",
            options_failed: "โหลดรายการตัวเลือกไม่สำเร็จ กรุณาปิดแล้วเปิดหน้าต่างตั้งค่านี้อีกครั้ง",
            error: {
                invalid_sale_channel: "ไม่พบช่องทางการขายที่เลือก (อาจถูกลบไปแล้ว)",
                sale_channel_not_selectable: "ช่องทางการขายนี้ใช้กับ Modern Trade ไม่ได้ (ช่องทางประเภทตัวแทนถูกกรองออกจากถังตัดรอบของห้องแพ็ค)",
                invalid_payment_method: "ไม่พบวิธีชำระเงินที่เลือก (อาจถูกลบไปแล้ว)",
                setting_retired: "มีค่าที่เลิกใช้แล้วถูกส่งไปยังระบบหลังบ้าน จึงบันทึกไม่สำเร็จ",
            },
            // สวิตช์ deduct_main_stock ถูกถอดออกแล้ว (bo-api #505) 3 บรรทัดข้างล่างนี้
            // มาแทนที่ เพื่อบอกกติกาใหม่ตรงที่สวิตช์เคยอยู่ ไม่ใช่ปล่อยให้ช่องหายเฉย ๆ
            stock_rule_title: "การตัดสต็อกของ Modern Trade",
            stock_rule_do: "ออกใบส่งของ = เอกสารล้วน ไม่ตัดสต็อกใด ๆ",
            stock_rule_order: "สต็อกจะถูกกันตอนกดปุ่ม “สร้างออเดอร์เข้าห้องแพ็ค” บนใบส่งของเท่านั้น แล้วห้องแพ็คจะตัดจริงตอนปิดรอบ",
            stock_rule_manual: "ใบส่งของที่ไม่ได้กดสร้างออเดอร์ ระบบจะไม่ตัดสต็อกให้เลย ต้องไปตัดใน WMS เอง",
            saved: "บันทึกการตั้งค่าสำเร็จ",
        },
        import: {
            pick_file: "เลือกไฟล์",
            template: "ดาวน์โหลดแบบฟอร์ม",
            validate: "ตรวจสอบไฟล์",
            preview: "ดูตัวอย่าง",
            confirm: "ยืนยัน",
            cancel: "ยกเลิก",
            row_no: "ลำดับ",
            status_ok: "ผ่าน",
            status_error: "ผิดพลาด",
            error_message: "ข้อความแจ้งเตือน",
            summary_total: "ทั้งหมด",
            summary_ok: "ผ่าน",
            summary_error: "ผิดพลาด",
            download_report: "ดาวน์โหลดรายงาน",
            confirm_note: "กดยืนยันเพื่อบันทึกข้อมูลลงระบบ",
            duplicate_file: "ไฟล์นี้เคยนำเข้าแล้ว",
            allocation: "การจัดสรร FEFO",
            import_success: "นำเข้าสำเร็จ",
        },
        sales: {
            title: "นำเข้าข้อมูลการขาย",
            history: "ประวัติการนำเข้า",
            sale_date: "วันที่ขาย",
            import_success: "นำเข้าข้อมูลการขายสำเร็จ",
        },
        sales_entry: {
            title: "ข้อมูลการขาย",
            doc_no: "เลขที่เอกสาร",
            company: "บริษัท",
            branch: "สาขา",
            branch_code: "รหัสสาขา",
            sold_at: "วันที่ขาย",
            item_count: "จำนวนรายการ",
            total_qty: "จำนวนชิ้น",
            source: "แหล่งที่มา",
            source_import: "นำเข้า",
            source_manual: "เพิ่มเอง",
            created_at: "บันทึกเมื่อ",
            search_placeholder: "ค้นหาเลขที่เอกสาร",
            date_from: "ตั้งแต่วันที่",
            date_to: "ถึงวันที่",
            btn_import: "นำเข้า",
            btn_add: "เพิ่ม",
            detail_title: "รายละเอียดข้อมูลการขาย",
            detail_items: "รายการสินค้า",
            sku_code: "รหัส SKU",
            barcode: "บาร์โค้ด",
            product_name: "ชื่อสินค้า",
            lot_no: "Lot",
            qty: "จำนวน",
            deducted_lots: "Lot ที่ตัดจริง",
            import_title: "นำเข้าข้อมูลการขาย",
            pick_company: "เลือกบริษัท",
            add_title: "เพิ่มข้อมูลการขาย",
            add_product: "เพิ่มสินค้า",
            select_product: "เลือกสินค้า",
            lot_auto_fefo: "อัตโนมัติ (FEFO)",
            lot_remaining: "คงเหลือ",
            lot_expire: "หมดอายุ",
            company_required: "กรุณาเลือกบริษัท",
            sold_at_required: "กรุณาเลือกวันที่ขาย",
            add_item_required: "กรุณาเพิ่มสินค้าอย่างน้อย 1 รายการ",
            qty_required: "กรุณากรอกจำนวนให้ครบทุกรายการ",
            save: "บันทึก",
            save_success: "บันทึกข้อมูลการขายสำเร็จ",
            import_success: "นำเข้าข้อมูลการขายสำเร็จ",
            file_format_title: "รูปแบบไฟล์นำเข้า",
            file_format_hint_key: "ระบุ sku_code (รหัส SKU) หรือ barcode (บาร์โค้ด) อย่างน้อย 1 ช่องต่อแถว (ไม่รองรับรหัสสินค้าแล้ว)",
            file_format_hint_date: "sale_date: วันที่ขาย รูปแบบ YYYY-MM-DD และต้องไม่เป็นวันที่ในอนาคต",
            file_format_hint_lot: "lot_no: เว้นว่างได้ ระบบจะตัดสต็อกอัตโนมัติแบบ FEFO",
            file_format_hint_qty: "qty: จำนวนเต็มบวก",
            col_sku_code: "รหัส SKU",
            col_barcode: "บาร์โค้ด",
            col_sale_date: "วันที่ขาย",
            col_lot_no: "Lot",
            col_qty: "จำนวน",
            err_missing_sku_or_barcode: "ต้องระบุ sku_code หรือ barcode อย่างน้อย 1 ช่อง",
            err_unknown_product: "ไม่พบสินค้าจากรหัส SKU/บาร์โค้ดที่ระบุ",
            import_errors_truncated: "แสดง {shown} จาก {total} แถวที่ผิดพลาด — แก้แถวที่เห็นแล้วอัปโหลดใหม่เพื่อดูส่วนที่เหลือ",
        },
        stock: {
            title: "คลังสินค้า MT",
            group_by_lot: "แสดงตาม Lot",
            group_by_product: "แสดงตามสินค้า",
            hide_zero: "ซ่อน stock เป็น 0",
            lot_no: "Lot No.",
            expired_date: "วันหมดอายุ",
            days_to_expire: "วันคงเหลือ",
            qty: "จำนวน",
            movements: "ประวัติการเคลื่อนไหว",
            adjust: "ปรับ Stock",
            adjust_qty: "จำนวน (บวก/ลบ)",
            adjust_reason: "เหตุผล",
            movement_type_receive: "รับเข้า",
            movement_type_sale: "ขาย",
            movement_type_adjust: "ปรับปรุง",
            no_movements: "ไม่มีข้อมูล",
            fill_all_required: "กรุณากรอกข้อมูลให้ครบ",
            qty_not_zero: "กรุณากรอกจำนวน (ไม่ใช่ 0)",
            reason_required: "กรุณากรอกเหตุผล",
            adjust_success: "ปรับ Stock สำเร็จ",
        },
        report: {
            expiry_title: "รายงานวันหมดอายุ",
            days_ahead: "ล่วงหน้า (วัน)",
            bucket_expired: "หมดอายุแล้ว",
            bucket_active: "ยังไม่หมดอายุ",
            bucket_30: "≤ 30 วัน",
            bucket_60: "≤ 60 วัน",
            bucket_90: "≤ 90 วัน",
            export_xlsx: "ส่งออก Excel",
        },
        // round-19 Dev-C — global document-number search (#363 §1)
        doc_search: {
            placeholder: "ค้นหาเลขเอกสาร (SO / MO / DO / PO / IV / ใบสั่งของ)",
            no_result: "ไม่พบเอกสาร",
            type_sale_order: "ใบสั่งขาย",
            type_po: "เลข PO ลูกค้า",
            type_production_order: "ใบสั่งผลิต",
            type_delivery: "ใบส่งของ",
            type_invoice: "ใบกำกับภาษี",
            type_receipt: "ใบสั่งของ",
        },
        validation: {
            unknown_tax_id: "ไม่พบเลขผู้เสียภาษีในระบบ",
            tax_id_mismatch: "เลขผู้เสียภาษีไม่ตรงกับบริษัทในใบรับ",
            company_inactive: "บริษัทถูกระงับการใช้งาน",
            unknown_product: "ไม่พบรหัสสินค้าในระบบ",
            bad_date: "รูปแบบวันที่ไม่ถูกต้อง",
            expired_on_receive: "สินค้าหมดอายุแล้ว ไม่สามารถรับเข้าคลังได้",
            shelf_life_too_short: "อายุสินค้าคงเหลือน้อยกว่าขั้นต่ำที่กำหนด",
            lot_expiry_mismatch: "วันหมดอายุของ Lot ไม่ตรงกับที่บันทึกไว้",
            bad_qty: "จำนวนไม่ถูกต้อง (ต้องเป็นจำนวนเต็มบวก)",
            duplicate_row: "แถวซ้ำในไฟล์",
            future_sale_date: "วันที่ขายอยู่ในอนาคต",
            unknown_lot: "ไม่พบ Lot ของสินค้านี้สำหรับบริษัทนี้",
            insufficient_stock: "Stock ไม่เพียงพอ",
            bad_header: "หัวตาราง (header) ไม่ถูกต้องหรือขาดหาย",
            file_too_large: "ไฟล์ใหญ่เกินขนาดที่กำหนด (สูงสุด 5,000 แถว / 10 MB)",
            all_or_nothing_blocked: "แก้ไฟล์ให้ผ่านทั้งหมดก่อนจึงจะยืนยันได้",
        },
        product: {
            title: "สินค้า Modern Trade",
            create: "เพิ่มสินค้า",
            edit: "แก้ไขสินค้า",
            code: "รหัสสินค้า",
            name: "ชื่อสินค้า",
            category: "กลุ่มสินค้า",
            manufacturer: "บริษัทผู้ผลิต",
            unit_buy: "หน่วยนับ (ซื้อ)",
            unit_sell: "หน่วยนับ (ขาย)",
            unit_stock: "หน่วยนับ (เก็บสต็อก)",
            size_value: "ขนาด",
            size_unit: "หน่วยขนาด",
            sku_code: "รหัส SKU",
            sku_mapped: "เชื่อมแล้ว",
            sku_unmapped: "ยังไม่เชื่อม",
            category_manage: "จัดการกลุ่มสินค้า",
            category_name: "ชื่อกลุ่มสินค้า",
            category_add: "เพิ่มกลุ่ม",
            category_add_placeholder: "ชื่อกลุ่มสินค้าใหม่",
            category_delete_confirm: "ลบกลุ่มสินค้านี้?",
            wms_product: "สินค้า WMS",
            default_retail_price: "ราคาขายปลีก default",
            account_code: "รหัสบัญชี",
            note: "หมายเหตุ",
            status: "สถานะ",
            active: "ใช้งาน",
            inactive: "ระงับ",
            import: "นำเข้าสินค้า",
            import_template: "ดาวน์โหลดแบบฟอร์ม",
            search_placeholder: "ค้นหาด้วยรหัสหรือชื่อสินค้า",
            delete_confirm: "ยืนยันการลบสินค้านี้?",
            has_reference_cannot_delete: "ไม่สามารถลบสินค้าที่ถูกอ้างในใบสั่งซื้อได้ กรุณาเปลี่ยนสถานะเป็น 'ระงับ' แทน",
            code_required: "กรุณากรอกรหัสสินค้า",
            name_required: "กรุณากรอกชื่อสินค้า",
            code_duplicate: "รหัสสินค้าซ้ำในระบบ",
            sku_not_resolved: "รหัส SKU ไม่ตรงกับสินค้า WMS (barcode / man_pn)",
            saved: "บันทึกสินค้าสำเร็จ",
            import_success: "นำเข้าสินค้าสำเร็จ",
        },
        price_template: {
            title: "เทมเพลตราคา",
            create: "เพิ่มเทมเพลต",
            edit: "แก้ไขเทมเพลต",
            rename: "แก้ไขชื่อ",
            name: "ชื่อเทมเพลต",
            note: "หมายเหตุ",
            status: "สถานะ",
            active: "ใช้งาน",
            inactive: "ระงับ",
            items: "รายการราคา",
            items_count: "จำนวน",
            select_for_pricing: "เลือกเทมเพลตนี้เพื่อแก้ไขรายการราคา",
            add_item: "เพิ่มรายการ",
            product: "สินค้า",
            retail_price: "ราคาปลีกพิเศษ",
            save_items: "บันทึกรายการราคา",
            delete_confirm: "ยืนยันการลบเทมเพลตนี้?",
            has_company_cannot_delete: "ไม่สามารถลบเทมเพลตที่มีบริษัทผูกอยู่ได้",
            name_required: "กรุณากรอกชื่อเทมเพลต",
            price_required: "กรุณากรอกราคาปลีก",
            product_required: "กรุณาเลือกสินค้า",
            saved: "บันทึกเทมเพลตสำเร็จ",
            items_saved: "บันทึกรายการราคาสำเร็จ",
            select_hint: "เลือกเทมเพลตจากตารางด้านซ้าย เพื่อแก้ไขรายการราคา",
            empty_templates: "ยังไม่มีเทมเพลตราคา — กดปุ่ม \"เพิ่มเทมเพลต\" มุมขวาบนเพื่อเริ่มต้น",
            empty_items: "ยังไม่มีรายการราคาในเทมเพลตนี้ — เลือกสินค้าและใส่ราคา แล้วกด \"เพิ่มรายการ\"",
            no_products: "ยังไม่มีสินค้าในระบบ Modern Trade",
            no_products_hint: "ต้องเพิ่มสินค้าที่หน้า \"สินค้า MT\" ก่อน จึงจะตั้งราคาพิเศษในเทมเพลตได้",
            no_products_match: "ไม่พบสินค้าที่ตรงกับคำค้นหา",
            go_products: "ไปหน้าสินค้า MT",
            price_positive: "ราคาปลีกต้องมากกว่า 0",
            product_duplicate: "สินค้านี้มีอยู่ในเทมเพลตแล้ว",
            read_only: "คุณมีสิทธิ์ดูอย่างเดียว — ต้องมีสิทธิ์แก้ไข Modern Trade จึงจะเพิ่ม/แก้ไข/ลบเทมเพลตราคาได้",
            load_failed: "โหลดเทมเพลตราคาไม่สำเร็จ",
            products_load_failed: "โหลดรายการสินค้า MT ไม่สำเร็จ",
            products_load_failed_hint: "ตรวจสอบการเชื่อมต่อ แล้วกด \"ลองใหม่\" อีกครั้ง",
            retry: "ลองใหม่",
        },
        sale_order: {
            title: "ใบสั่งซื้อ",
            detail_title: "รายละเอียดใบสั่งซื้อ",
            create: "สร้างใบสั่งซื้อ",
            so_no: "เลขที่ใบสั่งซื้อ",
            created_at: "สร้างเมื่อ",
            company: "บริษัท",
            sale_type: "ประเภทการขาย",
            sale_type_consignment: "ฝากขาย",
            sale_type_outright: "ขายขาด",
            shipping_type: "ประเภทการจัดส่ง",
            shipping_type_pack: "ส่งจากห้องแพ็ค",
            shipping_type_factory: "ส่งจากโรงงาน",
            shipping_type_express: "ห้องแพ็คฝากส่ง (MDF Express)",
            po_number: "เลขที่ PO",
            po_file: "ไฟล์ PO",
            upload_po: "อัพโหลดเอกสาร PO",
            download_po: "ดาวน์โหลด PO",
            note: "หมายเหตุ",
            items: "รายการสินค้า",
            product: "สินค้า",
            qty: "จำนวน",
            retail_price: "ราคาปลีก",
            unit_price: "ราคาต่อหน่วย",
            estimate: "ประมาณการ",
            estimate_note: "ราคาเป็นการประมาณการ ระบบจะคำนวณราคาจริงหลังบันทึก",
            price_source_template: "ราคาตามเทมเพลตบริษัท",
            price_source_default: "ราคาเริ่มต้นสินค้า",
            gp_percent: "GP %",
            discount: "ส่วนลด",
            bill_discount: "ส่วนลดท้ายบิล",
            amount: "จำนวนเงิน",
            sub_total: "ยอดรวม",
            vat_amount: "ภาษีมูลค่าเพิ่ม",
            net_amount: "ยอดสุทธิ",
            status: "สถานะ",
            status_draft: "ร่าง",
            status_confirmed: "ยืนยันแล้ว",
            status_in_production: "กำลังผลิต",
            status_goods_received: "รับสินค้าแล้ว",
            status_delivered: "ส่งของแล้ว",
            status_closed: "ปิดใบ",
            status_cancelled: "ยกเลิก",
            tracking: "เลขพัสดุ",
            bo_order: "BO Order",
            shipping_team_note: "การจัดส่งแบบนี้สร้างออเดอร์เข้าห้องแพ็คจากใบส่งของได้ — เปิดใบส่งของแล้วกด \"สร้างออเดอร์เข้าห้องแพ็ค\" ห้องแพ็คจะตัดสต็อกและคืนเลขพัสดุมาที่ออเดอร์ · ถ้าเลือกที่จะไม่สร้างออเดอร์ ต้องไปตัดสต็อกใน WMS เองและนำเลขพัสดุมากรอกที่ใบส่งของ",
            confirm: "ยืนยันใบสั่งซื้อ",
            cancel: "ยกเลิกใบสั่งซื้อ",
            confirm_confirm: "ยืนยันใบสั่งซื้อนี้? ราคาจะถูกล็อก",
            cancel_confirm: "ยืนยันการยกเลิกใบสั่งซื้อนี้?",
            close: "ปิดใบ",
            close_confirm: "ยืนยันการปิดใบสั่งขายนี้? \"ปิดใบ\" เป็นสถานะสุดท้าย — หลังจากนี้จะแก้ไข ยกเลิก บันทึกรับเงิน หรือสร้างเอกสารเพิ่มไม่ได้อีก",
            closed: "ปิดใบสำเร็จ",
            closed_banner: "ใบสั่งขายนี้ปิดใบแล้ว",
            closed_banner_hint: "แก้ไขข้อมูลไม่ได้อีก (ดู/พิมพ์เอกสารได้ตามปกติ)",
            production_orders: "ใบสั่งผลิต",
            gen_production_orders: "สร้างใบสั่งผลิต",
            production_order_pdf: "PDF ใบสั่งผลิต",
            mo_status_issued: "ออกแล้ว",
            mo_status_received: "รับแล้ว",
            lot_template: "Excel กรอก Lot/Expire",
            goods_import: "นำเข้าสินค้า (Lot/Expire)",
            received_lots: "ล็อตที่รับเข้า",
            qty_received: "รับเข้า",
            qty_delivered: "ส่งแล้ว",
            qty_available: "คงเหลือ",
            deliveries: "ใบส่งของ",
            create_delivery: "สร้างใบส่งของ",
            delivery_date: "วันที่ส่ง",
            delivery_pdf: "PDF ใบส่งของ",
            lot_no: "Lot No.",
            expired_date: "วันหมดอายุ",
            available: "คงเหลือ",
            consignment_invoice_info: "ใบกำกับภาษีสำหรับฝากขายออกจากหน้า Invoices ตามยอดขายจริง",
            company_required: "กรุณาเลือกบริษัท",
            sale_type_required: "กรุณาเลือกประเภทการขาย",
            shipping_type_required: "กรุณาเลือกประเภทการจัดส่ง",
            po_number_required: "กรุณากรอกเลขที่ PO",
            po_file_required: "กรุณาเลือกไฟล์ PO",
            po_file_too_large: "ไฟล์มีขนาดเกิน 10MB",
            items_required: "กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ",
            no_price: "ไม่พบราคาสินค้านี้ ไม่สามารถเพิ่มลงใบสั่งซื้อได้",
            unmapped_sku_block: "มีสินค้าที่ยังไม่ได้เชื่อม WMS ไม่สามารถสร้าง BO order ได้",
            edit_draft_only: "แก้ไขได้เฉพาะใบสั่งซื้อสถานะร่างเท่านั้น",
            saved: "บันทึกใบสั่งซื้อสำเร็จ",
            confirmed: "ยืนยันใบสั่งซื้อสำเร็จ",
            cancelled: "ยกเลิกใบสั่งซื้อสำเร็จ",
            po_date: "วันที่ PO",
            customer: "ลูกค้า",
            view_customer: "รายละเอียดลูกค้า",
            created_from: "สร้างตั้งแต่",
            created_to: "ถึง",
            created_date_range: "ช่วงวันที่สร้าง",
            view_pdf: "ดู PDF",
            product_detail: "รายละเอียดสินค้า",
            tab_items: "รายการสินค้า",
            tab_warehouse: "คลังสินค้า",
            tab_finance: "การเงิน",
            // แท็บคลังสินค้าของใบร่าง/ใบยกเลิก ยังไม่มีการ์ดใดแสดงเลย
            warehouse_empty: "ใบสั่งขายที่ยังเป็นแบบร่างหรือถูกยกเลิก ยังไม่มีข้อมูลคลังสินค้า",
            no_sku_badge: "ยังไม่มีรหัส SKU",
            no_sku_hint: "สินค้าที่ยังไม่มีรหัส SKU (ยังไม่เชื่อมคลังสินค้า) จะแสดงป้ายสีแดง",
            no_sku_confirm_title: "สินค้านี้ยังไม่มีรหัส SKU",
            no_sku_confirm_text: "สินค้ายังไม่ได้เชื่อมกับคลังสินค้า (WMS) จะเพิ่มลงใบสั่งซื้อต่อหรือไม่? กรุณาเชื่อมรหัส SKU ที่หน้าสินค้า Modern Trade ก่อนส่งของ",
        },
        invoice: {
            title: "ใบกำกับภาษี",
            tab_invoices: "ใบกำกับภาษี",
            create: "ออกใบกำกับภาษี",
            doc_no: "เลขที่ใบกำกับ",
            company: "บริษัท",
            invoice_date: "วันที่ออกใบ",
            due_date: "วันครบกำหนด",
            credit_term_days: "เครดิต (วัน)",
            sale_order: "ใบสั่งซื้อ",
            sales_batch: "รอบยอดขาย",
            source: "ที่มา",
            source_outright: "ขายขาด",
            source_consignment: "ฝากขาย",
            sub_total: "มูลค่าก่อน VAT",
            bill_discount: "ส่วนลดท้ายบิล",
            vat_amount: "ภาษีมูลค่าเพิ่ม",
            net_amount: "ยอดสุทธิ",
            paid_amount: "รับแล้ว",
            outstanding: "ค้างรับ",
            status: "สถานะ",
            status_unpaid: "ยังไม่รับเงิน",
            status_partial: "รับบางส่วน",
            status_paid: "รับครบแล้ว",
            status_cancelled: "ยกเลิก",
            pdf: "PDF ใบกำกับภาษี",
            cancel: "ยกเลิกใบกำกับ",
            cancel_confirm: "ยืนยันการยกเลิกใบกำกับนี้? เลขที่จะไม่ถูกนำกลับมาใช้",
            issue: "ออกใบกำกับภาษี",
            date_from: "ตั้งแต่",
            date_to: "ถึง",
            created: "ออกใบกำกับภาษีสำเร็จ",
            cancelled: "ยกเลิกใบกำกับสำเร็จ",
            // #303: ใบกำกับที่อยู่ใต้ SO ที่ปิดใบแล้ว — แก้ไม่ได้อีก
            so_closed_hint: "ใบสั่งขายของใบกำกับนี้ปิดใบแล้ว ไม่สามารถยกเลิกใบกำกับหรือแก้ไขการรับเงินได้อีก",
            // round-19 §2 — ออกใบกำกับจากประวัติรับเงิน + ยกเลิกพร้อมเหตุผล
            issue_confirm: "ออกใบกำกับภาษีจากยอดรับเงินที่ยังไม่ได้ออกใบ {amount} บาท?",
            issued: "ออกใบกำกับภาษีสำเร็จ",
            cancel_hint: "ยกเลิกใบกำกับได้แม้มีการรับเงินแล้ว — ระบบจะปลดการรับเงินกลับเข้ายอดรอออกใบ (ไม่ลบประวัติ)",
            cancel_reason_placeholder: "เหตุผลการยกเลิก (ไม่บังคับ)",
            cancel_reason: "เหตุผลการยกเลิก",
            cancel_no_so_warning: "ใบกำกับนี้เป็นแบบฝากขาย ไม่ได้ผูกกับใบสั่งขาย — ยอดรับเงินจะถูกปลดออกแต่จะไม่กลับเข้ายอดรอออกใบของใบสั่งขายใด (ประวัติการรับเงินไม่หาย)",
        },
        payment: {
            title: "การรับเงิน",
            record: "บันทึกรับเงิน",
            after_delivery_hint: "บันทึกรับเงินได้หลังส่งของแล้ว — บันทึกเป็นประวัติการรับเงิน แล้วกดออกใบกำกับภาษีภายหลัง",
            closed_no_more: "ใบสั่งขายนี้ปิดใบแล้ว — บันทึกรับเงินเพิ่มไม่ได้",
            // spec 2026-08-13: ปลายทางเปลี่ยนเป็นหน้า "รับเงินฝากขาย" (เงินผูกกับบริษัทคู่ค้า)
            // และใบกำกับภาษีออกจาก "รายการรับเงินที่เลือก" ที่หน้านั้นเลย
            consignment_hint: "ฝากขาย: รับเงินตามยอดขายจริง — บันทึกรับเงินที่หน้า \"รับเงินฝากขาย\" แล้วเลือกรายการรับเงินเพื่อออกใบกำกับภาษีที่หน้านั้น",
            consignment_link: "ไปที่หน้ารับเงินฝากขาย",
            auto_invoice_hint: "เมื่อบันทึกรับเงิน ระบบจะสร้างใบกำกับภาษีเต็มยอดส่งของให้อัตโนมัติ",
            history_hint: "บันทึกเป็นประวัติการรับเงินก่อน — เมื่อพร้อมแล้วกด \"ออกใบกำกับภาษี\" เพื่อออกใบจากยอดที่รับมา",
            slip: "สลิป",
            slip_choose: "แนบสลิป",
            slip_view: "ดูสลิป",
            slip_hint: "รองรับ JPG / PNG / WEBP / PDF ขนาดไม่เกิน 10MB",
            slip_bad_type: "ชนิดไฟล์ไม่รองรับ — ต้องเป็น JPG / PNG / WEBP หรือ PDF",
            slip_too_big: "ไฟล์ใหญ่เกิน 10MB",
            slip_upload_failed: "อัปโหลดสลิปไม่สำเร็จ",
            amount: "จำนวนเงิน",
            paid_date: "วันที่รับเงิน",
            method: "วิธีชำระ",
            method_cash: "เงินสด",
            method_transfer: "โอนเงิน",
            method_cheque: "เช็ค",
            method_other: "อื่น ๆ",
            note: "หมายเหตุ",
            history: "ประวัติการรับเงิน",
            delete: "ลบรายการรับเงิน",
            delete_confirm: "ยืนยันการลบรายการรับเงินนี้?",
            amount_required: "กรุณากรอกจำนวนเงิน",
            amount_positive: "จำนวนเงินต้องมากกว่า 0",
            date_required: "กรุณาเลือกวันที่รับเงิน",
            over_net: "ยอดรับเงินรวมเกินยอดสุทธิของใบกำกับ",
            outstanding: "ยอดคงค้าง",
            exceeds_outstanding: "จำนวนเงินเกินยอดคงค้าง (สูงสุด {amount} บาท)",
            recorded: "บันทึกรับเงินสำเร็จ",
            deleted: "ลบรายการรับเงินสำเร็จ",
        },
        // spec 2026-08-13 (รอบบ่าย) — ฝากขาย: รับเงินผูกกับบริษัทคู่ค้า
        // แล้วออกใบกำกับภาษี "ตามเงินที่รับจริง" จากรายการรับเงินที่เลือก
        consignment_payment: {
            title: "รับเงินฝากขาย",
            subtitle: "คู่ค้าโอนเงินมาตามยอดที่ขายได้ — บันทึกรับเงินผูกกับบริษัท แล้วเลือกรายการรับเงินเพื่อออกใบกำกับภาษีตามยอดเงินที่รับจริง",
            company: "บริษัทคู่ค้า",
            all_companies: "ทุกบริษัท",
            date_from: "รับเงินตั้งแต่",
            date_to: "ถึง",
            link_status: "สถานะการผูกใบกำกับ",
            status_all: "ทั้งหมด",
            status_unlinked: "รอออกใบ",
            status_linked: "ผูกใบแล้ว",
            total_received: "ยอดรับทั้งหมด",
            unlinked_amount: "รอออกใบ (กองเงิน)",
            unbilled_sales_amount: "ยอดขายที่ยังออกใบได้",
            unbilled_hint: "ยอดขายจริงที่ยังไม่ถูกออกใบ (รวม VAT แล้ว เทียบกับเงินที่รับได้ตรง ๆ) — เป็นเพดานตอนออกใบ ไม่ใช่เพดานตอนบันทึกรับเงิน",
            last_paid_date: "รับเงินล่าสุด",
            summary_all_hint: "รวมทุกบริษัทที่มีความเคลื่อนไหว",
            record: "บันทึกรับเงิน",
            record_title: "บันทึกรับเงินฝากขาย",
            paid_date: "วันที่รับเงิน",
            amount: "จำนวนเงิน",
            method: "วิธีชำระ",
            note: "หมายเหตุ",
            slip: "สลิป",
            invoice: "ใบกำกับที่ผูก",
            pending_invoice: "รอออกใบ",
            created_by: "ผู้บันทึก",
            no_cap_hint: "บันทึกได้ตามยอดที่คู่ค้าโอนมาจริง ไม่มีเพดาน",
            no_data: "ไม่มีข้อมูล",
            company_required: "กรุณาเลือกบริษัทคู่ค้า",
            amount_required: "กรุณากรอกจำนวนเงินให้มากกว่า 0",
            date_required: "กรุณาเลือกวันที่รับเงิน",
            recorded: "บันทึกรับเงินสำเร็จ",
            link: "ผูกใบกำกับ",
            link_title: "ผูกเงินรับเข้ากับใบกำกับภาษี",
            link_hint: "เลือกใบกำกับภาษีฝากขายของบริษัทเดียวกันที่ยังไม่ยกเลิกและยังรับเงินไม่ครบ (ไม่ซอยยอด — ต้องผูกเต็มจำนวนของรายการรับเงิน)",
            link_amount: "ยอดที่จะผูก",
            link_none: "ไม่มีใบกำกับภาษีฝากขายของบริษัทนี้ที่ยังรับเงินไม่ครบ",
            linked: "ผูกใบกำกับสำเร็จ",
            unlink: "ปลดการผูก",
            unlink_confirm: "ยืนยันปลดการผูกใบกำกับของรายการรับเงินนี้? เงินจะกลับเข้ากองรอออกใบของบริษัท",
            unlinked: "ปลดการผูกสำเร็จ",
            invoice_remaining: "คงเหลือ",
            invoice_select_required: "กรุณาเลือกใบกำกับภาษี",
            delete_confirm: "ยืนยันการลบรายการรับเงินนี้?",
            deleted: "ลบรายการรับเงินสำเร็จ",
            exceeds: "ผูกไม่ได้ — ยอดรับเงินรวมจะเกินยอดสุทธิของใบกำกับ",
            wrong_type: "รายการนี้ไม่ใช่เงินรับฝากขาย จึงผูก/ปลดที่หน้านี้ไม่ได้",
            // ── ออกใบกำกับภาษีจากรายการรับเงินที่เลือก (money-driven) ──────────────
            issue_selected: "ออกใบกำกับภาษีจากรายการที่เลือก",
            selected_count: "เลือกแล้ว {count} รายการ",
            selected_amount: "ยอดรวมที่เลือก",
            selectable_sales: "ยอดขายที่ยังออกใบได้",
            issue_hint: "ติ๊กเลือกรายการรับเงินที่ยังไม่ผูกใบของบริษัทเดียวกัน แล้วกดออกใบกำกับภาษี — ใบจะออกตามยอดเงินที่เลือกพอดี",
            issue_ready: "รายการสินค้าบนใบจะดึงจากยอดขายจริงที่ยังไม่ออกใบ เรียงเก่าก่อน",
            issue_cross_company: "เลือกข้ามบริษัทไม่ได้ — 1 ใบกำกับภาษีต่อ 1 บริษัท กรุณาเลือกเฉพาะรายการของบริษัทเดียวกัน",
            issue_need_selection: "กรุณาเลือกรายการรับเงินอย่างน้อย 1 รายการ",
            issue_over_sales: "ยอดที่เลือกมากกว่ายอดขายที่ยังออกใบได้ ({amount}) — ต้องลดรายการที่เลือกก่อน ไม่เช่นนั้นระบบจะไม่ออกใบให้",
            issue_confirm_title: "ออกใบกำกับภาษีจากรายการที่เลือก?",
            issue_confirm: "ออกใบกำกับภาษีของ {company} ยอด {amount} บาท จากรายการรับเงิน {count} รายการ — รายการสินค้าจะดึงจากยอดขายจริงที่ยังไม่ออกใบ เรียงเก่าก่อน",
            issued_title: "ออกใบกำกับภาษีสำเร็จ",
            issued: "ใบกำกับภาษีเลขที่ {doc_no} ยอดสุทธิ {amount} บาท — รายการรับเงินที่เลือกถูกผูกกับใบนี้แล้ว",
            insufficient_sales_title: "ยอดขายที่ยังออกใบได้ไม่พอ",
            insufficient_sales: "ยอดขายที่ยังออกใบได้ไม่พอกับยอดเงินที่เลือก กรุณาลดรายการที่เลือกแล้วลองใหม่",
            max_issuable: "ออกใบได้สูงสุด {amount} บาท",
            no_sales_yet: "ยังไม่มียอดขายที่ออกใบกำกับภาษีได้ — บันทึกหรือนำเข้าข้อมูลการขายของบริษัทนี้ก่อน",
            over_invoiced: "ยอดขายของบริษัทนี้ถูกออกใบกำกับภาษีไปหมดแล้ว (ยอดขาย {sales} บาท / ออกใบไปแล้ว {invoiced} บาท) — ถ้าราคาถูกแก้ย้อนหลัง ให้ตรวจสอบหรือยกเลิกใบกำกับภาษีที่ออกไปแล้วก่อน",
            skipped_unpriced_note: "มีสินค้า {count} รายการที่ยังไม่ได้ผูกกับสินค้า MT หรือไม่มีราคา จึงไม่ถูกนับเป็นยอดขาย: {products}",
            skipped_unpriced_badge: "ไม่มีราคา {count} รายการ",
            skipped_unpriced_card_hint: "มีสินค้า {count} รายการที่ยังไม่ได้ผูกกับสินค้า MT หรือไม่มีราคา ยอดนี้จึงต่ำกว่ายอดขายจริงของบริษัท",
            unpriced_blocked_title: "ต้องตั้งราคาสินค้าก่อนจึงออกใบได้",
            unpriced_blocked: "บริษัทนี้มียอดขายของสินค้าที่ยังไม่ได้ผูกกับสินค้า MT หรือไม่มีราคา และเคยออกใบกำกับภาษีไปแล้ว — ต้องผูก/ตั้งราคาสินค้าเหล่านี้ให้ครบก่อน แล้วจึงออกใบกำกับภาษี",
            payment_not_eligible: "รายการรับเงินที่เลือกออกใบไม่ได้ — อาจถูกผูกใบไปแล้ว เป็นของบริษัทอื่น หรือไม่ใช่เงินรับฝากขาย กรุณาเลือกใหม่",
            reason_already_linked: "ผูกกับใบกำกับภาษีไปแล้ว",
            reason_wrong_company: "เป็นเงินของบริษัทอื่น",
            reason_wrong_payment_type: "เป็นเงินของใบสั่งขาย (ขายขาด)",
            reason_no_company: "ไม่ระบุบริษัทคู่ค้า",
            reason_not_found: "ไม่พบรายการรับเงินนี้",
            reason_bad_amount: "จำนวนเงินไม่ถูกต้อง",
            no_company: "(ไม่ระบุบริษัท)",
            no_company_short: "ไม่มีบริษัท — ผูกใบไม่ได้",
            state_changed: "รายการนี้เพิ่งถูกแก้ไขโดยผู้ใช้อื่น — รีเฟรชหน้าจอแล้วลองใหม่",
            no_company_hint: "รายการเก่าที่ไม่มีบริษัทคู่ค้า — ออกใบกำกับภาษีหรือผูกใบไม่ได้ ต้องแก้ข้อมูลก่อน",
        },
        report_sales: {
            title: "รายงานยอดขาย",
            date_from: "ตั้งแต่",
            date_to: "ถึง",
            company: "บริษัท",
            group_by: "จัดกลุ่มตาม",
            group_by_company: "ตามบริษัท",
            group_by_product: "ตามสินค้า",
            group_by_invoice: "ตามใบกำกับ",
            overall: "ภาพรวม",
            sub_total: "ยอดก่อน VAT",
            vat_amount: "ภาษีมูลค่าเพิ่ม",
            net_amount: "ยอดสุทธิ",
            paid_amount: "รับแล้ว",
            outstanding: "ค้างรับ",
            invoice_count: "จำนวนใบกำกับ",
            export_xlsx: "ส่งออก Excel",
            no_data: "ไม่มีข้อมูล",
        },
        report_stock_value: {
            title: "รายงานมูลค่าคงเหลือ",
            company: "บริษัท",
            product: "สินค้า",
            lot_no: "Lot No.",
            expired_date: "วันหมดอายุ",
            qty: "จำนวน",
            unit_price: "ราคาต่อหน่วย",
            value: "มูลค่า",
            total_value: "มูลค่ารวม",
            no_price: "ไม่มีราคา",
            drill_down: "แยกตามสินค้า",
            export_xlsx: "ส่งออก Excel",
            no_data: "ไม่มีข้อมูล",
        },
        // #166 — ตั้งค่ารูปแบบเอกสาร (ใบสั่งผลิต/ใบส่งของ/ใบกำกับภาษี)
        doc_format: {
            title: "ตั้งค่ารูปแบบเอกสาร",
            subtitle: "ปรับแต่งรูปแบบเอกสาร PDF ที่พิมพ์จากระบบ (กระดาษ A4)",
            doc_type: "ประเภทเอกสาร",
            doc_type_production: "ใบสั่งผลิต",
            doc_type_delivery: "ใบส่งของ",
            doc_type_invoice: "ใบกำกับภาษี",
            section_appearance: "รูปลักษณ์เอกสาร",
            header_color: "สีหัวตาราง",
            show_logo: "แสดงโลโก้",
            show_stamp: "แสดงตราประทับ/ลายเซ็น",
            section_header_fields: "ฟิลด์ส่วนหัวเอกสาร",
            section_columns: "คอลัมน์ตารางสินค้า",
            section_summary: "แถวสรุปยอด",
            show_summary: "แสดงแถวสรุปยอด",
            section_footer: "ส่วนท้ายเอกสาร",
            footer_note: "หมายเหตุท้ายเอกสาร",
            sign_left_label: "ป้ายลายเซ็นซ้าย",
            sign_right_label: "ป้ายลายเซ็นขวา",
            col_show: "แสดง",
            col_label: "ชื่อที่แสดง",
            field: "ฟิลด์",
            column: "คอลัมน์",
            reset: "คืนค่าเริ่มต้น",
            save: "บันทึก",
            saved: "บันทึกรูปแบบเอกสารแล้ว",
            load_error: "ไม่สามารถโหลดการตั้งค่าได้",
            save_error: "ไม่สามารถบันทึกได้",
            // header field keys
            f_doc_no: "เลขที่เอกสาร",
            f_doc_date: "วันที่เอกสาร",
            f_date: "วันที่เอกสาร",
            f_do_no: "เลขที่ใบส่งของ",
            f_credit_term: "เครดิตเทอม",
            f_seller: "ผู้ขาย",
            f_customer: "ลูกค้า",
            f_tax_id: "เลขผู้เสียภาษี",
            f_branch: "สาขา",
            f_po_no: "เลขที่ใบสั่งซื้อ",
            f_po_ref: "เลขที่ PO อ้างอิง",
            f_po_number: "เลขที่ใบสั่งซื้อ (PO)",
            f_ship_method: "วิธีการจัดส่ง",
            f_tracking: "เลขพัสดุ (Tracking)",
            f_due_date: "วันครบกำหนด",
            // product column keys
            c_no: "ลำดับ",
            c_code: "รหัสสินค้า",
            c_name: "ชื่อสินค้า",
            c_size: "ขนาด",
            c_unit: "หน่วย",
            c_lot: "Lot No",
            c_exp: "วันหมดอายุ",
            c_qty: "จำนวน",
            c_unit_price: "ราคาต่อหน่วย",
            c_discount: "ส่วนลด",
            c_amount: "จำนวนเงิน",
            // #304 — ใบกำกับภาษี: รหัสสินค้าไม่ใช่คอลัมน์แยกแล้ว เหลือแค่ toggle นำหน้าชื่อ
            c_code_invoice: "แสดงรหัสสินค้านำหน้าชื่อรายการ",
            c_code_invoice_hint: "ตั้งชื่อคอลัมน์ไม่ได้ — ติ๊กออกเพื่อพิมพ์เฉพาะชื่อสินค้าโดยไม่มีรหัสนำหน้า",
            invoice_merged_hint: "ใบกำกับภาษีรวม \"รหัสสินค้า\" กับ \"ชื่อสินค้า\" เป็นคอลัมน์เดียว (เช่น P-075 - ชื่อสินค้า) ชื่อคอลัมน์ให้ตั้งที่แถว \"ชื่อสินค้า\"",
            // summary row keys
            s_subtotal: "รวมเป็นเงิน",
            s_discount: "ส่วนลด",
            s_vat: "ภาษีมูลค่าเพิ่ม",
            s_grand_total: "จำนวนเงินรวมทั้งสิ้น",
        },
        // #183 — หน้าตัวอย่างพิมพ์เอกสารเต็มจอ (SO/MO/DO/IV, ต้นฉบับ/สำเนา + จำนวนชุด)
        print_preview: {
            title: "ตัวอย่างเอกสาร",
            close_window: "ปิดหน้าต่าง",
            print: "พิมพ์",
            download: "ดาวน์โหลด",
            original: "ต้นฉบับ",
            copy: "สำเนา",
            copies: "จำนวนชุด",
            document: "เอกสาร",
            loading: "กำลังโหลด...",
            no_docs: "กรุณาเลือกเอกสารที่ต้องการพิมพ์",
            // เตือนเมื่อกดปุ่มพิมพ์เอกสารที่ใบสั่งขายนี้ยังไม่มี แล้วระบบติ๊กตัวสำรองให้แทน
            doc_not_available: "ใบสั่งขายนี้ยังไม่มี{doc} — แสดง{fallback}แทน",
            doc_so: "ใบสั่งขาย",
            doc_invoice: "ใบกำกับภาษี",
            doc_delivery: "ใบส่งของ",
            doc_production: "ใบสั่งผลิต",
        },
        // round-19 Dev-B — สถานะส่งของใบส่งของ (ห้องแพ็ค)
        delivery: {
            // #504/#505 — สร้างออเดอร์เข้าห้องแพ็คจากใบส่งของ
            // ออกใบส่งของไม่ตัดสต็อกแล้ว ของจะถูกกันตอนกดปุ่มนี้เท่านั้น
            bo_order: {
                column: "ออเดอร์ห้องแพ็ค",
                create_action: "สร้างออเดอร์เข้าห้องแพ็ค",
                view_action: "ดูออเดอร์ #{id}",
                dialog_title: "สร้างออเดอร์เข้าห้องแพ็ค",
                loading: "กำลังตรวจสอบ...",
                recipient: "ผู้รับ",
                recipient_phone: "เบอร์ติดต่อ",
                recipient_empty: "(ยังไม่มีข้อมูลผู้รับ)",
                shipping_provider: "บริษัทขนส่ง",
                shipping_provider_placeholder: "เลือกบริษัทขนส่ง",
                shipping_provider_required: "กรุณาเลือกบริษัทขนส่งก่อน",
                shipping_provider_locked: "ใบสั่งขายฝากส่ง ระบบบังคับใช้บริษัทขนส่งนี้",
                lines_title: "รายการที่จะถูกกันออกจากสต็อก",
                lines_note: "จำนวนนี้มาจากระบบหลังบ้าน ไม่ได้คำนวณที่หน้าจอ — เป็นจำนวนที่จะถูกกันจริง",
                col_product: "สินค้าในคลัง (WMS)",
                col_barcode: "บาร์โค้ด",
                col_qty: "จำนวน",
                col_mt_codes: "รหัสสินค้า MT",
                no_lines: "ไม่มีรายการที่จะกันสต็อก",
                // #240 — รายละเอียดบรรทัดที่ LOT/วันหมดอายุไม่ครบ (จาก missing_lots ของ BE)
                missing_lots_title: "บรรทัดที่ต้องแก้ก่อนสร้างออเดอร์",
                missing_lots_count: "{count} บรรทัด",
                col_line: "บรรทัดที่",
                col_product: "สินค้า",
                col_lot: "LOT",
                col_problem: "ปัญหาที่ต้องแก้",
                lot_empty: "(ยังไม่ระบุ LOT)",
                problem_missing_lot: "ยังไม่ระบุ LOT",
                problem_missing_expire: "ไม่มีวันหมดอายุ",
                fix_missing_lot: "แก้ที่บรรทัดนี้ในใบส่งของ — ต้องเลือกล็อตให้ก่อน",
                fix_missing_expire: "แก้ที่ล็อตที่รับเข้า — เติมวันหมดอายุของ LOT นี้",
                confirm_warning: "ยืนยันแล้วจำนวนนี้จะถูกกันออกจากสต็อกที่ส่งขึ้นแพลตฟอร์มทันที",
                confirm_action: "ยืนยันสร้างออเดอร์",
                created: "สร้างออเดอร์เข้าห้องแพ็คแล้ว",
                created_detail: "ออเดอร์ #{id} · {status}",
                tracking_pending: "กำลังขอเลขพัสดุ",
                status_111: "รอตัดรอบส่งสินค้า",
                // เส้นกรอกเลขพัสดุเอง: DO ที่ไม่ได้สร้างออเดอร์ ระบบไม่ตัดสต็อกให้เลย
                manual_ship_warning: "ระบบไม่ตัดสต็อกให้ ต้องไปตัดใน WMS เอง",
                manual_ship_hint: "ใบส่งของที่ไม่ได้กดสร้างออเดอร์เข้าห้องแพ็ค ระบบจะไม่ตัดสต็อกให้เลย เจ้าหน้าที่ต้องไปตัดใน WMS เอง",
                locked_by_order: "ใบส่งของนี้ส่งผ่านออเดอร์ #{id} — เลขพัสดุและสถานะการส่งเป็นของออเดอร์ ไม่ใช่ของใบส่งของ",
                reason: {
                    ok: "สร้างออเดอร์ได้",
                    already_created: "ใบส่งของนี้สร้างออเดอร์ไว้แล้ว",
                    stock_already_cut: "ออเดอร์เดิมของใบนี้ตัดสต็อกไปแล้ว สร้างใหม่ไม่ได้",
                    shipped_manually: "ใบส่งของนี้ทำเครื่องหมายว่าส่งของแล้ว",
                    missing_wms_mapping: "มีสินค้าที่ยังไม่ผูกกับสินค้าในคลัง (WMS)",
                    missing_lot_expire: "มีบรรทัดที่ยังไม่ระบุ LOT หรือวันหมดอายุ",
                    not_applicable: "ใบส่งของนี้ไม่เข้าเงื่อนไขสร้างออเดอร์",
                    setting_missing: "ยังไม่ได้ตั้งค่าช่องทางการขาย / วิธีชำระเงินของ Modern Trade",
                    legacy_bo_order: "ใบสั่งขายนี้ผูกกับออเดอร์เดิมอยู่แล้ว",
                    unknown: "สร้างออเดอร์ไม่ได้",
                },
            },
            ship_status: {
                label: "สถานะส่งของ",
                pending: "รอส่งของ",
                shipped: "ส่งของแล้ว",
                edit_action: "แก้ไขสถานะ/เลขพัสดุ",
                dialog_title: "อัปเดตสถานะส่งของ / เลขพัสดุ",
                tracking_number: "เลข Tracking",
                tracking_placeholder: "กรอกเลข Tracking (ถ้ามี)",
                shipped_by: "ผู้ทำเครื่องหมาย",
                shipped_at: "เวลาที่ส่ง",
                saved: "อัปเดตสถานะส่งของสำเร็จ",
                confirm_shipped: "ยืนยันว่าส่งของใบนี้แล้ว?",
            },
        },
        // round-19 Dev-B — บันทึกการตรวจสอบ (Audit Log)
        audit: {
            title: "บันทึกการตรวจสอบ",
            menu: "บันทึกการตรวจสอบ",
            filter_entity_type: "ประเภทข้อมูล",
            filter_action: "การกระทำ",
            filter_actor: "ผู้ทำรายการ (ID)",
            filter_doc_no: "เลขเอกสาร",
            date_from: "ตั้งแต่วันที่",
            date_to: "ถึงวันที่",
            search: "ค้นหา",
            reset: "ล้างตัวกรอง",
            all: "ทั้งหมด",
            col_time: "เวลา",
            col_actor: "ผู้ทำรายการ",
            col_action: "การกระทำ",
            col_entity: "ประเภทข้อมูล",
            col_doc_no: "เลขเอกสาร",
            col_detail: "รายละเอียด",
            view_detail: "ดูรายละเอียด",
            diff_title: "รายละเอียดการเปลี่ยนแปลง",
            diff_field: "ฟิลด์",
            diff_old: "ค่าเดิม",
            diff_new: "ค่าใหม่",
            no_change: "ไม่มีการเปลี่ยนแปลงฟิลด์",
            created_label: "สร้างใหม่",
            deleted_label: "ลบ/ยกเลิก",
            no_data: "ไม่พบข้อมูล",
            empty_value: "(ว่าง)",
            entity_sale_order: "ใบสั่งขาย",
            entity_invoice: "ใบกำกับภาษี",
            entity_payment: "การรับเงิน",
            entity_delivery: "ใบส่งของ",
            entity_product: "สินค้า",
            entity_price_template: "เทมเพลตราคา",
            entity_company: "บริษัทคู่ค้า",
            entity_setting: "การตั้งค่า",
            action_so_create: "สร้างใบสั่งขาย",
            action_so_update: "แก้ไขใบสั่งขาย",
            action_so_confirm: "ยืนยันใบสั่งขาย",
            action_so_cancel: "ยกเลิกใบสั่งขาย",
            action_so_close: "ปิดใบสั่งขาย",
            action_delivery_create: "สร้างใบส่งของ",
            action_delivery_ship_status: "เปลี่ยนสถานะส่งของ",
            action_invoice_create: "ออกใบกำกับภาษี",
            action_invoice_cancel: "ยกเลิกใบกำกับภาษี",
            action_payment_create: "บันทึกรับเงิน",
            action_payment_link: "ผูกเงินรับกับใบกำกับ",
            action_payment_unlink: "ปลดการผูกเงินรับ",
            action_payment_delete: "ลบรายการรับเงิน",
            action_product_create: "เพิ่มสินค้า",
            action_product_update: "แก้ไขสินค้า",
            action_product_delete: "ลบสินค้า",
            action_product_import: "นำเข้าสินค้า",
            action_price_template_update: "แก้ไขเทมเพลตราคา",
            action_price_template_items: "แก้ไขราคาในเทมเพลต",
            action_company_update: "แก้ไขบริษัทคู่ค้า",
            action_setting_update: "แก้ไขการตั้งค่า",
        },
    },
    // Round-3 shared MT components (PdfFullscreenModal / CustomerDetailModal / ProductDetailPopup)
    mt_shared: {
        pdf_title: "เอกสาร PDF",
        download: "ดาวน์โหลด",
        close: "ปิด",
        loading: "กำลังโหลด...",
        pdf_error: "ไม่สามารถโหลดไฟล์ PDF ได้",
        no_pdf: "ไม่มีไฟล์ PDF",
        no_data: "ไม่มีข้อมูล",
        yes: "ใช่",
        no: "ไม่",
        days: "วัน",
        customer_detail: "รายละเอียดลูกค้า",
        product_detail: "รายละเอียดสินค้า",
        name: "ชื่อ",
        tax_id: "เลขประจำตัวผู้เสียภาษี",
        branch_code: "รหัสสาขา",
        address: "ที่อยู่",
        contact_name: "ผู้ติดต่อ",
        contact_phone: "เบอร์โทร",
        contact_email: "อีเมล",
        credit_term_days: "เครดิตเทอม",
        gp_percent: "GP (%)",
        vat_included: "ราคารวม VAT",
        product_name: "ชื่อสินค้า",
        wms_name: "ชื่อ WMS",
        sku_code: "SKU",
        barcode: "บาร์โค้ด",
        wms_not_linked: "ยังไม่เชื่อม WMS",
    },
    // #169 — BO admin promo notification composer
    promo_notification: {
        title: "แจ้งเตือนโปรโมชั่น",
        compose: "สร้างการแจ้งเตือน",
        compose_hint: "ส่งถึงสมาชิกทุกคน",
        field_title: "หัวข้อ",
        field_icon: "ไอคอน",
        field_body: "รายละเอียด",
        field_image: "รูปภาพ",
        field_link_type: "ลิงก์ไปยัง",
        field_link_ref: "อ้างอิงลิงก์",
        url_placeholder: "วาง URL หรืออัปโหลด",
        link_none: "ไม่มี",
        link_product: "สินค้า",
        link_coupon: "คูปอง",
        link_ref_product: "รหัสสินค้า (Product ID)",
        link_ref_coupon: "รหัสคูปอง (Coupon code)",
        audience_all: "ผู้รับ: สมาชิกทั้งหมด",
        send: "ส่ง",
        sent_ok: "ส่งการแจ้งเตือนแล้ว",
        sent_list: "ประวัติการส่ง",
        col_title: "หัวข้อ",
        col_link: "ลิงก์",
        col_recipients: "ผู้รับ",
        col_sent_at: "ส่งเมื่อ",
        confirm_title: "ยืนยันการส่ง",
        confirm_body: "ส่งการแจ้งเตือนนี้ถึงสมาชิกทุกคน?",
        err_title_required: "กรุณากรอกหัวข้อ",
        err_link_ref_required: "กรุณากรอกอ้างอิงลิงก์",
    },
    // shopee_to_seller — #260 "ส่งเข้า seller" บน /admin/product_platform
    // (spec docs/specs/2026-09-22-shopee-master-product-sync-design.md §6A)
    // amaze_push — #263 "sync ไป platform" + หน้าจับคู่หมวด platform (spec §6B.8)
    amaze_push: {
        btn_open: "Sync ไป Platform",
        title: "Sync สินค้าไป Platform",
        product: "สินค้า",
        platform_label: "ปลายทาง",
        btn_check: "ตรวจสอบ",
        btn_confirm: "ยืนยัน sync",
        btn_retry: "ลองใหม่",
        go_category_map: "ไปหน้าจับคู่หมวด platform",
        summary_name: "ชื่อที่จะส่ง",
        summary_action: "การกระทำ",
        summary_images: "จำนวนรูป",
        summary_models: "จำนวนตัวเลือก",
        summary_category: "หมวดปลายทาง",
        summary_brand: "แบรนด์",
        summary_parcel: "ขนาดพัสดุ · น้ำหนัก",
        sku_table: "รายการ SKU",
        col_sku_code: "รหัส SKU",
        col_sent_code: "รหัสที่ส่งจริง",
        col_action: "ส่ง/ข้าม",
        col_reason: "เหตุผล",
        warnings_title: "คำเตือน",
        warnings_dry_run: "จากการตรวจสอบ ยังไม่ได้ส่ง",
        rejected_title: "ส่งไม่ได้ — ต้องแก้ก่อน",
        // 200 + rejects = ยังส่งได้ แต่ SKU พวกนี้จะไม่ถูกส่งไปด้วย (§6B.3 ข้อ 7)
        skipped_title: "SKU ที่จะถูกข้าม",
        job_title: "งาน sync",
        platform_product_id: "รหัสสินค้าบน platform",
        badge_column: "สถานะ Amaze",
        badge_synced: "sync Amaze แล้ว",
        badge_edited_since_sync: "แก้ไขหลัง sync ล่าสุด",
        action: {
            create: "สร้างใหม่",
            update: "อัปเดตของเดิม"
        },
        platform: {
            amaze: "Amaze",
            makro: "Makro (Mirakl)",
            shopee: "Shopee",
            disabled_phase4: "ยังไม่รองรับ (อยู่ใน Phase 4)",
            disabled_source_only: "เป็นต้นทางสินค้า ไม่ใช่ปลายทาง",
            disabled_unknown: "ยังไม่รองรับ"
        },
        state: {
            none: "ยังไม่เคย sync",
            pushing: "กำลังส่ง…",
            reviewing: "ส่งแล้ว รอ platform รีวิว",
            live: "ขึ้นขายบน platform แล้ว",
            rejected: "platform ปฏิเสธสินค้านี้",
            failed: "sync ไม่สำเร็จ",
            unknown: "สถานะที่ระบบยังไม่รู้จัก"
        },
        step: {
            queued: "รอคิว",
            images: "อัปรูป",
            create: "สร้างสินค้า",
            link: "ผูกรหัส SKU",
            poll: "รอรีวิว",
            unknown: "ขั้นตอนที่ระบบยังไม่รู้จัก"
        },
        sku_action: {
            send: "ส่ง",
            skip: "ข้าม",
            unknown: "ไม่ทราบ"
        },
        reject: {
            sku_code_too_long_for_platform: "รหัส SKU ยาวเกินที่ platform รองรับ (เกิน 100 ตัวอักษร)",
            sku_code_invalid_chars: "รหัส SKU มีอักขระที่ใช้ไม่ได้ (ขึ้นบรรทัดใหม่ อักขระควบคุม หรือเว้นวรรคหัวท้าย)",
            category_not_mapped: "หมวดของสินค้านี้ยังไม่ได้จับคู่กับหมวดของ platform",
            missing_required_attribute: "ยังไม่ได้กรอกคุณสมบัติที่ platform บังคับของหมวดนี้",
            no_active_sku: "ไม่เหลือ SKU ที่ส่งได้เลย",
            unknown: "ส่งไม่ได้ด้วยเหตุผลที่ระบบยังไม่รู้จัก"
        },
        warning: {
            image_not_uploaded: "มีรูปที่ยังอัปขึ้น platform ไม่สำเร็จ จึงไม่ถูกส่งไปด้วย",
            sku_skipped: "มี SKU ที่ปิดการขายอยู่ จึงไม่ถูกส่งไปด้วย",
            attribute_defaulted: "มีคุณสมบัติที่ใช้ค่าตั้งต้นของหมวดแทนค่าที่กรอกเอง",
            unknown: "คำเตือนที่ระบบยังไม่รู้จัก"
        },
        error: {
            in_flight: "สินค้านี้มีงาน sync ค้างอยู่แล้ว ระบบกำลังติดตามงานเดิมให้",
            rejected: "ส่งไป platform ไม่ได้",
            payload_not_buildable: "ระบบประกอบข้อมูลที่จะส่งไม่ได้ ต้องแก้ข้อมูลสินค้าก่อน",
            category_not_mapped: "หมวดของสินค้านี้ยังไม่ได้จับคู่กับหมวดของ platform",
            platform_not_supported: "ยังไม่รองรับการส่งไป platform นี้",
            bad_request: "ข้อมูลที่ส่งไปไม่ถูกต้อง",
            amaze_disabled: "การเชื่อมต่อ Amaze ถูกปิดอยู่ (platform.amaze.enabled = false)",
            amaze_not_configured: "ยังไม่ได้ใส่รหัสผู้ใช้/รหัสผ่านของ Amaze ใน config",
            amaze_env_unset: "ยังไม่ได้ตั้ง env ของ Amaze เป็น prod (ค่า uat ใช้ไม่ได้ เพราะโฮสต์ UAT ล่มอยู่)",
            amaze_shop_unresolved:
                "ระบบไม่รู้ว่าจะส่งเข้าร้าน Amaze ร้านไหน — ต้องตั้ง platform.amaze.shop_id ใน config หรือกดทดสอบการเชื่อมต่อหนึ่งครั้งเพื่อให้ระบบจำรหัสร้าน",
            unavailable: "ยังเรียก Amaze ไม่ได้ในตอนนี้",
            upstream: "platform ตอบกลับผิดพลาด ระบบยังไม่ได้ส่งสินค้า",
            generic: "sync ไป platform ไม่สำเร็จ"
        },
        map: {
            hint: "จับคู่หมวดของร้านกับหมวดบน platform หนึ่งครั้งต่อหมวด แล้วปุ่ม sync จะใช้ค่าตั้งต้นชุดนี้ทุกครั้ง",
            auto_approve_warning: "ร้านนี้ตั้ง auto approve ไว้ สินค้าที่ส่งจะขึ้นขายทันทีโดยไม่ผ่านการรีวิว",
            col_seller_category: "หมวดของร้าน",
            col_platform_category: "หมวดบน platform",
            col_updated_at: "แก้ไขล่าสุด",
            unmapped: "ยังไม่จับคู่",
            editor_title: "จับคู่หมวด",
            platform_category: "หมวดบน platform",
            category_hint: "เลือกจนถึงหมวดย่อยสุดท้าย — ระบบจะใช้หมวดสุดท้ายเป็น category_group_id ให้เอง",
            category_required: "ต้องเลือกหมวดบน platform ก่อนจึงจะบันทึกได้",
            brand: "แบรนด์",
            warehouse: "ที่อยู่คลัง",
            warehouse_name: "ชื่อคลังบน platform",
            shipping: "วิธีจัดส่ง",
            attributes: "คุณสมบัติที่บังคับ",
            payment_configs: "ช่องทางชำระเงิน",
            payment_configs_hint: "platform ไม่มี API สำหรับดึงรายการช่องทางชำระเงิน ค่านี้ต้องคัดลอกมาจากสินค้าที่มีอยู่แล้วตามคู่มือ §6B.6",
            weight: "น้ำหนัก (กรัม)",
            parcel_width: "กว้าง (ซม.)",
            parcel_length: "ยาว (ซม.)",
            parcel_height: "สูง (ซม.)",
            btn_save: "บันทึกการจับคู่",
            saved: "บันทึกการจับคู่หมวดแล้ว",
            error: {
                path_mismatch: "เส้นทางหมวดไม่ตรงกับหมวดสุดท้าย — ต้องเลือกหมวดใหม่อีกครั้ง",
                platform_not_supported: "ยังไม่รองรับการจับคู่หมวดของ platform นี้",
                bad_request: "ข้อมูลที่ส่งไปไม่ถูกต้อง",
                generic: "บันทึกการจับคู่หมวดไม่สำเร็จ"
            }
        }
    },
    shopee_to_seller: {
        btn_send: "ส่งเข้า seller",
        title: "ส่งสินค้า Shopee เข้า seller",
        item_id: "รหัสสินค้า Shopee",
        shop_id: "รหัสร้าน",
        model_id: "model_id",
        category: "หมวดหมู่ของ seller",
        category_hint: "เลือกหมวดหมู่ที่จะใช้ตอนสร้างสินค้าใหม่ (เลือกครั้งเดียว ซิงก์รอบถัดไปจะไม่เปลี่ยนหมวด)",
        category_required_hint: "ต้องเลือกหมวดหมู่ก่อน จึงจะกดยืนยันส่งเข้า seller ได้",
        update_category_kept: "สินค้านี้อยู่ใน seller แล้ว การซิงก์ซ้ำจะคงหมวดหมู่เดิมไว้",
        btn_check: "ตรวจสอบ",
        btn_confirm: "ยืนยันส่งเข้า seller",
        preview_name: "ชื่อสินค้า",
        image_count: "จำนวนรูป",
        description_image_count: "รูปในรายละเอียด",
        option_groups: "ตัวเลือก",
        sku_table: "รายการ SKU",
        col_sku_code: "รหัส SKU",
        col_sku_name: "ชื่อ SKU",
        col_price: "ราคา",
        col_action: "การกระทำ",
        warnings_title: "คำเตือน",
        warnings_dry_run: "จากการตรวจสอบ ยังไม่ได้บันทึก",
        rejected_title: "ส่งเข้า seller ไม่ได้ — ต้องแก้ที่ Shopee ก่อน",
        success: "ส่งเข้า seller สำเร็จ",
        open_in_catalog: "เปิดในจัดการสินค้า",
        badge_linked: "อยู่ใน seller แล้ว",
        disabled_not_shopee: "ใช้ได้เฉพาะสินค้าจาก Shopee",
        disabled_item_status: "สถานะสินค้าบน Shopee ไม่อนุญาตให้ส่ง (ต้องเป็น NORMAL หรือ UNLIST)",
        disabled_no_item_id: "ไม่พบรหัสสินค้าบน Shopee",
        sku_action: {
            create: "สร้างใหม่",
            update: "อัปเดต",
            deactivate: "ปิดการขาย",
            reactivate: "เปิดการขายอีกครั้ง",
            unknown: "ไม่ทราบ"
        },
        reject: {
            model_sku_empty: "ตัวเลือกนี้ไม่มีรหัส SKU (model_sku) บน Shopee",
            sku_code_too_long: "รหัส SKU ยาวเกินที่ระบบ seller รองรับ",
            item_status_not_allowed: "สถานะสินค้าบน Shopee ไม่อนุญาตให้ส่ง (ต้องเป็น NORMAL หรือ UNLIST)",
            no_price: "ตัวเลือกนี้ไม่มีราคา",
            model_list_empty: "สินค้านี้ระบุว่ามีตัวเลือก แต่ Shopee ไม่ส่งรายการตัวเลือกกลับมาเลย",
            unknown: "ส่งไม่ได้ด้วยเหตุผลที่ระบบยังไม่รู้จัก"
        },
        error: {
            category_required: "ต้องเลือกหมวดหมู่ของ seller ก่อนสร้างสินค้าใหม่",
            cover_image_failed: "ย้ายรูปปกไม่สำเร็จ ระบบจึงไม่บันทึกอะไรเลย กรุณาลองใหม่",
            upstream: "ดึงข้อมูลจาก Shopee ไม่สำเร็จ ระบบยังไม่ได้บันทึกอะไร กรุณาลองใหม่",
            rejected: "ส่งเข้า seller ไม่ได้",
            bad_request: "ข้อมูลที่ส่งไปไม่ถูกต้อง",
            generic: "ส่งเข้า seller ไม่สำเร็จ"
        }
    },
    // shopee_bulk_sync — #280 "sync ทั้งร้านเข้า seller" บน /admin/product_platform
    // (spec §6C.6) · ทำงานเป็นงานเบื้องหลัง: กด → poll → ดูผลรายตัว
    shopee_bulk_sync: {
        btn_toolbar: "sync ทั้งร้านเข้า seller",
        btn_toolbar_disabled: "ใช้ได้เฉพาะร้าน Shopee ที่เลือกร้านแล้ว",
        title: "sync สินค้าทั้งร้าน Shopee เข้า seller",
        shop: "ร้าน",
        // #284: สองชื่อ คนละที่มา — shop_name คือชื่อที่ Shopee เรียกร้านนี้
        // (ดึงจาก GET .../shops/:id/info) · seller_name คือชื่อที่ backoffice
        // เรียก (bo_seller.seller_name) ต้องโชว์ทั้งคู่เพื่อให้เห็นว่าตรงกัน
        // ก่อนกด sync ทั้งร้าน
        shop_name: "ชื่อร้านบน Shopee",
        seller_name: "ชื่อร้านใน backoffice",
        shop_id: "รหัสร้าน",
        open_in_shopee: "เปิดสินค้านี้ใน Shopee Seller Centre",
        settings_title: "1. ตั้งค่าการ sync",
        category: "หมวดหมู่ของ seller สำหรับสินค้าใหม่",
        category_hint:
            "ใช้เฉพาะสินค้าที่ยังไม่มีใน seller · สินค้าที่มีอยู่แล้วจะคงหมวดหมู่เดิมไว้ ไม่ถูกเปลี่ยน",
        category_required_hint: "ต้องเลือกหมวดหมู่ก่อน จึงจะเริ่ม sync จริงได้ (การตรวจสอบไม่ต้องเลือก)",
        item_status_label: "สถานะสินค้าบน Shopee ที่จะดึงมา",
        item_status_hint:
            "ค่าเริ่มต้นดึงเฉพาะ NORMAL · ติ๊ก UNLIST เองถ้าต้องการสินค้าที่ซ่อนอยู่ · สถานะอื่นระบบจะข้ามให้อยู่ดี (ส่งเข้า seller ไม่ได้)",
        item_status_required_hint: "ต้องเลือกสถานะอย่างน้อย 1 อย่าง",
        only_unlinked: "ข้ามสินค้าที่อยู่ใน seller แล้ว",
        only_unlinked_hint:
            "เปิด = ทำเฉพาะสินค้าที่ยังไม่มีใน seller (เร็วกว่า ไม่ยิง Shopee ซ้ำ) · ปิด = อัปเดตทุกตัวให้ตรงกับ Shopee",
        btn_dry_run: "ตรวจสอบทั้งร้าน",
        btn_real: "เริ่ม sync จริง",
        btn_dry_run_hint: "ตรวจสอบเท่านั้น ไม่บันทึกอะไรลง seller",
        confirm_title: "เริ่ม sync จริงทั้งร้าน?",
        confirm_text:
            "ระบบจะสร้าง/อัปเดตสินค้าใน seller ตามข้อมูลจาก Shopee ทั้งร้าน งานนี้ใช้เวลานานและหยุดกลางทางได้",
        confirm_ok: "เริ่ม sync จริง",
        confirm_cancel: "ยกเลิก",
        progress_title: "2. ความคืบหน้า",
        job_label: "งานที่",
        mode_dry_run: "ตรวจสอบ (ไม่บันทึก)",
        mode_real: "sync จริง",
        listing_hint: "กำลังนับสินค้าในร้าน…",
        queued_hint: "อยู่ในคิว รอเริ่มงาน…",
        processed_of: "ทำแล้ว {processed} จาก {total} รายการ",
        total: "ทั้งหมด",
        processed: "ทำแล้ว",
        created_count: "สร้างใหม่",
        updated_count: "อัปเดต",
        attached_existing: "มีงานของร้านนี้กำลังทำอยู่แล้ว — กำลังแสดงความคืบหน้าของงานนั้น",
        btn_cancel_job: "ยกเลิกงาน",
        cancel_confirm_title: "ยกเลิกงาน sync?",
        cancel_confirm_text: "รายการที่ทำไปแล้วจะยังอยู่ ส่วนที่เหลือจะไม่ถูกทำ",
        cancel_requested: "ส่งคำสั่งยกเลิกแล้ว กำลังหยุดหลังจบรายการปัจจุบัน…",
        results_title: "3. ผลลัพธ์",
        tab_all: "ทั้งหมด",
        tab_ok: "สำเร็จ",
        tab_rejected: "ปฏิเสธ",
        tab_failed: "ล้มเหลว",
        tab_skipped: "ข้าม",
        col_item_id: "รหัสสินค้า Shopee",
        // #642: ชื่อสินค้าตามที่ Shopee ตั้งไว้ (มาจาก item_base_info ในคลัง raw)
        // ว่างได้ ถ้าเป็นสินค้าที่ระบบข้ามไปเลยจึงไม่เคยดึงข้อมูลมา
        col_item_name: "ชื่อสินค้าบน Shopee",
        col_status: "สถานะ",
        col_action: "การกระทำ",
        col_product: "สินค้าใน seller",
        col_reason: "เหตุผล",
        // #286: ปุ่มดาวน์โหลดผลทั้งงานเป็นไฟล์ Excel 3 ชีต
        // (สรุป / รายการ / SKU ที่ต้องแก้บน Shopee) · export_excel_short
        // คือลิงก์สั้นในตาราง "งานล่าสุด" ที่มีพื้นที่แค่คำเดียว
        export_excel: "ส่งออก Excel",
        export_excel_short: "Excel",
        export_failed: "ส่งออกไฟล์ไม่สำเร็จ",
        open_in_catalog: "เปิดในจัดการสินค้า",
        empty_items: "ไม่มีรายการในกลุ่มนี้",
        sku_summary: "SKU สร้าง {create} · อัปเดต {update}",
        btn_recent: "งานล่าสุด",
        recent_title: "งาน sync ล่าสุดของร้านนี้",
        recent_empty: "ยังไม่มีงาน sync ของร้านนี้",
        recent_open: "ดูผล",
        col_created_at: "เริ่มเมื่อ",
        col_mode: "โหมด",
        col_result: "ผล",
        last_error: "ข้อผิดพลาดของงาน",
        finished_done: "งาน sync เสร็จแล้ว",
        finished_failed: "งาน sync ล้มเหลว",
        finished_cancelled: "งาน sync ถูกยกเลิก",
        job_status: {
            queued: "อยู่ในคิว",
            listing: "กำลังนับสินค้า",
            running: "กำลังทำ",
            done: "เสร็จแล้ว",
            failed: "ล้มเหลว",
            cancelled: "ยกเลิกแล้ว",
            unknown: "ไม่ทราบสถานะ"
        },
        item_status: {
            pending: "ยังไม่ได้ทำ",
            ok: "สำเร็จ",
            rejected: "ปฏิเสธ",
            failed: "ล้มเหลว",
            skipped: "ข้าม",
            unknown: "ไม่ทราบสถานะ"
        },
        action: {
            create: "สร้างใหม่",
            update: "อัปเดต",
            none: "-",
            unknown: "ไม่ทราบ"
        },
        reason: {
            item_status_not_allowed: "สถานะสินค้าบน Shopee ไม่อนุญาตให้ส่ง (ต้องเป็น NORMAL หรือ UNLIST)",
            already_linked: "สินค้านี้อยู่ใน seller แล้ว และตั้งค่าให้ข้ามสินค้าที่ผูกแล้ว",
            fetch_failed: "ดึงข้อมูลจาก Shopee ไม่สำเร็จ",
            cover_image_failed: "ย้ายรูปปกไม่สำเร็จ ระบบจึงไม่บันทึกสินค้านี้",
            category_required: "ไม่มีหมวดหมู่ตั้งต้นสำหรับสร้างสินค้าใหม่",
            save_failed: "บันทึกลง seller ไม่สำเร็จ",
            unknown: "เหตุผลที่ระบบยังไม่รู้จัก"
        },
        error: {
            shop_required: "ต้องเลือกร้าน Shopee ก่อน",
            category_required: "ต้องเลือกหมวดหมู่ของ seller ก่อนเริ่ม sync จริง",
            bad_item_status: "สถานะสินค้าที่เลือกไม่ถูกต้อง",
            bad_request: "ข้อมูลที่ส่งไปไม่ถูกต้อง",
            already_finished: "งานนี้จบไปแล้ว ยกเลิกไม่ได้",
            not_found: "ไม่พบงาน sync นี้",
            poll_failed: "อ่านความคืบหน้าไม่สำเร็จ งานยังทำอยู่เบื้องหลัง — ปิดแล้วเปิด \"งานล่าสุด\" เพื่อดูผลได้",
            generic: "เริ่มงาน sync ไม่สำเร็จ"
        }
    },
    // shopee_category_map — #282 "จับคู่หมวด Shopee → seller" (spec §6D.6)
    // หมวดของสินค้าใหม่มาจาก Shopee เองโดยอัตโนมัติ · หน้านี้คือที่แก้การเดานั้น
    shopee_category_map: {
        menu: "จับคู่หมวด Shopee → seller",
        title: "จับคู่หมวด Shopee → หมวดของ seller",
        hint:
            "สินค้าใหม่ที่ sync จาก Shopee จะได้หมวดตามตารางนี้ · หมวดที่ยังไม่ได้จับคู่ ระบบจะสร้างหมวดใหม่ชื่อเดียวกับ Shopee ให้เอง",
        retroactive_hint: "การแก้ตารางนี้มีผลกับสินค้าที่ sync ครั้งต่อไปเท่านั้น สินค้าที่ sync ไปแล้วจะไม่ถูกย้ายหมวด",
        shop: "ร้าน Shopee",
        shop_placeholder: "เลือกร้าน Shopee",
        no_shop: "ยังไม่มีร้าน Shopee ที่เชื่อมต่อไว้",
        fetched_at: "ชื่อหมวดจาก Shopee อัปเดตเมื่อ",
        fetched_at_never: "ยังไม่เคยดึง",
        col_shopee_category: "หมวดบน Shopee",
        col_product_count: "จำนวนสินค้าในร้าน",
        col_seller_category: "หมวดของ seller",
        col_source: "ที่มา",
        auto_option: "ให้สร้างอัตโนมัติ",
        auto_placeholder: "ใช้หมวดตาม Shopee (อัตโนมัติ)",
        btn_save: "บันทึก",
        btn_refresh: "รีเฟรชชื่อหมวดจาก Shopee",
        saved: "บันทึกการจับคู่แล้ว",
        saved_text: "แก้ไข {count} หมวด · สินค้าที่ sync ไปแล้วจะไม่ถูกย้ายหมวด",
        refreshed: "รีเฟรชชื่อหมวดจาก Shopee แล้ว",
        refreshed_text: "ได้หมวดทั้งหมด {count} รายการ",
        no_changes: "ยังไม่มีการแก้ไข",
        empty: "ยังไม่มีหมวดของร้านนี้ — กดรีเฟรชชื่อหมวดจาก Shopee หรือ sync สินค้าเข้ามาก่อน",
        modal_hint: "ไม่ต้องเลือกก็ได้ — ระบบจะตั้งหมวดตาม Shopee ให้เอง",
        modal_link: "จับคู่หมวด Shopee",
        would_create: "จะสร้างหมวดใหม่",
        preview_category: "หมวดของ seller ที่จะได้",
        col_category: "หมวดของ seller",
        source: {
            auto: "อัตโนมัติ",
            manual: "ตั้งเอง",
            none: "ยังไม่มี map"
        },
        resolution: {
            override: "เลือกหมวดเอง",
            map: "ตามที่จับคู่ไว้",
            existing_name: "ใช้หมวดเดิมที่ชื่อตรงกัน",
            auto_new: "สร้างหมวดใหม่ตาม Shopee",
            unknown_name: "ไม่พบชื่อหมวดบน Shopee ระบบตั้งชื่อชั่วคราวให้",
            unchanged: "คงหมวดเดิม (สินค้าอัปเดต ไม่เปลี่ยนหมวด)",
            unknown: "ไม่ทราบที่มาของหมวด"
        },
        error: {
            shop_required: "ต้องเลือกร้าน Shopee ก่อน",
            bad_category: "หมวดของ seller ที่เลือกไว้บางหมวดถูกลบไปแล้ว กรุณาโหลดหน้านี้ใหม่",
            upstream: "ดึงหมวดจาก Shopee ไม่สำเร็จ กรุณาลองใหม่",
            generic: "ทำรายการไม่สำเร็จ"
        }
    },
    // shopee_promotion — B7 "โปรโมชั่น Shopee → seller" (spec
    // 2026-10-02-shopee-promotions-to-seller-design §6)
    // โปรฯ Discount + Shop Flash Sale ของร้าน Shopee ถูกคัดลอกมาเป็นราคาแฟลชราย SKU
    // ในแอป · ทิศทางเดียว แก้ที่ Shopee เท่านั้น
    shopee_promotion: {
        menu_title: "โปรโมชั่น Shopee → seller",
        page_title: "โปรโมชั่นจาก Shopee",
        hint:
            "โปรฯ ส่วนลดและ Flash Sale ของร้านบน Shopee จะถูกคัดลอกมาเป็นราคาแฟลชในแอปด้วยราคาเดียวกัน · แก้ไขได้ที่ Shopee Seller Centre เท่านั้น",
        shop: "ร้าน Shopee",
        shop_placeholder: "เลือกร้าน Shopee",
        shop_on_shopee: "ชื่อร้านบน Shopee",
        no_shop: "ยังไม่มีร้าน Shopee ที่เชื่อมต่อไว้",
        fetched_at: "ดึงข้อมูลจาก Shopee เมื่อ",
        fetched_at_never: "ยังไม่เคยดึง",
        last_run: "รันล่าสุด",
        last_run_never: "ยังไม่เคยรัน",
        last_run_line: "{at} · ใช้ {promotions} โปรฯ · ตั้งราคา {set} SKU · ล้าง {cleared}",
        link_at: "เมื่อ {at}",
        col_type: "ประเภท",
        col_name: "ชื่อโปรโมชั่น",
        col_window: "ช่วงเวลา",
        col_status: "สถานะบน Shopee",
        col_item_count: "จำนวนสินค้า",
        col_app_state: "สถานะในแอป",
        type_discount: "ส่วนลด",
        type_flash_sale: "Flash Sale",
        type_unknown: "ไม่ทราบประเภท",
        status_upcoming: "ยังไม่เริ่ม",
        status_ongoing: "กำลังวิ่ง",
        status_expired: "หมดอายุ",
        status_unsupported: "ไม่รองรับ",
        status_unknown: "ไม่ทราบสถานะ",
        app_state_synced: "sync แล้ว {count} SKU",
        app_state_ended: "จบแล้ว",
        app_state_skipped: "ข้าม",
        app_state_failed: "ล้มเหลว",
        app_state_none: "ยังไม่ sync",
        btn_dry_run: "ตรวจสอบ (dry-run)",
        btn_sync_now: "sync เดี๋ยวนี้",
        btn_dry_run_hint: "ตรวจสอบจะไม่เขียนราคาใด ๆ · ติ๊กเลือกบางโปรฯ ได้ ไม่ติ๊ก = ทั้งร้าน",
        btn_view_result: "ดูผลราย SKU",
        btn_view_result_hint: "ผลราย SKU มีเฉพาะรันที่กดจากหน้านี้ — กดตรวจสอบหรือ sync ก่อน",
        btn_close: "ปิด",
        btn_cancel: "ยกเลิก",
        selected_count: "เลือกไว้ {count} โปรฯ",
        selected_none: "ไม่ได้เลือก = ทั้งร้าน",
        confirm_title: "sync โปรโมชั่นจาก Shopee ?",
        confirm_text:
            "ระบบจะตั้งราคาแฟลชในแอปตามโปรฯ บน Shopee ({count} โปรฯ ที่เลือกไว้ · 0 = ทั้งร้าน) · ราคาแฟลชที่พนักงานตั้งเองจะไม่ถูกแตะ",
        running: "กำลังรัน sync โปรโมชั่นอยู่ — ปุ่มจะกลับมาใช้ได้เมื่อรอบนี้จบ",
        result_title: "ผลราย SKU",
        result_dry_run: "ผลการตรวจสอบ (ยังไม่เขียนอะไร)",
        result_applied: "sync โปรโมชั่นเรียบร้อย",
        result_summary:
            "โปรฯ ทั้งหมด {total} · ใช้ {applied} · ตั้งราคา {set} SKU · ล้าง {cleared} · ข้าม {skipped}",
        result_empty: "ไม่มี SKU ในโปรฯ นี้",
        col_sku: "SKU",
        col_price_before: "ราคาเดิม",
        col_price_after: "ราคาโปรฯ",
        col_action: "ผล",
        col_reason: "เหตุผล",
        action_set: "ตั้งราคา",
        action_keep: "เหมือนเดิม",
        action_clear: "ล้างราคา",
        action_skip: "ข้าม",
        action_unknown: "ไม่ทราบผล",
        promo_action_apply: "ใช้โปรฯ นี้",
        promo_action_end: "จบโปรฯ นี้",
        promo_action_skip: "ข้ามโปรฯ นี้",
        promo_action_noop: "ไม่มีอะไรเปลี่ยน",
        promo_action_unknown: "ไม่ทราบผล",
        warnings_title: "คำเตือน",
        warn_sku_not_synced: "สินค้าตัวนี้ยังไม่ได้ sync เข้าแอป (ยังไม่มี SKU ให้ตั้งราคา)",
        warn_manual_flash_exists: "SKU นี้มีราคาแฟลชที่พนักงานตั้งเองอยู่ ระบบไม่แตะ",
        warn_app_price_already_lower: "ราคาในแอปถูกกว่าหรือเท่าโปรฯ Shopee อยู่แล้ว ระบบไม่เขียนทับ",
        warn_platform_promotion_skipped: "โปรฯ นี้ Shopee สร้างให้ (platform campaign) ระบบไม่รองรับ",
        warn_base_price_mismatch: "ราคาปกติบน Shopee ไม่ตรงกับราคาปกติในแอป (แจ้งให้ทราบเท่านั้น)",
        warn_item_level_price_spread: "Shopee ส่งราคามาระดับสินค้า ระบบกระจายให้ทุกตัวเลือกในโปรฯ",
        warn_model_not_active: "ตัวเลือกนี้ถูกปิด/ลบ/ไม่ผ่านการอนุมัติบน Shopee",
        warn_no_promotion_price: "โปรฯ นี้ไม่มีราคาที่ใช้ได้ส่งมา",
        warn_promotion_ended: "โปรฯ นี้จบหรือถูกปิดบน Shopee แล้ว ระบบล้างราคาที่เคยตั้งไว้",
        warn_sku_inactive: "SKU นี้ถูกลบหรือปิดอยู่",
        warn_ownership_columns_missing: "ฐานข้อมูลยังไม่มีคอลัมน์เจ้าของราคาแฟลช (ยังไม่ได้รัน SQL)",
        warn_duplicate_sku_mapping: "มีตัวเลือกบน Shopee 2 ตัวในโปรฯ นี้ ผูกมาที่ SKU เดียวกัน ระบบใช้ราคาตัวแรกเท่านั้น กรุณาแก้การผูกสินค้า",
        warn_remote_expired_window_open: "Shopee แจ้งว่าโปรฯ นี้หมดอายุแล้ว แต่ช่วงเวลาที่ส่งมายังไม่จบ ระบบจึงไม่เขียนราคา",
        warn_unknown: "มีคำเตือนที่ระบบยังไม่รู้จัก",
        disabled_state: "ฟีเจอร์ sync โปรโมชั่น Shopee ปิดอยู่ (ต้องเปิดที่ config ฝั่ง API)",
        mode_shadow_hint: "โหมด shadow: ระบบคำนวณผลแต่ยังไม่เขียนราคาจริง",
        show_upcoming_state: "แสดงโปรฯ ที่ยังไม่เริ่มบนหน้าร้าน",
        show_upcoming_on: "เปิด",
        show_upcoming_off: "ปิด",
        setting_label: "แสดงโปรฯ ที่ยังไม่เริ่ม (เร็ว ๆ นี้)",
        setting_help:
            "เปิด = หน้าร้าน/แอปจะโชว์ราคาโปรฯ ที่ยังไม่เริ่มพร้อมป้าย \"เร็ว ๆ นี้\" · ปิด = เห็นเฉพาะโปรฯ ที่กำลังวิ่ง (ค่าเริ่มต้น)",
        flash_from_shopee: "จาก Shopee",
        flash_from_shopee_hint: "ราคานี้มาจากโปรโมชั่นบน Shopee แก้ที่ Shopee Seller Centre",
        empty: "ยังไม่มีโปรโมชั่นของร้านนี้ — ตั้งโปรฯ บน Shopee Seller Centre แล้วกดตรวจสอบ",
        err_shop_required: "ต้องเลือกร้าน Shopee ก่อน",
        err_shop_not_found: "ไม่พบร้าน Shopee นี้ในระบบ",
        err_in_flight: "มีรอบ sync โปรโมชั่นของร้านนี้กำลังทำงานอยู่ — ระบบจะตามผลรอบนั้นให้",
        err_bad_promotion_type: "ประเภทโปรโมชั่นไม่ถูกต้อง (รองรับเฉพาะส่วนลดและ Flash Sale)",
        err_shop_not_master: "sync โปรโมชั่นได้เฉพาะร้าน Shopee ต้นแบบเท่านั้น",
        err_fetch_failed: "ดึงโปรโมชั่นจาก Shopee ไม่สำเร็จ กรุณาลองใหม่",
        err_disabled: "ฟีเจอร์ sync โปรโมชั่น Shopee ปิดอยู่",
        err_generic: "ทำรายการไม่สำเร็จ"
    },
    product_platform_v2: {
        map_wms_btn: "แมป SKU กับคลังสินค้า (WMS)",
        mdfstore_hint: "สินค้ากลุ่มนี้ซิงก์มาจากหน้าร้าน (Storefront) — ต้องแมป SKU กับคลังสินค้า (WMS) ก่อน ไม่งั้นคำสั่งซื้อจะไม่ตัดสต็อก",
        makro_hint: "สินค้ากลุ่มนี้ซิงก์มาจากออฟเฟอร์ Makro (Mirakl) — ต้องแมป SKU กับคลังสินค้า (WMS) ก่อน ไม่งั้นคำสั่งซื้อจะไม่ตัดสต็อก"
    },
    // makro_order — mirakl Dev-B2 (Makro PRO / Mirakl order actions)
    makro_order: {
        sync_now: "ซิงก์ Makro",
        sync_started: "เริ่มซิงก์คำสั่งซื้อ Makro แล้ว",
        sync_running: "กำลังซิงก์ Makro อยู่แล้ว",
        accept: "รับออเดอร์ (Makro)",
        accept_success: "รับออเดอร์ Makro สำเร็จ",
        ship_to_makro: "แจ้งส่ง Makro",
        ship_success: "แจ้งส่ง Makro สำเร็จ",
        tracking_required: "กรุณากรอกหมายเลขพัสดุก่อนแจ้งส่ง",
        action_failed: "ดำเนินการกับ Makro ไม่สำเร็จ"
    },
    // ── key ที่ call site เรียกใช้แต่ไม่เคยมีในไฟล์ภาษา (เติม 2026-08-21) ──
    // ก่อนหน้านี้ vue-i18n จะพ่นชื่อ key ดิบ ๆ ออกหน้าจอ เช่นหัวตารางขึ้นว่า "order_id"
    // หรือ dialog error ขึ้น title ว่า "error" — สแกนหาได้ด้วยการ resolve ทุก $t()
    // กับไฟล์ภาษาจริง (ห้ามตั้งชื่อซ้ำกับ key ที่มีอยู่ ดูหมายเหตุที่ platform_integration)
    error: "ข้อผิดพลาด",
    warning: "คำเตือน",
    no_data: "ไม่พบข้อมูล",
    loading: "กำลังโหลด...",
    clear: "ล้างข้อมูล",
    remove: "ลบ",
    Export: "ส่งออก",
    continue: "ดำเนินการต่อ",
    confirm_delete: "ยืนยันการลบ",
    please_fill_required: "กรุณากรอกข้อมูลที่จำเป็นให้ครบ",
    save_failed: "บันทึกไม่สำเร็จ",
    create_failed: "สร้างไม่สำเร็จ",
    webcam_not_found: "ไม่พบกล้อง",
    Barcode: "บาร์โค้ด",
    size: "ขนาด",
    address: "ที่อยู่",
    code: "รหัส",
    number: "หมายเลข",
    order_id: "รหัสคำสั่งซื้อ",
    tracking: "หมายเลขพัสดุ",
    sku: "SKU",
    storage: "คลังจัดเก็บ",
    staff: "พนักงาน",
    date_from: "ตั้งแต่วันที่",
    date_to: "ถึงวันที่",
    po_number: "เลขที่ใบสั่งซื้อ",
    partner_name: "ชื่อคู่ค้า",
    coupon_id: "รหัสคูปอง",
    coupon_prefix: "คำนำหน้าคูปอง",
    coupon_start: "เลขเริ่มต้น",
    coupon_end: "เลขสิ้นสุด",
    bc_coupon_deail: "รายละเอียดคูปอง",

    // coupon_event — หน้าสร้าง event คูปอง (spec 2026-09-23 §4)
    // สิทธิ์สร้างมาจาก config.yml coupon_event.emails ไม่ใช่ role
    coupon_event: {
        enabled: "เปิดใช้งาน",
        enabled_hint: "ปิดไว้ = สร้างรหัสแต่ยังไม่ให้ใช้",
        title: "สร้าง event คูปอง",
        create_button: "สร้าง event คูปอง",
        subtitle: "สร้างชุดคูปองใหม่ ระบบจะสร้างรหัสคูปองให้เบื้องหลังหลังบันทึก",

        // ฟิลด์ตามลำดับในตาราง §3
        name: "ชื่อ event",
        name_placeholder: "เช่น สงกรานต์ 2026",
        prefix: "คำนำหน้ารหัสคูปอง",
        prefix_placeholder: "A-Z และ 0-9 ไม่เกิน 10 ตัว",
        prefix_hint: "ระบบจะแปลงเป็นตัวพิมพ์ใหญ่ให้อัตโนมัติ",
        url_prefix: "URL สำหรับ QR",
        url_prefix_placeholder: "https://www.madamefin.com/c/",
        url_prefix_hint: "ต้องเป็น URL เต็มขึ้นต้นด้วย http:// หรือ https://",
        valid_from: "เริ่มใช้ได้",
        valid_to: "ใช้ได้ถึง",
        running_from: "เลขรันเริ่มต้น",
        running_to: "เลขรันสิ้นสุด",
        running_digit: "จำนวนหลักของเลขรัน",
        running_digit_hint: "ต้องไม่น้อยกว่าจำนวนหลักของเลขรันสิ้นสุด",
        random_digit: "จำนวนหลักของเลขสุ่ม",
        random_digit_hint: "ใส่ 0 ถ้าไม่ต้องการเลขสุ่ม",
        random_round: "จำนวนรอบของเลขสุ่ม",
        random_round_hint: "จำนวนรอบที่วนเลขรันซ้ำ แต่ละรอบใช้เลขสุ่มคนละชุด (0 หรือ 1 = รอบเดียว, สูงสุด 200) ต้องมีหลักเลขสุ่มด้วย",
        condition: "เงื่อนไข",
        condition_placeholder: "ข้อความอิสระ (ไม่บังคับ)",

        quantity: "จำนวนคูปอง",
        quantity_hint: "คำนวณจาก (เลขรันสิ้นสุด − เลขรันเริ่มต้น + 1) × จำนวนรอบของเลขสุ่ม (ระบบคำนวณซ้ำฝั่งเซิร์ฟเวอร์)",
        // {max} ส่งมาจาก COUPON_EVENT_MAX_QUANTITY ห้ามเขียนตัวเลขตรง ๆ ในคำแปล
        quantity_max: "สูงสุด {max} ใบต่อ 1 event",
        quantity_over_cap: "จำนวนคูปองเกินกว่าที่สร้างได้ต่อ 1 event กรุณาลดช่วงเลขรันหรือจำนวนรอบของเลขสุ่ม",

        submit: "บันทึก",
        cancel: "ยกเลิก",
        back: "กลับ",

        created: "สร้าง event คูปองแล้ว",
        created_detail: "ระบบกำลังสร้างรหัสคูปองเบื้องหลัง อาจใช้เวลาสักครู่",

        // ลบ event + ปุ่ม All (spec §8.3)
        // delete_confirm ใช้ {name} · deleted ใช้ {codes} · all_count ใช้ {n}
        delete: "ลบ event",
        delete_confirm: "ลบ event \"{name}\" ?",
        delete_confirm_detail: "รหัสคูปองทั้งหมดของ event นี้จะถูกลบไปด้วย และย้อนกลับไม่ได้จากหน้านี้",
        delete_confirm_ok: "ลบ",
        deleted: "ลบ event แล้ว",
        deleted_detail: "ลบรหัสคูปองไปทั้งหมด {codes} ใบ",
        all: "All",
        all_count: "ทั้งหมด {n} ใบ",
        all_loading: "กำลังโหลดคูปองทั้งหมด",
        exporting: "กำลังสร้างไฟล์ Export",

        forbidden: "คุณไม่มีสิทธิ์สร้าง event คูปอง",

        forbidden_title: "ไม่มีสิทธิ์สร้าง event คูปอง",
        forbidden_detail: "สิทธิ์นี้กำหนดจากอีเมลใน config ของระบบ กรุณาติดต่อผู้ดูแลระบบ",

        // errors — คีย์ตรงกับรหัสที่ API ส่งมาใน Msg (spec §3)
        // ผู้ใช้ต้องไม่เห็นรหัสดิบ เช่น "coupon_event_bad_prefix"
        errors: {
            coupon_event_bad_name: "กรุณากรอกชื่อ event",
            coupon_event_bad_prefix: "คำนำหน้าต้องเป็น A-Z หรือ 0-9 ความยาว 1-10 ตัว",
            coupon_event_bad_url: "URL ไม่ถูกต้อง ต้องขึ้นต้นด้วย http:// หรือ https://",
            coupon_event_bad_dates: "ช่วงวันที่ไม่ถูกต้อง วันสิ้นสุดต้องอยู่หลังวันเริ่มต้น",
            coupon_event_bad_running: "เลขรันไม่ถูกต้อง เลขเริ่มต้นต้องเป็น 0 ขึ้นไป เลขสิ้นสุดต้องไม่น้อยกว่าเลขเริ่มต้น และจำนวนรวมไม่เกิน 200,000 ใบ",
            coupon_event_bad_digits: "จำนวนหลักไม่ถูกต้อง เลขรัน 1-10 หลัก (ต้องพอกับเลขรันสิ้นสุด) เลขสุ่ม 0-10 หลัก รอบสุ่ม 0-5 รอบ",
            coupon_event_name_taken: "มี event ชื่อนี้อยู่แล้ว กรุณาใช้ชื่ออื่น",
            coupon_event_forbidden: "คุณไม่มีสิทธิ์สร้าง event คูปอง",
            // §8.1 — ลบไม่ได้เพราะมีคนถือคูปองอยู่ ({registered} ลงทะเบียน / {used} ส่งไปกับออเดอร์)
            coupon_event_in_use: "ลบไม่ได้ มีผู้ลงทะเบียนแล้ว {registered} ใบ และส่งไปกับออเดอร์แล้ว {used} ใบ",
            coupon_event_in_use_registered: "ลบไม่ได้ มีผู้ลงทะเบียนคูปองของ event นี้แล้ว {registered} ใบ",
            coupon_event_in_use_used: "ลบไม่ได้ มีคูปองของ event นี้ส่งไปกับออเดอร์แล้ว {used} ใบ",
            coupon_event_not_found: "ไม่พบ event นี้ หรือถูกลบไปแล้ว",
            // unknown = หน้าสร้าง · unknown_delete = ปุ่มลบ · unknown_all = ปุ่ม All
            // ต้องใช้คำกริยาให้ตรงกับสิ่งที่ผู้ใช้เพิ่งกด ไม่งั้นจะบอกว่า "สร้างไม่สำเร็จ" ทั้งที่กดลบ
            unknown: "สร้าง event คูปองไม่สำเร็จ",
            unknown_delete: "ลบ event คูปองไม่สำเร็จ",
            unknown_all: "โหลดคูปองทั้งหมดไม่สำเร็จ"
        }
    },
    // #437 /wms/inventory/shipped-no-deduct (spec 2026-10-09 §5)
    shipped_no_deduct: {
        title: "สินค้าที่ส่งแล้วแต่ยังไม่ตัดสต็อก",
        hint: "ออเดอร์ที่ส่งออกไปแล้วแต่ไม่มีการยิงปิดสินค้า ใช้เป็นข้อมูลเบิกสินค้าออกจากคลัง",
        date_hint: "ช่วงวันที่ตามวันสั่งซื้อ ไม่เกิน 31 วัน",
        filter_date: "วันที่สั่งซื้อ",
        filter_platform: "แพลตฟอร์ม",
        filter_status: "สถานะ",
        all: "ทั้งหมด",
        platform_self: "ขายเอง (BO)",
        tab_summary: "สรุปตามสินค้า",
        tab_orders: "รายการออเดอร์",
        col_code: "รหัสสินค้า",
        col_name: "ชื่อสินค้า",
        col_barcode: "Barcode",
        col_qty: "จำนวนที่ต้องเบิก",
        col_qty_short: "จำนวน",
        col_order_count: "จำนวนออเดอร์",
        col_order_id: "เลขออเดอร์",
        col_platform_order_id: "เลขคำสั่งซื้อแพลตฟอร์ม",
        col_platform: "แพลตฟอร์ม",
        col_shop: "ร้านค้า",
        col_status: "สถานะ",
        col_created_at: "วันที่สั่งซื้อ",
        col_reason: "สาเหตุ",
        col_items: "สินค้า",
        total: "รวม",
        product_deleted: "(ลบแล้ว)",
        reason: {
            no_packing_close: "ไม่ได้ยิงปิดสินค้า",
            closed_without_items: "ปิดแพ็คแล้วแต่ไม่มีรายการตัดสต็อก",
        },
        reason_no_packing_close: "ไม่ได้ยิงปิดสินค้า",
        reason_closed_without_items: "ปิดแพ็คแล้วแต่ไม่มีรายการตัดสต็อก",
        mapping_missing: "ไม่มีข้อมูลจับคู่สินค้า",
        mapping_missing_banner: "{n} ออเดอร์ไม่มีข้อมูลจับคู่สินค้า — ไม่ถูกนับในสรุป ต้องตรวจสอบเอง",
        mapping_missing_link: "ดูรายการ",
        mapping_missing_only: "แสดงเฉพาะออเดอร์ที่ไม่มีข้อมูลจับคู่สินค้า",
        clear_filter: "ล้างตัวกรอง",
        returning_badge: "กำลังตีกลับ",
        empty: "ไม่พบสินค้าที่ส่งแล้วแต่ยังไม่ตัดสต็อกในช่วงนี้",
        as_of: "ข้อมูล ณ {time}",
        retry: "ลองใหม่",
        sheet_summary: "สรุปตามสินค้า",
        sheet_orders: "รายการออเดอร์",
        errors: {
            range_too_wide: "ช่วงวันที่ต้องไม่เกิน 31 วัน",
            too_many_rows: "รายการเกิน 5,000 ออเดอร์ กรุณาลดช่วงวันที่หรือเลือกแพลตฟอร์ม",
            report_index_missing: "ยังใช้รายงานนี้ไม่ได้ — ผู้ดูแลระบบต้องรัน SQL index (2026-10-09-wms-inventory-head-bo-order-id-index.sql) ก่อน",
            invalid_status: "สถานะที่เลือกไม่ถูกต้อง",
            invalid_request: "ข้อมูลที่ส่งไม่ถูกต้อง",
        },
    },
    // POS หน้าร้าน (#443, spec 2026-10-10-pos-module-design §7) — keep th/en keys identical
    pos: {
        menu: {
            root: "POS หน้าร้าน",
            bills: "บิลขาย POS",
            reports: "รายงาน POS",
            report_sales: "สรุปยอดขาย",
            report_top_spenders: "ลูกค้ายอดซื้อสูงสุด",
            report_products: "สินค้าขายดี",
            report_promotions: "โปรโมชั่นขายดี",
            manage: "ตั้งค่า POS",
            devices: "เครื่อง POS",
            events: "งาน / อีเวนต์",
            bundles: "ชุดโปรโมชั่น",
            settings: "ตั้งค่าทั่วไป",
            products: "สินค้า POS",
            report_event_members: "ผู้ซื้อตามรหัสในงาน",
        },
        role: {
            label: "สิทธิ์ POS",
            none: "ไม่มีสิทธิ์",
            seller: "พนักงานขาย",
            supervisor: "หัวหน้า",
            admin: "ผู้ดูแล",
            bo_menu: "เมนู POS ใน BO",
            bo_menu_hint: "เข้าหน้า POS ในหลังบ้าน (บิล/รายงาน; ระดับหัวหน้า = เครื่อง; ผู้ดูแล = งาน/สินค้า/ตั้งค่า) — ไม่เกี่ยวกับการขายในแอป",
            from_group: "สิทธิ์จากกลุ่มผู้ใช้",
        },
        not_installed: "ยังไม่ได้ติดตั้งตาราง POS — ให้ผู้ดูแลรัน sql/2026-10-10-pos-module.sql แล้วลองใหม่",
        not_installed_phase3: "ยังไม่ได้ติดตั้งตาราง POS เฟส 3 — ให้ผู้ดูแลรัน sql/2026-10-10-pos-phase3.sql แล้วลองใหม่",
        common: {
            save: "บันทึก",
            cancel: "ยกเลิก",
            delete: "ลบ",
            close: "ปิด",
            back: "ย้อนกลับ",
            search: "ค้นหา",
            export: "ส่งออก Excel",
            confirm: "ยืนยัน",
            saved: "บันทึกแล้ว",
            deleted: "ลบแล้ว",
            active: "เปิดใช้งาน",
            inactive: "ปิดใช้งาน",
            total_rows: "ทั้งหมด {n} รายการ",
            export_capped: "ส่งออกได้สูงสุด 20,000 แถว",
            menu: "เมนู",
            move_up: "เลื่อนขึ้น",
            move_down: "เลื่อนลง",
            remove: "เอาออก",
        },
        filter: {
            range: "ช่วงวันที่",
            event: "งาน",
            event_all: "ทุกงาน",
            event_default: "ชุดเริ่มต้นของเครื่อง",
            device: "เครื่อง",
            device_all: "ทุกเครื่อง",
            include_test: "รวมเครื่องทดสอบ",
            range_invalid: "กรุณาเลือกช่วงวันที่ให้ถูกต้อง",
            range_too_long: "เลือกช่วงวันที่ได้ไม่เกิน 92 วัน",
            status: "สถานะ",
            status_all: "ทั้งหมด",
            status_paid: "ชำระแล้ว",
            status_voided: "ยกเลิกแล้ว",
            payment: "ช่องทางชำระ",
            payment_all: "ทุกช่องทาง",
            search: "ค้นหา (เลขบิล / เบอร์ / ชื่อ)",
        },
        device: {
            add: "เพิ่มเครื่อง",
            apk: "APK",
            apk_title: "ดาวน์โหลดแอป POS",
            apk_hint: "สแกนด้วยเครื่อง POS (Sunmi V3) เพื่อดาวน์โหลดแอปเวอร์ชันล่าสุด แล้วกดติดตั้ง — ถ้าขึ้นว่าแอปถูกบล็อก ให้กด รายละเอียดเพิ่มเติม → ติดตั้งต่อไป",
            apk_copy: "คัดลอกลิงก์",
            apk_copied: "คัดลอกลิงก์แล้ว",
            apk_copy_failed: "คัดลอกลิงก์ไม่สำเร็จ",
            code: "รหัสเครื่อง",
            name: "ชื่อเครื่อง",
            status: "สถานะ",
            enabled: "เปิดใช้งาน",
            disabled: "ปิดใช้งาน",
            paired: "จับคู่แล้ว",
            not_paired: "ยังไม่จับคู่",
            last_seen: "ใช้งานล่าสุด",
            last_user: "ผู้ใช้ล่าสุด",
            is_test: "เครื่องทดสอบ",
            is_test_form: "เครื่องทดสอบ (ไม่นับในรายงาน)",
            bills: "บิล",
            note: "หมายเหตุ",
            edit: "แก้ไข",
            pairing_code_create: "สร้างรหัสจับคู่",
            unpair: "ยกเลิกการจับคู่",
            default_set: "สินค้าชุดเริ่มต้น",
            delete: "ลบ",
            form_title_add: "เพิ่มเครื่อง POS",
            form_title_edit: "แก้ไขเครื่อง POS",
            code_locked_hint: "เครื่องนี้มีบิลแล้ว จึงเปลี่ยนรหัสเครื่องไม่ได้",
            pairing_title: "รหัสจับคู่เครื่อง",
            pairing_expires: "หมดอายุใน {time}",
            pairing_expired: "รหัสหมดอายุแล้ว กรุณาสร้างใหม่",
            pairing_hint: "นำรหัสนี้ไปกรอกที่หน้าจอ จับคู่เครื่อง POS บนเครื่อง {code}",
            confirm_unpair: "ยกเลิกการจับคู่เครื่อง {code}?",
            confirm_delete: "ลบเครื่อง {code}?",
            unpaired_ok: "ยกเลิกการจับคู่แล้ว",
            default_set_title: "สินค้าชุดเริ่มต้น — {code}",
            default_products: "สินค้า",
            default_bundles: "ชุดโปรโมชั่น",
            product_search: "ค้นหาสินค้าเพื่อเพิ่ม",
            eligible_no: "ขายไม่ได้",
            mode: "โหมด",
            mode_app: "แอป (เข้าสู่ระบบถาวร)",
            mode_web: "เว็บ",
            session_user: "ผู้ใช้เครื่อง",
            passcode: "รหัสปลดล็อก",
            passcode_set: "ตั้งแล้ว",
            passcode_cooldown: "รอปลดล็อก (พักชั่วคราว)",
            passcode_hard_locked: "ล็อกถาวร",
            passcode_none: "—",
            passcode_reset: "รีเซ็ตรหัสเป็น 123456",
            passcode_reset_title: "รีเซ็ตรหัสเป็น 123456 — {code}",
            passcode_new: "รหัสใหม่ 6 หลัก",
            passcode_confirm: "ยืนยันรหัส",
            passcode_mismatch: "รหัสทั้งสองช่องไม่ตรงกัน",
            passcode_shape: "รหัสต้องเป็นตัวเลข 6 หลัก",
            passcode_weak_hint: "ห้ามใช้เลขเดียวกันทั้งหมด หรือเลขเรียงกัน เช่น 123456 / 654321",
            passcode_reset_ok: "ตั้งรหัสใหม่แล้ว — แจ้งรหัสให้พนักงานที่เครื่อง {code}",
            lock_idle: "ล็อกหน้าจออัตโนมัติ",
            lock_idle_hint: "เลือก 5 / 10 / 15 นาที หรือไม่ล็อกอัตโนมัติ (ค่าเริ่มต้น 5 นาที)",
            app_version: "เวอร์ชันแอป",
            staff: "พนักงานที่ใช้เครื่องนี้ได้",
            staff_title: "พนักงานที่ใช้เครื่องนี้ได้ — {code}",
            staff_hint: "เลือกได้ทุกคนในบริษัท — ไม่เลือกใคร = เครื่องนี้ไม่มีพนักงานใช้ได้ (เว้นแต่งานที่เครื่องอยู่กำหนดพนักงานไว้)",
            staff_all: "เลือกพนักงานที่ใช้เครื่องนี้ได้",
            staff_count: "{n} คน",
            pos_product_search: "ค้นหาสินค้า POS เพื่อเพิ่ม",
            lock_idle_col: "ล็อกอัตโนมัติ",
            lock_idle_300: "5 นาที",
            lock_idle_600: "10 นาที",
            lock_idle_900: "15 นาที",
            lock_idle_0: "ไม่ล็อกอัตโนมัติ",
            lock_idle_other: "ค่าเดิม (ตั้งใหม่)",
            passcode_reset_confirm: "รีเซ็ตรหัสปลดล็อกของเครื่อง {code} เป็น 123456? รหัสเดิมและการล็อกถาวรจะถูกล้าง เครื่องต้องปลดล็อกใหม่",
            passcode_reset_done: "รหัสปลดล็อกใหม่คือ 123456",
        },
        event: {
            add: "สร้างงาน",
            name: "ชื่องาน",
            location: "สถานที่",
            date_range: "ช่วงวันที่",
            start_date: "วันที่เริ่ม",
            end_date: "วันที่สิ้นสุด",
            end_before_start: "วันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่ม",
            status: "สถานะ",
            active_today: "กำลังเปิดวันนี้",
            devices: "เครื่อง POS",
            products: "สินค้า",
            bundles: "ชุดโปรฯ",
            bills: "บิล",
            cap_pct: "เพดานส่วนลดของพนักงาน (%)",
            cap_amount: "เพดานส่วนลดของพนักงาน (บาท)",
            cap_hint: "ว่างทั้งสองช่อง = พนักงานให้ส่วนลดไม่ได้ ต้องให้หัวหน้าอนุมัติ",
            note: "หมายเหตุ",
            tab_products: "สินค้าและราคาพิเศษ",
            tab_bundles: "ชุดโปรโมชั่น",
            tab_receipt: "ใบเสร็จ",
            product: "สินค้า",
            code: "รหัส",
            retail_price: "ราคาปกติ",
            special_price: "ราคาพิเศษ (ว่าง = ราคาปกติ)",
            receipt_override: "ใช้หัว/ท้ายใบเสร็จเฉพาะงานนี้",
            copy_default: "คัดลอกจากค่าเริ่มต้น",
            title_new: "สร้างงาน / อีเวนต์",
            title_edit: "แก้ไขงาน / อีเวนต์",
            confirm_delete: "ลบงานนี้?",
            image: "รูป",
            board_card: "บอร์ด Top Spender",
            board_enabled: "เปิดบอร์ดอันดับผู้ซื้อ (สาธารณะ)",
            board_url: "ลิงก์บอร์ด",
            board_copy: "คัดลอกลิงก์",
            board_open: "เปิดดู",
            board_copied: "คัดลอกลิงก์แล้ว",
            board_hint: "ใบเสร็จของงานนี้จะพิมพ์ QR ไปยังบอร์ด",
            board_no_url: "ลิงก์บอร์ดจะแสดงหลังบันทึกงาน (และเมื่อเซิร์ฟเวอร์ตั้ง pos.board_base_url แล้ว)",
            tab_payment: "บัญชีรับเงิน",
            payment_override: "ใช้บัญชีรับเงินเฉพาะงานนี้",
            staff_title: "พนักงานในงาน",
            staff_hint: "เลือกได้ทุกคนในบริษัท — ไม่เลือกใคร = ใช้รายชื่อพนักงานของเครื่อง; ถ้าเครื่องก็ไม่ได้กำหนด จะไม่มีพนักงานใช้ได้",
            staff_placeholder: "เลือกพนักงานที่ขายในงานนี้",
            staff_not_installed: "ยังไม่ได้ติดตั้งตารางพนักงานในงาน — ให้ผู้ดูแลรัน sql/2026-10-10-pos-phase3c-event-staff.sql",
            staff_after_save: "บันทึกงานก่อน แล้วจึงเลือกพนักงานในงาน",
            staff_load_error: "โหลดรายชื่อพนักงานในงานไม่สำเร็จ",
            staff_retry: "ลองใหม่",
        },
        bundle: {
            add: "เพิ่มชุดโปรโมชั่น",
            name: "ชื่อชุด",
            code: "รหัส",
            price: "ราคาชุด",
            retail_total: "ราคาปกติรวม",
            item_count: "จำนวนรายการ",
            used_in: "ใช้ในงาน",
            status: "สถานะ",
            product: "สินค้า",
            qty: "จำนวน",
            retail_price: "ราคาปกติ",
            line_total: "รวม",
            summary: "ราคาปกติรวม {retail} · ลูกค้าประหยัด {saving}",
            title_add: "เพิ่มชุดโปรโมชั่น",
            title_edit: "แก้ไขชุดโปรโมชั่น",
            confirm_delete: "ลบชุดโปรโมชั่นนี้?",
        },
        settings: {
            promptpay_card: "พร้อมเพย์",
            promptpay_id: "หมายเลขพร้อมเพย์ (เบอร์โทร 10 หลัก / เลขประจำตัว 13 หลัก)",
            promptpay_name: "ชื่อบัญชีที่แสดงใต้ QR",
            cap_card: "เพดานส่วนลดเมื่อไม่มีงาน",
            cap_pct: "(%)",
            cap_amount: "(บาท)",
            receipt_card: "หัว/ท้ายใบเสร็จ (ค่าเริ่มต้น)",
            logo: "โลโก้",
            logo_upload: "อัปโหลด png/jpg",
            logo_remove: "ลบโลโก้",
            logo_hint: "ระบบย่อเหลือกว้างไม่เกิน 384 px เป็นภาพขาวดำ ขนาดไม่เกิน 200 KB",
            logo_too_big: "โลโก้ใหญ่เกิน 200 KB หลังย่อแล้ว กรุณาใช้ภาพที่เรียบง่ายกว่านี้",
            shop_name: "ชื่อร้าน",
            address: "ที่อยู่",
            phone: "เบอร์โทร",
            header_note: "ข้อความหัวใบเสร็จ",
            footer_text: "ข้อความท้ายใบเสร็จ",
            footer_qr_text: "QR ท้ายใบเสร็จ (ลิงก์หรือข้อความ)",
            footer_qr_caption: "คำอธิบายใต้ QR",
            show_customer_address: "แสดงที่อยู่ลูกค้าบนใบเสร็จ",
            preview: "ตัวอย่างใบเสร็จ 80 มม.",
        },
        bill: {
            bill_no: "เลขที่บิล",
            datetime: "วันเวลา",
            device: "เครื่อง",
            event: "งาน",
            seller: "พนักงาน",
            customer: "ลูกค้า",
            phone: "เบอร์โทร",
            qty: "จำนวน",
            subtotal: "ยอดรวม",
            discount: "ส่วนลด",
            net: "ยอดสุทธิ",
            payment: "ชำระโดย",
            status: "สถานะ",
            void_reason: "เหตุผลยกเลิก",
            reprint_count: "พิมพ์ซ้ำ (ครั้ง)",
            view: "ดูบิล",
            reprint: "พิมพ์ซ้ำ",
            void: "ยกเลิกบิล",
            voided_tag: "ยกเลิกแล้ว",
            paid_tag: "ชำระแล้ว",
            cash: "เงินสด",
            transfer: "โอน / พร้อมเพย์",
            sum_bills: "บิล",
            sum_net: "ยอดสุทธิ",
            sum_cash: "เงินสด",
            sum_transfer: "โอน",
            void_title: "ยกเลิกบิล",
            void_reason_label: "เหตุผลที่ยกเลิก",
            void_reason_min: "กรุณาระบุเหตุผลอย่างน้อย 3 ตัวอักษร",
            voided_ok: "ยกเลิกบิลแล้ว",
            detail_title: "รายละเอียดบิล",
            mid: "รหัสผู้ซื้อ",
            mid_filter: "รหัสผู้ซื้อ",
            mid_needs_event: "เลือกงานก่อนจึงกรองรหัสผู้ซื้อได้",
        },
        report: {
            group_by: "แสดงตาม",
            by_day: "รายวัน",
            by_device: "ตามเครื่อง",
            by_seller: "ตามพนักงาน",
            by_event: "ตามงาน",
            bills: "บิล",
            items: "ชิ้น",
            gross: "ยอดก่อนส่วนลด",
            discount: "ส่วนลด",
            net: "ยอดสุทธิ",
            cash: "เงินสด (บิล)",
            transfer: "โอน (บิล)",
            cash_amount: "เงินสด",
            cash_count: "เงินสด (บิล)",
            transfer_amount: "โอน",
            transfer_count: "โอน (บิล)",
            total: "รวม",
            voided_note: "บิลที่ยกเลิก {n} บิล ({amount} บาท) ไม่รวมในยอด",
            chart_net: "ยอดสุทธิ (เงินสด + โอน)",
            chart_top: "10 อันดับแรก",
            rank: "อันดับ",
            phone: "เบอร์โทร",
            name: "ชื่อ",
            phone_prefix: "ค้นหาเบอร์โทร",
            bill_count: "จำนวนบิล",
            total_spent: "ยอดซื้อรวม",
            avg_bill: "เฉลี่ยต่อบิล",
            first_bill: "ซื้อครั้งแรก",
            last_bill: "ซื้อล่าสุด",
            customer_title: "ลูกค้า",
            customer_profile: "ข้อมูลลูกค้า",
            address: "ที่อยู่",
            bills_of_customer: "บิลของลูกค้า",
            product: "สินค้า",
            code: "รหัส",
            qty_single: "ขายเดี่ยว (ชิ้น)",
            qty_in_bundle: "ในชุดโปรฯ (ชิ้น)",
            qty_total: "รวม (ชิ้น)",
            amount: "ยอดขาย",
            amount_single: "ยอดขายเดี่ยว",
            amount_bundle: "ยอดในชุดโปรฯ",
            qty_special: "ขายราคาพิเศษ (ชิ้น)",
            sort_by: "เรียงตาม",
            sort_qty: "จำนวน",
            sort_amount: "ยอดขาย",
            products_note: "ยอดขายเป็นยอดก่อนส่วนลดท้ายบิล",
            section_bundles: "ชุดโปรโมชั่น",
            section_special: "ราคาพิเศษ",
            section_discount: "ส่วนลดท้ายบิล",
            bundle: "ชุดโปรโมชั่น",
            qty: "จำนวน",
            retail_value: "มูลค่าราคาปกติ",
            savings: "ลูกค้าประหยัด",
            event: "งาน",
            discount_given: "ส่วนลดที่ให้",
            discount_total: "ส่วนลดรวม",
            approved_count: "อนุมัติเกินสิทธิ์ (บิล)",
            approved_total: "ยอดส่วนลดที่อนุมัติ",
            no_data: "ไม่มีข้อมูล",
            level: "ระดับ",
            level_pos: "สินค้า POS",
            level_wms: "สินค้า WMS",
            wms_product: "สินค้า WMS",
            wms_code: "รหัส WMS",
            qty_pieces: "จำนวน (ชิ้น)",
            mid: "รหัสผู้ซื้อ",
            mid_search: "ค้นหา (รหัสผู้ซื้อ / เบอร์)",
            mid_bills: "บิลของผู้ซื้อ {mid}",
            mid_event: "งาน",
            mid_event_pick: "เลือกงาน",
            mid_event_required: "กรุณาเลือกงานก่อน",
            members: "ผู้ซื้อ",
            open_board: "เปิดบอร์ดสาธารณะ",
            top_spenders_day: "ผู้ซื้อยอดสูงสุดของวัน (ตามรหัสผู้ซื้อ)",
            top_spenders_day_hint: "10 อันดับแรกของงานที่เลือก ในวันที่เลือก ไม่รวมบิลที่ยกเลิก",
        },
        product: {
            add: "เพิ่มสินค้า POS",
            search: "ค้นหาชื่อ / รหัส",
            status_all: "ทุกสถานะ",
            image: "รูป",
            image_label: "รูปสินค้า",
            image_upload: "อัปโหลด png/jpg",
            image_remove: "ลบรูป",
            image_hint: "ระบบย่อให้ด้านยาวไม่เกิน 800 px (JPEG)",
            image_too_big: "รูปใหญ่เกิน 1 MB หลังย่อแล้ว กรุณาใช้รูปอื่น",
            name: "ชื่อสินค้า",
            code: "รหัส",
            price: "ราคา",
            price_baht: "ราคา (บาท)",
            wms: "สินค้า WMS",
            used_in_events: "ใช้ในงาน",
            device_sets: "ชุดเริ่มต้นของเครื่อง",
            status: "สถานะ",
            note: "หมายเหตุ",
            edit: "แก้ไข",
            delete: "ลบ",
            sold_hint: "ขายแล้ว ปิดใช้งานแทน",
            wms_section: "สินค้า WMS ในชุดนี้",
            wms_search: "ค้นหาสินค้า WMS (รหัส / ชื่อ / บาร์โค้ด)",
            wms_qty: "จำนวน",
            wms_add: "+ เพิ่มสินค้า WMS",
            wms_footer: "รวม {n} รายการ · {q} ชิ้น",
            wms_hint: "ใช้สำหรับรายงาน ไม่ตัดสต็อก",
            wms_missing: "สินค้า WMS นี้ถูกลบหรือปิดใช้งานแล้ว",
            title_add: "เพิ่มสินค้า POS",
            title_edit: "แก้ไขสินค้า POS",
            confirm_delete: "ลบสินค้า POS นี้?",
            picker: "ค้นหาสินค้า POS เพื่อเพิ่ม",
            inactive_tag: "ปิดใช้งาน",
            pieces: "{n} ชิ้น",
        },
        payment_account: {
            card: "บัญชีรับเงินโอน",
            mode: "รูปแบบการรับเงิน",
            mode_promptpay: "พร้อมเพย์ (QR ระบุยอดเงิน)",
            mode_static_qr_image: "QR ร้านค้าจากธนาคาร (รูปภาพ เช่น K SHOP)",
            mode_bank_account_only: "แสดงเลขบัญชีเท่านั้น (ไม่มี QR)",
            mode_helper: "เลขบัญชีธนาคารทำ QR ระบุยอดเงินไม่ได้ — หากต้องการ QR ระบุยอด ให้ใช้พร้อมเพย์ที่ผูกกับเลขผู้เสียภาษีของบริษัท หรืออัปโหลด QR ร้านค้าจากธนาคาร",
            bank: "ธนาคาร",
            account_no: "เลขที่บัญชี",
            account_name: "ชื่อบัญชี",
            promptpay_type: "ประเภทพร้อมเพย์",
            promptpay_type_phone: "เบอร์โทรศัพท์",
            promptpay_type_tax_id: "เลขประจำตัวผู้เสียภาษี 13 หลัก",
            promptpay_type_ewallet: "e-Wallet 15 หลัก",
            promptpay_id: "หมายเลขพร้อมเพย์",
            tax_id_invalid: "เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง",
            promptpay_id_invalid: "หมายเลขพร้อมเพย์ไม่ถูกต้องสำหรับประเภทที่เลือก",
            account_no_invalid: "เลขที่บัญชีต้องเป็นตัวเลข 10–15 หลัก",
            account_name_required: "กรุณาระบุชื่อบัญชี",
            qr_image: "รูป QR",
            qr_upload: "อัปโหลด png/jpg",
            qr_change: "เปลี่ยนรูป",
            qr_hint: "ระบบย่อให้ไม่เกิน 600 px และไม่เกิน 300 KB",
            qr_too_big: "รูป QR ใหญ่เกิน 300 KB หลังย่อแล้ว",
            qr_required: "กรุณาอัปโหลดรูป QR",
            show_on_receipt: "แสดงบัญชีรับเงินบนใบเสร็จ (บิลโอน)",
            save: "บันทึกบัญชีรับเงิน",
            preview: "ตัวอย่างหน้าจอรับเงินโอน",
            preview_amount: "ยอดที่ต้องโอน",
            preview_dynamic_qr: "QR พร้อมเพย์ระบุยอดเงิน (สร้างที่เครื่อง POS)",
            preview_no_amount: "QR นี้ไม่ระบุยอดเงิน — ลูกค้าต้องกรอกยอดเอง",
            preview_no_qr: "ไม่มี QR — ลูกค้าโอนเข้าบัญชีด้านล่าง",
            receipt_line: "บรรทัดบนใบเสร็จ",
            none: "ยังไม่ได้ตั้งบัญชีรับเงิน",
            banks: {
                KBANK: "ธนาคารกสิกรไทย",
                SCB: "ธนาคารไทยพาณิชย์",
                BBL: "ธนาคารกรุงเทพ",
                KTB: "ธนาคารกรุงไทย",
                BAY: "ธนาคารกรุงศรีอยุธยา",
                TTB: "ธนาคารทหารไทยธนชาต",
                GSB: "ธนาคารออมสิน",
                BAAC: "ธ.ก.ส.",
                GHB: "ธนาคารอาคารสงเคราะห์",
                UOB: "ธนาคารยูโอบี",
                CIMB: "ธนาคารซีไอเอ็มบี ไทย",
                KKP: "ธนาคารเกียรตินาคินภัทร",
                LHB: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
                TISCO: "ธนาคารทิสโก้",
            },
        },
        errors: {
            generic: "เกิดข้อผิดพลาด กรุณาลองใหม่",
            pos_address_invalid: "ที่อยู่ไม่ถูกต้อง",
            pos_approval_bad_request: "ข้อมูลการอนุมัติไม่ครบถ้วน",
            pos_approval_failed: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
            pos_approval_invalid: "การอนุมัติหมดอายุหรือใช้ไปแล้ว",
            pos_approval_not_supervisor: "บัญชีนี้ไม่มีสิทธิ์อนุมัติ",
            pos_bad_request: "ข้อมูลไม่ถูกต้อง",
            pos_bill_already_voided: "บิลนี้ถูกยกเลิกไปแล้ว",
            pos_bill_invalid: "ข้อมูลบิลไม่ถูกต้อง",
            pos_bill_not_found: "ไม่พบบิล",
            pos_bill_other_device: "บิลนี้เป็นของเครื่องอื่น",
            pos_bundle_has_bills: "ชุดนี้เคยขายแล้ว ลบไม่ได้ — ให้ปิดใช้งานแทน",
            pos_bundle_invalid: "ข้อมูลชุดโปรโมชั่นไม่ถูกต้อง (ต้องมีสินค้าอย่างน้อย 1 รายการ และราคามากกว่า 0)",
            pos_bundle_not_found: "ไม่พบชุดโปรโมชั่น",
            pos_cash_insufficient: "รับเงินไม่พอกับยอดสุทธิ",
            pos_device_code_invalid: "รหัสเครื่องต้องเป็น A–Z หรือ 0–9 ยาว 2–10 ตัว",
            pos_device_code_locked: "เครื่องนี้มีบิลแล้ว เปลี่ยนรหัสเครื่องไม่ได้",
            pos_device_code_taken: "รหัสเครื่องนี้ถูกใช้แล้ว",
            pos_device_disabled: "เครื่องนี้ถูกปิดใช้งาน",
            pos_device_has_bills: "เครื่องนี้มีบิลแล้ว ลบไม่ได้ — ให้ปิดใช้งานแทน",
            pos_device_not_found: "ไม่พบเครื่อง POS",
            pos_device_unpaired: "เครื่องนี้ยังไม่ได้จับคู่",
            pos_device_wrong_enterprise: "เครื่องนี้เป็นของร้านอื่น",
            pos_discount_exceeds_subtotal: "ส่วนลดมากกว่ายอดรวม",
            pos_discount_invalid: "ส่วนลดไม่ถูกต้อง",
            pos_discount_needs_approval: "ส่วนลดเกินสิทธิ์ ต้องให้หัวหน้าอนุมัติ",
            pos_event_has_bills: "งานนี้มีบิลแล้ว ลบไม่ได้ — ให้ปิดใช้งานแทน",
            pos_event_inactive: "งานนี้ปิดแล้ว กรุณาเลือกงานใหม่",
            pos_event_invalid: "ข้อมูลงานไม่ถูกต้อง (ตรวจวันที่และเพดานส่วนลด)",
            pos_event_not_found: "ไม่พบงาน",
            pos_export_too_large: "ข้อมูลเกิน 20,000 แถว กรุณาลดช่วงวันที่",
            pos_forbidden: "ไม่มีสิทธิ์ทำรายการนี้",
            pos_internal: "ระบบขัดข้อง กรุณาลองใหม่",
            pos_item_not_available: "สินค้าบางรายการไม่สามารถขายได้แล้ว",
            pos_logo_invalid: "โลโก้ต้องเป็นไฟล์ png/jpg ไม่เกิน 200 KB",
            pos_no_catalog: "เครื่องนี้ยังไม่มีสินค้าให้ขาย กรุณาติดต่อผู้ดูแล",
            pos_not_installed: "ระบบ POS ยังไม่พร้อมใช้งาน (ยังไม่ได้ติดตั้งฐานข้อมูล)",
            pos_pairing_invalid: "รหัสจับคู่ไม่ถูกต้องหรือหมดอายุ",
            pos_pairing_locked: "ใส่รหัสผิดเกิน 5 ครั้ง กรุณาสร้างรหัสใหม่",
            pos_phone_invalid: "เบอร์โทรไม่ถูกต้อง",
            pos_product_ineligible: "มีสินค้าที่ขายผ่าน POS ไม่ได้ (ต้องเป็นสินค้าหลังบ้านที่เปิดขาย)",
            pos_promptpay_invalid: "หมายเลขพร้อมเพย์ต้องเป็นตัวเลข 10, 13 หรือ 15 หลัก",
            pos_range_invalid: "ช่วงวันที่ไม่ถูกต้อง",
            pos_range_too_long: "เลือกช่วงวันที่ได้ไม่เกิน 92 วัน",
            pos_total_mismatch: "ราคามีการเปลี่ยนแปลง กรุณาตรวจสอบบิลอีกครั้ง",
            pos_transfer_unconfirmed: "กรุณายืนยันว่าได้รับเงินโอนแล้ว",
            pos_void_needs_approval: "การยกเลิกบิลต้องให้หัวหน้าอนุมัติ",
            pos_void_reason_required: "กรุณาระบุเหตุผลอย่างน้อย 3 ตัวอักษร",
            pos_zipcode_invalid: "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
            pos_phase3_not_installed: "ยังไม่ได้ติดตั้งตาราง POS เฟส 3",
            pos_device_session_disabled: "เครื่องนี้ไม่ได้อยู่ในโหมดแอป",
            pos_session_user_invalid: "ผู้ที่จับคู่เครื่องนี้ไม่มีสิทธิ์ POS แล้ว — ต้องจับคู่ใหม่",
            pos_device_locked: "เครื่องถูกล็อก — ปลดล็อกด้วยรหัส",
            pos_passcode_invalid: "รหัสต้องเป็นตัวเลข 6 หลัก",
            pos_passcode_weak: "รหัสง่ายเกินไป (เลขเดียวกันทั้งหมดหรือเลขเรียงกัน)",
            pos_passcode_wrong: "รหัสไม่ถูกต้อง",
            pos_passcode_cooldown: "ใส่รหัสผิดหลายครั้ง กรุณารอสักครู่",
            pos_passcode_hard_locked: "ใส่รหัสผิดเกิน 10 ครั้ง — หัวหน้าต้องตั้งรหัสใหม่ในหลังบ้าน",
            pos_passcode_not_set: "เครื่องนี้ยังไม่ได้ตั้งรหัสปลดล็อก",
            pos_device_not_app: "เครื่องนี้ไม่ได้จับคู่แบบแอป จึงตั้งรหัสปลดล็อกไม่ได้",
            pos_device_invalid: "ข้อมูลเครื่องไม่ถูกต้อง (ล็อกหน้าจอ 30–3600 วินาที / พนักงานต้องมีสิทธิ์ POS)",
            pos_product_invalid: "ข้อมูลสินค้า POS ไม่ถูกต้อง",
            pos_product_code_taken: "รหัสสินค้านี้ถูกใช้แล้ว",
            pos_product_has_bills: "สินค้านี้ขายแล้ว ลบไม่ได้ — ให้ปิดใช้งานแทน",
            pos_product_not_found: "ไม่พบสินค้า POS",
            pos_image_invalid: "รูปต้องเป็น png/jpg ไม่เกิน 1 MB",
            pos_mid_invalid: "รหัสผู้ซื้อไม่ถูกต้อง",
            pos_mid_not_found: "ไม่พบรหัสผู้ซื้อนี้ในงาน",
            pos_mid_no_event: "กรุณาเลือกงานก่อนค้นหารหัสผู้ซื้อ",
            pos_event_required: "กรุณาเลือกงาน",
            pos_board_not_found: "ไม่พบบอร์ด",
            pos_rate_limited: "เรียกใช้งานถี่เกินไป กรุณารอสักครู่",
            pos_payment_account_invalid: "ข้อมูลบัญชีรับเงินไม่ถูกต้อง",
            pos_qr_image_invalid: "รูป QR ต้องเป็น png/jpg ไม่เกิน 300 KB",
            pos_staff_not_allowed: "พนักงานคนนี้ใช้เครื่องนี้ไม่ได้",
            pos_lock_idle_invalid: "เลือกเวลาล็อกได้เฉพาะ 5 / 10 / 15 นาที หรือไม่ล็อก",
            pos_event_staff_not_installed: "ยังไม่ได้ติดตั้งตารางพนักงานในงาน",
        },
    },
    // การตลาด — หน้า Landing (โฆษณา) + รายงานที่มาของออเดอร์ (Phase 1 ads §6.6)
    marketing: {
        menu: {
            root: "การตลาด",
            landing_pages: "หน้า Landing (โฆษณา)",
            attribution: "ที่มาของออเดอร์ / โฆษณา",
            referral_codes: "รหัสแนะนำ",
            referral_report: "รายงานรหัสแนะนำ",
            affiliate_settings: "Affiliate: ตั้งค่า",
            affiliate_members: "Affiliate: สมาชิก",
            affiliate_commissions: "Affiliate: รายการค่าคอม",
            affiliate_payouts: "Affiliate: รอบจ่ายเงิน",
            affiliate_report: "รายงาน Affiliate",
        },
        role_label: "การตลาด (หน้า Landing / รายงานที่มา / รหัสแนะนำ / Affiliate)",
        referral: {
            create: "สร้างรหัส",
            bulk_create: "สร้างหลายรหัส",
            edit: "แก้ไข",
            disable: "ปิดใช้งาน",
            enable: "เปิดใช้งาน",
            copy_link: "คัดลอกลิงก์",
            download_qr: "ดาวน์โหลด QR",
            view_report: "ดูรายงาน",
            generate: "สุ่มรหัส",
            export_csv: "ส่งออก CSV",
            copied: "คัดลอกแล้ว",
            search: "ค้นหารหัสหรือชื่อ",
            tab_all: "ทั้งหมด",
            filter_owner: "พนักงาน",
            filter_team: "ทีม",
            filter_campaign: "แคมเปญ",
            none_label: "(ไม่ระบุ)",
            no_reward: "ไม่มี",
            always: "ไม่จำกัดเวลา",
            batch_filter: "กำลังดูรหัสจากการสร้างครั้งเดียวกัน",
            clear_filter: "ล้างตัวกรอง",
            save: "บันทึก",
            cancel: "ยกเลิก",
            close: "ปิด",
            confirm: "ยืนยัน",
            reload: "โหลดใหม่",
            done: "เสร็จสิ้น",
            created: "สร้างรหัสแล้ว",
            saved: "บันทึกแล้ว",
            disabled_ok: "ปิดใช้งานรหัสแล้ว",
            enabled_ok: "เปิดใช้งานรหัสแล้ว",
            confirm_disable: "ปิดใช้งานรหัส {code}? ลิงก์และรหัสนี้จะใช้สมัครไม่ได้จนกว่าจะเปิดอีกครั้ง",
            link_card: "ลิงก์และ QR",
            code_blank_hint: "เว้นว่างไว้ ระบบจะสุ่มรหัสให้ตอนบันทึก (ใช้คำนำหน้าถ้ากรอก)",
            code_readonly: "แก้รหัสไม่ได้หลังสร้าง (พิมพ์อยู่บน QR และลิงก์แล้ว)",
            prefix_hint: "ไม่บังคับ ไม่เกิน 8 ตัว (A–Z, 0–9)",
            lp_placeholder: "เลือกหน้า Landing ที่เผยแพร่อยู่",
            custom_placeholder: "เช่น /p/12 หรือ /products?x=1",
            owner_placeholder: "พิมพ์ชื่อพนักงานเพื่อค้นหา",
            template_placeholder: "เลือกแม่แบบคูปอง",
            datetime_placeholder: "ไม่กำหนด",
            code_status: {
                checking: "กำลังตรวจสอบ…",
                available: "ใช้รหัสนี้ได้",
                taken: "รหัสนี้ถูกใช้แล้ว",
                format: "รหัสต้องเป็น A–Z หรือ 0–9 ยาว 4–16 ตัว",
            },
            state: {
                active: "ใช้งานได้",
                scheduled: "ตั้งเวลา",
                expired: "หมดเวลา",
                full: "ครบจำนวน",
                disabled: "ปิดใช้งาน",
            },
            col: {
                code: "รหัส",
                name: "ชื่อ",
                owner: "พนักงาน",
                team: "ทีม",
                campaign: "แคมเปญ",
                reward: "รางวัล",
                used: "ใช้แล้ว",
                window: "ช่วงเวลา",
                state: "สถานะ",
                actions: "เมนู",
                link: "ลิงก์",
            },
            field: {
                code: "รหัส",
                prefix: "คำนำหน้ารหัส",
                name: "ชื่อ",
                owner: "พนักงานเจ้าของรหัส",
                team: "ทีม",
                campaign: "แคมเปญ",
                landing: "เปิดหน้าไหนหลังกดลิงก์",
                landing_home: "หน้าแรก",
                landing_lp: "หน้า Landing",
                landing_custom: "กำหนดเอง",
                reward: "รางวัลเมื่อสมัครสำเร็จ",
                reward_none: "ไม่มี",
                reward_coupon: "ให้คูปองอัตโนมัติ",
                template: "แม่แบบคูปอง",
                max_uses: "จำนวนครั้งสูงสุด",
                unlimited: "ไม่จำกัด",
                starts_at: "วันเริ่ม",
                ends_at: "วันสิ้นสุด",
                note: "หมายเหตุ",
            },
            bulk: {
                mode_owner: "หนึ่งรหัสต่อพนักงาน",
                mode_count: "จำนวน N รหัส",
                count: "จำนวน",
                result: "รหัสที่สร้าง",
                view_in_list: "ดูในรายการ",
                owners: "พนักงาน",
                create: "สร้าง",
                download_csv: "ดาวน์โหลด CSV",
                name_hint: "เว้นว่างเพื่อตั้งชื่ออัตโนมัติ (แคมเปญหรือทีม + พนักงาน / ลำดับ)",
                created_n: "สร้าง {n} รหัสแล้ว",
                mode: "รูปแบบ",
            },
            hint: {
                link: "ลิงก์นี้พาไปที่ {landing} และกรอกรหัสให้ลูกค้าอัตโนมัติ",
                reward_future: "มีผลกับผู้สมัครหลังจากนี้เท่านั้น",
                welcome_dup: "สมาชิกใหม่จะได้คูปองต้อนรับอยู่แล้ว — คูปองนี้จะได้เพิ่มอีกใบ",
                template_dead: "คูปองใช้ไม่ได้",
            },
            err: {
                code_taken: "รหัสนี้ถูกใช้แล้ว",
                code_format: "รหัสต้องเป็น A–Z หรือ 0–9 ยาว 4–16 ตัว",
                template_invalid: "แม่แบบคูปองนี้ใช้ไม่ได้",
                invalid_landing: "ลิงก์ต้องขึ้นต้นด้วย /",
                below_used: "ต่ำกว่าจำนวนที่ใช้ไปแล้ว",
                stale: "มีผู้อื่นแก้ไขรหัสนี้ — โหลดใหม่",
                too_many: "สร้างได้ไม่เกิน 200 รหัสต่อครั้ง",
                required: "กรุณากรอก",
                max_length: "ยาวเกินกำหนด",
                range: "ค่าไม่ถูกต้อง",
                format: "รูปแบบไม่ถูกต้อง",
                owner_not_found: "ไม่พบพนักงานคนนี้",
                not_found: "ไม่พบรหัสนี้",
                not_retryable: "รายการนี้ให้คูปองซ้ำไม่ได้",
                generic: "ทำรายการไม่สำเร็จ",
                load: "โหลดข้อมูลไม่สำเร็จ",
            },
            tpl: {
                discount: "ส่วนลด {v}",
                expiry: "หมดอายุ {n} วันหลังได้รับ",
                left: "เหลือ {n} สิทธิ์",
                unlimited: "ไม่จำกัดสิทธิ์",
            },
            reward_status: {
                none: "ไม่มีรางวัล",
                pending: "รอยืนยันเบอร์",
                granted: "ได้รับแล้ว",
                failed: "ไม่สำเร็จ",
                retry: "ให้คูปองอีกครั้ง",
                retried: "ให้คูปองแล้ว",
                coupon_used: "ใช้คูปองแล้ว",
                error: {
                    template_inactive: "แม่แบบถูกปิด",
                    template_missing: "ไม่พบแม่แบบ",
                    template_expired: "แม่แบบหมดอายุ",
                    quota_exhausted: "สิทธิ์คูปองหมด",
                    error: "ผิดพลาด",
                },
            },
            report: {
                title: "รายงานรหัสแนะนำ",
                range: "ช่วงวันที่",
                cohort: "กลุ่มสมาชิก",
                cohort_all: "สมาชิกทุกคนที่มาจากรหัส",
                cohort_range: "เฉพาะที่สมัครในช่วงนี้",
                group_by: "จัดกลุ่มตาม",
                group: {
                    code: "รหัส",
                    owner: "พนักงาน",
                    team: "ทีม",
                    campaign: "แคมเปญ",
                },
                owner: "พนักงาน",
                team: "ทีม",
                campaign: "แคมเปญ",
                code: "รหัส",
                search: "ค้นหา",
                export: "ส่งออก CSV",
                all: "ทั้งหมด",
                card: {
                    signups: "สมัครใหม่",
                    signups_rewarded: "ได้รับคูปอง",
                    members_ordered: "สมาชิกที่สั่งซื้อ",
                    orders: "ออเดอร์",
                    revenue_placed: "ยอดสั่งซื้อ",
                    revenue_completed: "ยอดสำเร็จ (130)",
                    revenue_cancelled_returned: "ยอดยกเลิก/ตีกลับ",
                },
                col: {
                    code: "รหัส",
                    name: "ชื่อ",
                    owner_name: "พนักงาน",
                    team: "ทีม",
                    campaign: "แคมเปญ",
                    signups: "สมัครใหม่",
                    signups_rewarded: "ได้คูปอง",
                    members_ordered: "สมาชิกที่สั่งซื้อ",
                    conversion: "% ซื้อ",
                    orders: "ออเดอร์",
                    open: "กำลังดำเนินการ",
                    completed: "สำเร็จ",
                    cancelled: "ยกเลิก",
                    returned: "ตีกลับ",
                    revenue_placed: "ยอดสั่งซื้อ",
                    revenue_completed: "ยอดสำเร็จ",
                    revenue_cancelled_returned: "ยอดยกเลิก/ตีกลับ",
                    aov: "AOV",
                },
                total: "รวม",
                empty: "ไม่มีข้อมูล",
                truncated: "แสดง 1,000 แถวแรก — ส่งออก CSV เพื่อดูทั้งหมด",
                invalid_range: "ช่วงวันที่ไม่ถูกต้อง (ไม่เกิน 366 วัน)",
                load_error: "โหลดรายงานไม่สำเร็จ",
                footnote: "นับเฉพาะออเดอร์ร้าน MadameFin (เว็บ/แอป/แชท) ที่ยืนยันแล้ว — COD นับตอนสั่ง, โอน/บัตรนับเมื่อชำระแล้ว · สถานะตามปัจจุบัน",
                drawer_title: "สมาชิกจากรหัสแนะนำ",
                export_members: "ส่งออก CSV",
                deleted: "(ลบบัญชีแล้ว)",
                source: {
                    link: "ลิงก์",
                    typed: "พิมพ์เอง",
                    unknown: "ไม่ทราบ",
                },
                channel: {
                    phone: "เบอร์โทร",
                    line: "LINE",
                    facebook: "Facebook",
                    email: "อีเมล",
                },
                m: {
                    name: "ชื่อ",
                    phone: "เบอร์",
                    signed_up_at: "สมัครเมื่อ",
                    channel: "ช่องทาง",
                    source: "มาจาก",
                    code: "รหัส",
                    coupon: "คูปอง",
                    orders: "ออเดอร์",
                    completed: "สำเร็จ",
                    cancelled_returned: "ยกเลิก/ตีกลับ",
                    revenue_placed: "ยอดสั่งซื้อ",
                    revenue_completed: "ยอดสำเร็จ",
                    last_order: "สั่งล่าสุด",
                },
            },
        },
        schema_missing: "ยังไม่ได้ติดตั้งฐานข้อมูลส่วนนี้ (รอรันไฟล์ SQL)",
        // Phase 3 affiliate (spec 2026-10-13 §5.7)
        affiliate: {
            env_off: "เซิร์ฟเวอร์นี้ยังไม่เปิดใช้ Affiliate (affiliate.env_enabled) — ตั้งค่าได้ แต่หน้าร้านจะยังไม่แสดง",
            save: "บันทึก",
            saved: "บันทึกแล้ว",
            cancel: "ยกเลิก",
            confirm: "ยืนยัน",
            reload: "โหลดใหม่",
            edit: "แก้ไข",
            search: "ค้นหา",
            export_csv: "ส่งออก CSV",
            actions: "จัดการ",
            all: "ทั้งหมด",
            empty: "ไม่มีข้อมูล",
            copy: "คัดลอก",
            copied: "คัดลอกแล้ว",
            on: "เปิด",
            off: "ปิด",
            reason: "เหตุผล",
            reason_required: "กรุณาระบุเหตุผล",
            reason_too_long: "เหตุผลยาวเกิน 300 ตัวอักษร",
            updated_by: "แก้ไขล่าสุดโดย {name} เมื่อ {at}",
            settings: {
                tab_program: "ตั้งค่าโปรแกรม",
                tab_rates: "อัตราค่าคอม",
                enabled: "เปิดใช้งานโปรแกรม",
                click_window_days: "ระยะเวลานับคลิก (วัน)",
                maturity_days: "รอยืนยันหลังออเดอร์สำเร็จ (วัน)",
                min_payout: "ยอดขั้นต่ำการจ่าย (บาท)",
                wht: "หัก ณ ที่จ่าย 3%",
                terms_th: "เงื่อนไข (ไทย)",
                terms_en: "เงื่อนไข (อังกฤษ)",
                bump_terms: "บันทึกเป็นเงื่อนไขเวอร์ชันใหม่ (สมาชิกต้องกดยอมรับใหม่)",
                confirm_on: "สมาชิกที่ได้รับสิทธิ์ Affiliate (ให้สิทธิ์ที่หน้าจัดการสมาชิก) และยืนยันเบอร์แล้ว จะเห็นปุ่มแชร์และเริ่มรับค่าคอมได้ทันที",
                confirm_off: "ลิงก์จะหยุดนับค่าคอม ปุ่มแชร์จะถูกซ่อน ค่าคอมที่มีอยู่ยังจ่ายตามปกติ",
                stale: "มีผู้อื่นแก้ไขการตั้งค่า — โหลดใหม่",
                terms_version: "เงื่อนไขปัจจุบัน: เวอร์ชัน {v}",
            },
            rule: {
                add: "เพิ่มอัตรา",
                edit_title: "แก้ไขอัตรา",
                scope: "ขอบเขต",
                scope_default: "ค่าเริ่มต้น",
                scope_category: "หมวดสินค้า",
                scope_product: "สินค้า",
                scope_promotion: "ชุดสินค้า",
                all_scopes: "ทุกขอบเขต",
                target: "เป้าหมาย",
                target_placeholder: "พิมพ์เพื่อค้นหา",
                all_products: "ทุกสินค้า",
                rate_type: "ประเภท",
                rate_type_percent: "เปอร์เซ็นต์",
                rate_type_fixed: "บาทต่อชิ้น",
                rate: "อัตรา",
                per_item: "ต่อชิ้น",
                starts_at: "วันเริ่ม",
                ends_at: "วันสิ้นสุด",
                note: "หมายเหตุ",
                zero_hint: "ใส่ 0 เพื่อไม่ให้สินค้านี้ได้ค่าคอม",
                no_default: "ยังไม่มีอัตราพื้นฐาน — สินค้าที่ไม่มีอัตราเฉพาะจะไม่ได้ค่าคอม",
                window: "ช่วงเวลา",
                always: "ตลอด",
                state: "สถานะ",
                updated_by: "แก้ไขโดย",
                disable: "ปิด",
                enable: "เปิด",
                state_active: "ใช้งาน",
                state_scheduled: "รอเริ่ม",
                state_expired: "หมดอายุ",
                state_disabled: "ปิดแล้ว",
                precedence: "ลำดับการใช้อัตรา: สินค้า > หมวดสินค้า > ค่าเริ่มต้น · ชุดสินค้า > ค่าเริ่มต้น · เปลี่ยนอัตรามีผลกับออเดอร์ใหม่เท่านั้น",
            },
            eligibility: {
                title: "สิทธิ์ Affiliate",
                status: "สิทธิ์",
                status_eligible: "มีสิทธิ์",
                status_revoked: "ถูกถอนสิทธิ์",
                status_never: "ยังไม่มีสิทธิ์",
                row_not_eligible: "ไม่มีสิทธิ์",
                joined_as: "เข้าร่วมแล้ว รหัส {code}",
                hint: "เมนู Affiliate บนเว็บและ LINE จะแสดงเฉพาะสมาชิกที่มีสิทธิ์เท่านั้น ถอนสิทธิ์แล้วลิงก์เดิมจะหยุดนับค่าคอม แต่ข้อมูลค่าคอมเดิมไม่ถูกลบ",
                program_off: "ตอนนี้โปรแกรม Affiliate ยังปิดอยู่ — สมาชิกจะเห็นเมนูเมื่อเปิดโปรแกรมในหน้า Affiliate: ตั้งค่า",
                granted_by: "ให้สิทธิ์โดย {name} เมื่อ {at}",
                revoked_by: "ถอนสิทธิ์โดย {name} เมื่อ {at}",
                note: "หมายเหตุ",
                note_placeholder: "หมายเหตุ (ไม่บังคับ)",
                note_too_long: "หมายเหตุยาวเกิน 300 ตัวอักษร",
                grant: "ให้สิทธิ์",
                revoke: "ถอนสิทธิ์",
                confirm_grant: "ให้สิทธิ์ Affiliate กับสมาชิกคนนี้? สมาชิกจะเห็นเมนู Affiliate และเข้าร่วมโปรแกรมได้",
                confirm_revoke: "ถอนสิทธิ์ Affiliate? เมนูจะหายไป ลิงก์ที่แชร์ไว้จะหยุดนับค่าคอม (ค่าคอมเดิมยังอยู่)",
                granted: "ให้สิทธิ์แล้ว",
                revoked: "ถอนสิทธิ์แล้ว",
                history: "ประวัติสิทธิ์",
                when: "เวลา",
                action: "รายการ",
                by: "โดย",
                audit_grant: "ให้สิทธิ์",
                audit_revoke: "ถอนสิทธิ์",
                schema_missing: "ยังไม่ได้ติดตั้งตารางสิทธิ์ Affiliate (รอรัน sql/postgres/2026-10-16-affiliate-eligibility.sql) — ระหว่างนี้ไม่มีสมาชิกคนใดมีสิทธิ์",
                list_title: "ผู้มีสิทธิ์ Affiliate",
                list_hint: "ให้สิทธิ์สมาชิกใหม่ได้ที่ จัดการสมาชิก → เปิดสมาชิก → แท็บ Affiliate",
                filter_true: "มีสิทธิ์",
                filter_false: "ถูกถอนสิทธิ์",
                filter_all: "ทั้งหมด",
                search: "ค้นหา ชื่อ / เบอร์ / รหัส / เลขสมาชิก",
                not_joined: "ยังไม่เข้าร่วม",
                changed: "เปลี่ยนล่าสุด",
            },
            member: {
                code: "รหัส",
                name: "ชื่อ",
                phone: "เบอร์",
                joined: "เข้าร่วม",
                status: "สถานะ",
                docs: "เอกสาร",
                status_active: "ใช้งาน",
                status_suspended: "ระงับ",
                status_deleted: "ลบบัญชีแล้ว",
                tab_all: "ทั้งหมด",
                tab_active: "ใช้งาน",
                tab_suspended: "ระงับ",
                tab_deleted: "ลบบัญชีแล้ว",
                hold: "ระงับจ่าย",
                suspend: "ระงับ",
                unsuspend: "ยกเลิกระงับ",
                hold_on: "ระงับจ่าย",
                hold_off: "ยกเลิกระงับจ่าย",
                suspend_reason: "เหตุผล",
                suspend_hold: "ระงับการจ่ายเงินด้วย",
                clicks_30d: "คลิก 30 วัน",
                orders_30d: "ออเดอร์ 30 วัน",
                pending: "รอยืนยัน",
                approved: "พร้อมจ่าย",
                in_payout: "อยู่ในรอบจ่าย",
                paid_total: "จ่ายแล้วรวม",
                tab_commissions: "ค่าคอม",
                tab_profile: "ข้อมูลรับเงิน",
                tab_audit: "ประวัติ",
                search: "ค้นหา รหัส / ชื่อ / เบอร์",
                docs_all: "เอกสาร: ทั้งหมด",
                view: "ดูรายละเอียด",
                deleted_name: "(ลบบัญชีแล้ว)",
                confirm_unsuspend: "ยกเลิกระงับ {code}? (สถานะระงับจ่ายไม่เปลี่ยน)",
                totals: "คลิกทั้งหมด {clicks} · ออเดอร์ทั้งหมด {orders}",
                open_ledger: "ดูในรายการค่าคอม",
            },
            profile: {
                status_none: "ยังไม่กรอก",
                status_submitted: "รอตรวจ",
                status_verified: "ผ่าน",
                status_rejected: "ไม่ผ่าน",
                view_id_card: "ดูบัตรประชาชน",
                view_bookbank: "ดูสมุดบัญชี",
                verify: "ยืนยันข้อมูล",
                reject: "ไม่ผ่าน",
                reject_reason: "เหตุผลที่ไม่ผ่าน",
                not_submitted: "ข้อมูลนี้ไม่ได้อยู่ในสถานะรอตรวจ",
                full_name: "ชื่อ-นามสกุล",
                national_id: "เลขประจำตัวประชาชน",
                address: "ที่อยู่",
                bank: "ธนาคาร",
                account_no: "เลขบัญชี",
                account_name: "ชื่อบัญชี",
                pdpa: "ความยินยอม PDPA",
                link_expiry: "ลิงก์ไฟล์ใช้ได้ 5 นาที และทุกครั้งที่เปิดดูจะถูกบันทึก",
                confirm_verify: "ยืนยันว่าข้อมูลรับเงินของ {name} ถูกต้องตรงกับเอกสาร?",
            },
            commission: {
                kind: "ประเภท",
                kind_order: "ออเดอร์",
                kind_adjustment: "ปรับยอด",
                status_pending: "รอยืนยัน",
                status_approved: "ยืนยันแล้ว",
                status_paid: "จ่ายแล้ว",
                status_cancelled: "ยกเลิก",
                status_reversed: "ถูกหักคืน",
                zero_paid_ad: "โฆษณาร้าน",
                zero_self_purchase: "ซื้อเอง",
                zero_rule_zero: "ไม่ร่วมรายการ (0)",
                zero_no_rule: "ไม่มีอัตรา",
                zero_reason: "เหตุผลไม่ได้ค่าคอม",
                cancel: "ยกเลิกค่าคอม",
                cancel_reason: "เหตุผล",
                not_cancellable: "ยกเลิกไม่ได้ (อยู่ในรอบจ่ายหรือสถานะไม่ถูกต้อง)",
                adjust: "ปรับยอด",
                adjust_amount: "จำนวนเงิน",
                adjust_amount_hint: "ติดลบ = หักคืน",
                adjust_order_no: "เลขออเดอร์ (ถ้ามี)",
                adjust_note: "หมายเหตุ",
                mature_at: "ยืนยันได้เมื่อ",
                partial_return_note: "คืนสินค้าบางรายการ: ระบบไม่หักให้อัตโนมัติ ให้ฝ่ายการเงินกด \"ปรับยอด\" ติดลบตามมูลค่าที่คืน",
                range: "ช่วงวันที่",
                status: "สถานะ",
                order_no: "เลขออเดอร์",
                payout: "รอบจ่าย",
                date: "วันที่",
                order: "ออเดอร์",
                order_status: "สถานะออเดอร์",
                product: "สินค้า",
                qty: "จำนวน",
                base: "ยอดคิดค่าคอม",
                amount: "ค่าคอม",
                reason_order_cancelled: "ออเดอร์ถูกยกเลิก",
                reason_order_returned: "ออเดอร์ตีกลับ",
                reason_unpaid: "ไม่ได้ชำระเงิน",
                reason_bo_cancel: "ยกเลิกโดยหลังบ้าน",
            },
            payout: {
                create: "สร้างรอบจ่าย",
                cutoff: "ตัดยอดถึงวันที่",
                preview_eligible: "ได้รับเงินรอบนี้ {n} คน",
                preview_skipped_min: "ไม่ถึงขั้นต่ำ {n} คน",
                preview_skipped_profile: "ข้อมูลรับเงินยังไม่ผ่าน {n} คน",
                preview_skipped_hold: "ระงับจ่าย {n} คน",
                create_draft: "สร้างรอบ (ร่าง)",
                draft_exists: "มีรอบร่างอยู่แล้ว — เปิดรอบนั้น",
                open_draft: "เปิดรอบร่าง",
                submit: "ส่งรอบจ่าย",
                cancel: "ยกเลิกรอบ",
                transfer_csv: "ไฟล์โอนเงิน CSV",
                wht_csv: "ไฟล์ ภ.ง.ด.3 CSV",
                pay: "บันทึกการจ่าย",
                unpay: "ยกเลิกการจ่าย",
                view_slip: "ดูสลิป",
                payment_date: "วันที่โอน",
                slip: "สลิป",
                payment_note: "หมายเหตุ",
                remove_item: "เอาออกจากรอบ",
                below_min: "ต่ำกว่าขั้นต่ำ (ยอดถูกหักคืนระหว่างรอบ)",
                below_min_short: "ต่ำกว่าขั้นต่ำ",
                details: "รายละเอียด",
                not_found: "ไม่พบรอบจ่ายนี้ หรือรอบถูกลบไปแล้ว",
                back_to_list: "กลับไปหน้ารอบจ่ายเงิน",
                status_draft: "ร่าง",
                status_submitted: "ส่งแล้ว",
                status_paid: "จ่ายครบ",
                status_cancelled: "ยกเลิก",
                item_unpaid: "ยังไม่จ่าย",
                item_paid: "จ่ายแล้ว",
                has_paid_items: "ยกเลิกไม่ได้ มีรายการที่จ่ายแล้ว",
                nothing_to_pay: "ไม่มียอดที่ต้องจ่ายถึงวันที่นี้",
                code: "รอบ",
                status: "สถานะ",
                people: "จำนวนคน",
                paid_of: "จ่ายแล้ว",
                gross: "ยอดรวม",
                wht: "หัก ณ ที่จ่าย",
                wht_short: "หัก 3%",
                net: "ยอดโอนสุทธิ",
                created: "สร้างโดย/เมื่อ",
                note: "หมายเหตุ",
                tax_id: "เลขประจำตัวผู้เสียภาษี",
                count: "จำนวนรายการ",
                slip_hint: "JPG, PNG หรือ PDF ไม่เกิน 10 MB",
                confirm_submit: "ส่งรอบ {code}? หลังส่งแล้วจะแก้ไขรายการในรอบไม่ได้",
                confirm_remove: "เอา {code} ออกจากรอบนี้? ค่าคอมจะกลับไปรอรอบถัดไป",
                submitted_hint: "ดาวน์โหลดไฟล์โอนเงินแล้วโอนนอกระบบ จากนั้นบันทึกการจ่ายทีละคนพร้อมสลิป ห้ามโอนเงินจริงสำหรับรอบทดสอบ (TEST)",
                view_commissions: "ดูรายการค่าคอมในรอบนี้",
            },
            report: {
                group: "จัดกลุ่ม",
                group_day: "รายวัน",
                group_month: "รายเดือน",
                export_which: "ส่งออกรายงาน",
                export_series: "ยอดรายวัน/รายเดือน",
                top_affiliates: "Top affiliates",
                top_targets: "Top สินค้าที่ถูกแชร์",
                chart_title: "คลิกและออเดอร์",
                card: {
                    affiliates_active: "affiliate ที่ใช้งาน",
                    affiliates_with_sales: "affiliate ที่มียอดขาย",
                    clicks: "คลิก",
                    orders: "ออเดอร์",
                    base_total: "ยอดคิดค่าคอม",
                    commission_pending: "ค่าคอมรอยืนยัน",
                    commission_approved: "ค่าคอมยืนยันแล้ว",
                    commission_paid: "ค่าคอมจ่ายแล้ว",
                    zero_paid_ad_orders: "ออเดอร์ที่ไม่ได้ค่าคอม (โฆษณาร้าน)",
                    zero_self_orders: "ออเดอร์ที่ไม่ได้ค่าคอม (ซื้อเอง)",
                    reversed_total: "ยอดหักคืน",
                },
                col: {
                    clicks: "คลิก",
                    orders: "ออเดอร์",
                    base: "ยอดคิดค่าคอม",
                    commission: "ค่าคอม",
                    zero: "โฆษณา/ซื้อเอง",
                },
                footnote: "นับเฉพาะออเดอร์ร้าน MadameFin จากเว็บไซต์ (www) ที่มาจากลิงก์ affiliate · ค่าคอมคิดเฉพาะสินค้าที่ถูกแชร์",
            },
            audit: {
                action: "รายการ",
                by: "โดย",
                detail: "รายละเอียด",
                settings_update: "แก้ไขการตั้งค่า",
                join: "เข้าร่วม",
                terms_accept: "ยอมรับเงื่อนไข",
                suspend: "ระงับ",
                unsuspend: "ยกเลิกระงับ",
                hold: "ระงับจ่าย",
                profile_submit: "ส่งข้อมูลรับเงิน",
                profile_verify: "ยืนยันข้อมูลรับเงิน",
                profile_reject: "ข้อมูลรับเงินไม่ผ่าน",
                file_view: "เปิดดูเอกสาร",
                commission_cancel: "ยกเลิกค่าคอม",
                adjust: "ปรับยอด",
                payout_create: "สร้างรอบจ่าย",
                payout_item_remove: "เอาออกจากรอบ",
                payout_submit: "ส่งรอบจ่าย",
                payout_cancel: "ยกเลิกรอบ",
                payout_item_pay: "บันทึกการจ่าย",
                payout_item_unpay: "ยกเลิกการจ่าย",
                slip_view: "เปิดดูสลิป",
            },
            err: {
                generic: "ทำรายการไม่สำเร็จ ลองใหม่อีกครั้ง",
                load: "โหลดข้อมูลไม่สำเร็จ",
                stale: "มีผู้อื่นแก้ไขข้อมูลนี้ — โหลดใหม่",
                not_found: "ไม่พบข้อมูล",
                invalid_body: "ข้อมูลไม่ถูกต้อง ตรวจสอบช่องที่มีข้อความสีแดง",
                required: "กรุณากรอกข้อมูล",
                range: "ค่าอยู่นอกช่วงที่กำหนด",
                max_length: "ข้อความยาวเกินไป",
                format: "รูปแบบไม่ถูกต้อง",
                amount: "จำนวนเงินต้องไม่เป็น 0 อยู่ระหว่าง -100,000 ถึง 100,000 และมีทศนิยมไม่เกิน 2 ตำแหน่ง",
                target_not_found: "ไม่พบสินค้า / ชุดสินค้า / หมวดนี้",
                not_submitted: "ข้อมูลนี้ไม่ได้อยู่ในสถานะรอตรวจ",
                not_cancellable: "ยกเลิกไม่ได้ (อยู่ในรอบจ่ายหรือสถานะไม่ถูกต้อง)",
                affiliate_not_found: "ไม่พบ affiliate นี้",
                no_file: "ยังไม่มีไฟล์",
                invalid_range: "ช่วงวันที่ไม่ถูกต้อง (ไม่เกิน 366 วัน)",
                draft_exists: "มีรอบร่างอยู่แล้ว — เปิดรอบนั้น",
                nothing_to_pay: "ไม่มียอดที่ต้องจ่ายถึงวันที่นี้",
                not_draft: "รอบนี้ไม่ใช่ร่างแล้ว",
                has_paid_items: "ยกเลิกไม่ได้ มีรายการที่จ่ายแล้ว",
                already_paid: "รายการนี้จ่ายแล้ว",
                not_paid: "รายการนี้ยังไม่ได้จ่าย",
                slip_required: "กรุณาแนบสลิป (JPG, PNG หรือ PDF ไม่เกิน 10 MB)",
                no_slip: "ไม่มีสลิป",
                member_not_found: "ไม่พบสมาชิกนี้",
                schema_missing: "ยังไม่ได้ติดตั้งฐานข้อมูลส่วนนี้ (รอรันไฟล์ SQL)",
            },
        },
        lp: {
            create: "สร้างหน้าใหม่",
            save_draft: "บันทึกร่าง",
            publish: "เผยแพร่",
            unpublish: "ยกเลิกเผยแพร่",
            archive: "เก็บถาวร",
            duplicate: "ทำสำเนา",
            delete: "ลบ",
            history: "ประวัติเวอร์ชัน",
            restore: "นำกลับมาเป็นร่าง",
            rotate_preview: "สร้างลิงก์ตัวอย่างใหม่",
            open_preview_tab: "เปิดตัวอย่างในแท็บใหม่",
            edit: "แก้ไข",
            open_page: "เปิดหน้า",
            search: "ค้นหาชื่อหรือ slug",
            tab_all: "ทั้งหมด",
            state: {
                published: "เผยแพร่แล้ว",
                live: "กำลังแสดง",
                scheduled: "ตั้งเวลา",
                ended: "หมดเวลา",
                draft: "ร่าง",
                archived: "เก็บถาวร",
                unpublished_changes: "มีการแก้ไขที่ยังไม่เผยแพร่",
            },
            col: {
                page: "หน้า",
                state: "สถานะ",
                window: "ช่วงเวลาแสดง",
                version: "เวอร์ชัน",
                updated: "แก้ไขล่าสุด",
                actions: "จัดการ",
            },
            always: "แสดงตลอด",
            from: "เริ่ม",
            until: "ถึง",
            field: {
                title: "ชื่อหน้า",
                slug: "Slug (ลิงก์)",
                starts_at: "วันเริ่ม",
                ends_at: "วันสิ้นสุด",
                fallback_url: "ลิงก์สำรองเมื่อหมดเวลา",
                seo_title: "ชื่อสำหรับแชร์ (SEO)",
                seo_description: "คำอธิบาย",
                og_image: "รูปตอนแชร์ลิงก์",
                noindex: "ไม่ให้ Google ค้นหา",
            },
            slug_hint: "ใช้ a-z, 0-9 และ - เท่านั้น 3–60 ตัวอักษร",
            slug_status: {
                checking: "กำลังตรวจสอบ…",
                available: "ใช้ได้",
                format: "รูปแบบไม่ถูกต้อง",
                taken: "Slug นี้ถูกใช้แล้ว",
                reserved: "Slug นี้สงวนไว้",
                old_slug: "Slug นี้เคยใช้กับหน้าอื่นแล้ว",
            },
            card_page: "ข้อมูลหน้า",
            card_seo: "SEO / แชร์ลิงก์",
            ad_link: "ลิงก์โฆษณา",
            copy_ad_link: "คัดลอกลิงก์โฆษณา",
            copy_params: "คัดลอกเฉพาะพารามิเตอร์",
            ad_link_hint: "วางในช่อง URL ของโฆษณา Meta — Meta จะเติม {{…}} ให้เอง",
            copied: "คัดลอกแล้ว",
            sections: "ส่วนต่าง ๆ ของหน้า",
            add_section: "เพิ่มส่วน",
            visible: "แสดง",
            move_up: "เลื่อนขึ้น",
            move_down: "เลื่อนลง",
            remove_section: "ลบส่วนนี้",
            empty_sections: "ยังไม่มีส่วนใด กด + เพิ่มส่วน",
            type: {
                hero: "ภาพหลัก + ปุ่ม",
                product_grid: "ตารางสินค้า",
                featured_product: "สินค้าเด่น (ซื้อเลย)",
                promotion: "ชุดสินค้า/โปรโมชัน",
                countdown: "นับถอยหลัง",
                coupon: "ปุ่มเก็บคูปอง",
                rich_text: "ข้อความ",
                faq: "คำถามที่พบบ่อย",
                line_chat: "ปุ่มแชท LINE",
                sticky_cta: "ปุ่มลอยด้านล่าง",
            },
            type_desc: {
                hero: "รูปหรือวิดีโอใหญ่บนสุดพร้อมปุ่ม ต้องเป็นส่วนแรก",
                product_grid: "เลือกสินค้าได้ถึง 24 ชิ้น แสดง 2 คอลัมน์บนมือถือ",
                featured_product: "สินค้าเดียวพร้อมปุ่มเพิ่มลงตะกร้า / ซื้อเลย (สูงสุด 3 ต่อหน้า)",
                promotion: "การ์ดชุดสินค้า/โปรโมชันที่ใช้งานอยู่ สูงสุด 6",
                countdown: "นาฬิกานับถอยหลังถึงเวลาที่กำหนด",
                coupon: "ปุ่มให้ลูกค้าเก็บโค้ดเข้ากระเป๋าคูปอง",
                rich_text: "ข้อความจัดรูปแบบ รูปภาพ ลิสต์",
                faq: "คำถาม–คำตอบแบบกดเปิด",
                line_chat: "ปุ่มสีเขียวเปิดแชท LINE OA",
                sticky_cta: "ปุ่มติดขอบล่างจอบนมือถือ (1 ต่อหน้า)",
            },
            f: {
                image: "รูปเดสก์ท็อป",
                image_mobile: "รูปมือถือ",
                video: "วิดีโอ (ไม่บังคับ)",
                video_poster: "รูปปกวิดีโอ",
                title: "หัวข้อ",
                subtitle: "ข้อความรอง",
                cta_label: "ข้อความบนปุ่ม",
                cta_action: "เมื่อกดปุ่ม",
                cta_scroll: "เลื่อนไปที่ส่วน",
                cta_link: "ลิงก์",
                cta_target: "เลือกส่วน",
                text_theme: "สีตัวอักษร",
                theme_light: "สว่าง (ตัวอักษรขาว)",
                theme_dark: "เข้ม (ตัวอักษรดำ)",
                overlay: "ความทึบชั้นบัง (%)",
                products: "สินค้า",
                product: "สินค้า",
                title_override: "ชื่อที่แสดง (ไม่บังคับ)",
                badge_text: "ป้าย",
                show_description: "แสดงรายละเอียดสินค้า",
                promotions: "ชุดสินค้า/โปรโมชัน",
                ends_at: "สิ้นสุดเวลา",
                ended_text: "ข้อความเมื่อหมดเวลา",
                hide_when_ended: "ซ่อนเมื่อหมดเวลา",
                theme: "โทนสี",
                description: "คำอธิบาย",
                code: "โค้ดคูปอง",
                button_label: "ข้อความบนปุ่ม",
                html: "เนื้อหา",
                faq_q: "คำถาม",
                faq_a: "คำตอบ",
                add_faq: "เพิ่มคำถาม",
                label: "ข้อความบนปุ่ม",
                url: "ลิงก์ LINE",
                note: "หมายเหตุใต้ปุ่ม",
                sublabel: "ข้อความรอง",
                search_product: "ค้นหาสินค้า (รหัสหรือชื่อ)",
                search_promotion: "เลือกชุดสินค้า/โปรโมชัน",
            },
            hint: {
                video_drop: "คลิกหรือลากไฟล์มาวาง (MP4, ไม่เกิน 15 MB)",
                image: "แนะนำ 1920×800",
                image_mobile: "แนะนำ 1080×1350 (4:5)",
                og_image: "แนะนำ 1200×630",
                video: "mp4 ไม่เกิน 15 MB เล่นอัตโนมัติแบบปิดเสียง",
                fallback_url: "เช่น / หรือ /products",
                window: "เวลาไทย (Asia/Bangkok) เว้นว่าง = แสดงทันที / ไม่มีวันสิ้นสุด",
            },
            preview: "ตัวอย่างบนมือถือ",
            preview_desktop: "เดสก์ท็อป",
            preview_none: "บันทึกร่างก่อนเพื่อดูตัวอย่าง",
            saved: "บันทึกร่างแล้ว",
            published: "เผยแพร่แล้ว",
            unpublished: "ยกเลิกเผยแพร่แล้ว",
            archived_ok: "เก็บถาวรแล้ว",
            deleted: "ลบแล้ว",
            restored: "นำกลับมาเป็นร่างแล้ว",
            rotated: "สร้างลิงก์ตัวอย่างใหม่แล้ว ลิงก์เก่าใช้ไม่ได้",
            duplicated: "ทำสำเนาแล้ว",
            created: "สร้างหน้าแล้ว",
            confirm_unpublish: "ยกเลิกเผยแพร่หน้านี้? ลิงก์โฆษณาจะเปิดไม่ได้จนกว่าจะเผยแพร่ใหม่",
            confirm_archive: "เก็บถาวรหน้านี้?",
            confirm_delete: "ลบหน้านี้?",
            confirm_restore: "นำเวอร์ชันนี้กลับมาแทนร่างปัจจุบัน?",
            confirm_rotate: "สร้างลิงก์ตัวอย่างใหม่? ลิงก์ตัวอย่างเดิมจะใช้ไม่ได้",
            confirm_leave: "มีการแก้ไขที่ยังไม่บันทึก ออกจากหน้านี้หรือไม่?",
            confirm_remove_section: "ลบส่วนนี้?",
            duplicate_title: "ทำสำเนาหน้า",
            history_empty: "ยังไม่เคยเผยแพร่",
            version: "เวอร์ชัน",
            published_at: "เผยแพร่เมื่อ",
            published_by: "โดย",
            reload: "โหลดใหม่",
            read_only: "คุณมีสิทธิ์ดูอย่างเดียว",
            cancel: "ยกเลิก",
            confirm: "ยืนยัน",
            close: "ปิด",
            unsaved: "ยังไม่บันทึก",
            err: {
                slug_taken: "Slug นี้ถูกใช้แล้ว",
                stale_draft: "มีผู้อื่นแก้ไขหน้านี้ — โหลดใหม่",
                publish_invalid: "ยังเผยแพร่ไม่ได้ กรุณาแก้ส่วนที่ทำเครื่องหมายไว้",
                unavailable_product: "ไม่แสดงบนหน้าร้าน",
                invalid_slug: "Slug ไม่ถูกต้อง",
                invalid_link: "ลิงก์ต้องเป็น /path หรือ https://*.madamefin.com",
                is_published: "ต้องยกเลิกเผยแพร่ก่อน",
                invalid_body: "ข้อมูลไม่ถูกต้อง",
                invalid_content_type: "ชนิดไฟล์ไม่รองรับ",
                generic: "ทำรายการไม่สำเร็จ",
                load: "โหลดข้อมูลไม่สำเร็จ",
                file_too_large: "ไฟล์มีขนาดใหญ่เกินไป (สูงสุด {mb} MB)",
            },
            rule: {
                required: "จำเป็นต้องกรอก",
                max_length: "ยาวเกินกำหนด",
                invalid_link: "ลิงก์ไม่ได้รับอนุญาต",
                too_many: "เกินจำนวนที่กำหนด",
                duplicate: "รหัสส่วนซ้ำ",
                hero_first: "ภาพหลักต้องเป็นส่วนแรกที่แสดง",
                invalid_target: "ไม่พบส่วนปลายทาง",
                in_past: "ต้องเป็นเวลาในอนาคต",
                range: "วันสิ้นสุดต้องหลังวันเริ่ม",
                format: "รูปแบบไม่ถูกต้อง",
            },
        },
        report: {
            title: "ที่มาของออเดอร์ / โฆษณา",
            range: "ช่วงวันที่",
            model: "โมเดล",
            model_last: "ครั้งล่าสุดก่อนซื้อ",
            model_first: "ครั้งแรก",
            group_by: "จัดกลุ่มตาม",
            group: {
                source: "แหล่งที่มา",
                source_medium: "แหล่ง+สื่อ",
                campaign: "แคมเปญ",
                content: "โฆษณา (utm_content)",
                term: "กลุ่มโฆษณา (utm_term)",
                landing_page: "หน้า Landing",
            },
            source: "แหล่งที่มา (source)",
            medium: "สื่อ (medium)",
            campaign: "แคมเปญ",
            lp: "หน้า Landing",
            channel: "ช่องทาง",
            channel_all: "ทุกช่องทาง",
            channels: {
                shop: "เว็บไซต์",
                member: "เว็บสมาชิก",
                app: "แอป",
                guest: "ผู้เยี่ยมชม",
                chat: "แชท",
            },
            search: "ค้นหา",
            export: "ส่งออก CSV",
            card: {
                orders: "ออเดอร์",
                revenue_placed: "ยอดสั่งซื้อ",
                revenue_completed: "ยอดสำเร็จ (130)",
                completion: "อัตราสำเร็จ %",
                aov: "AOV",
                new_members: "สมาชิกใหม่",
            },
            chart_title: "ออเดอร์รายวัน (5 แหล่งที่มาสูงสุด)",
            other: "อื่น ๆ",
            col: {
                source: "แหล่งที่มา",
                medium: "สื่อ",
                campaign: "แคมเปญ",
                content: "โฆษณา",
                term: "กลุ่มโฆษณา",
                lp_slug: "หน้า Landing",
                orders: "ออเดอร์",
                open: "กำลังดำเนินการ",
                completed: "สำเร็จ",
                cancelled: "ยกเลิก",
                returned: "ตีกลับ",
                revenue_placed: "ยอดสั่งซื้อ",
                revenue_completed: "ยอดสำเร็จ",
                revenue_cancelled_returned: "ยอดยกเลิก/ตีกลับ",
                aov: "AOV",
                customers: "ลูกค้า",
                new_members: "สมาชิกใหม่",
            },
            total: "รวม",
            truncated: "แสดง 500 แถวแรก (เรียงตามจำนวนออเดอร์)",
            footnote: "นับเฉพาะออเดอร์จากหน้าเว็บ/แอป MadameFin ที่เข้าระบบหลังบ้านแล้ว — ไม่มีข้อมูลการเข้าชม/คลิก (ดูใน Meta Ads Manager)",
            drawer_title: "ออเดอร์ของกลุ่มนี้",
            order_no: "เลขออเดอร์",
            ordered_at: "วันที่สั่ง",
            status: "สถานะ",
            amount: "ยอดชำระ",
            invalid_range: "ช่วงวันที่ไม่ถูกต้อง (สูงสุด 366 วัน)",
            empty: "ไม่มีข้อมูลในช่วงนี้",
            load_error: "โหลดรายงานไม่สำเร็จ",
            new_members_na: "ยังไม่มีข้อมูลสมาชิกใหม่ (รอรันไฟล์ SQL)",
        },
    },
    // Phase 3 affiliate §5.1 — users-page role label (`user` is already a string key)
    // spec 2026-10-16 §6 (bo-api #980): the old "ผู้ขาย" role checkbox is read-only
    seller_perm: {
        managed_in_seller_center: "จัดการสิทธิ์ใน Seller Center",
    },
    user_role: {
        affiliate_finance: "การเงิน Affiliate (ตรวจเอกสาร / รอบจ่ายเงิน)",
    },
    // spec 2026-10-14 §5.3/§5.4 — BO tracking failures, recipient edit, stuck-112 revert
    // bo-api #931: admin set / change of an order's tracking number
    tracking_change: {
        action: "เปลี่ยนเลขพัสดุ",
        title: "เปลี่ยนเลขพัสดุ — ออเดอร์ #{id}",
        current: "เลขพัสดุปัจจุบัน",
        none: "ยังไม่มีเลขพัสดุ",
        new: "เลขพัสดุใหม่",
        hint: "ระบบจะไม่จองเลขใหม่กับขนส่ง บันทึกเฉพาะเลขที่กรอก",
        replace_warning: "ออเดอร์นี้มีเลขพัสดุ {tn} อยู่แล้ว เลขเดิมจะถูกแทนที่",
        cancelled_warning: "ออเดอร์นี้ถูกยกเลิกแล้ว ตรวจสอบให้แน่ใจก่อนบันทึกเลขพัสดุ",
        confirm_title: "ยืนยันการบันทึกเลขพัสดุ",
        confirm_replace: "เปลี่ยนเลขพัสดุจาก {old} เป็น {new} ใช่หรือไม่?",
        confirm_cancelled: "ออเดอร์นี้ถูกยกเลิกแล้ว ยังต้องการบันทึกเลขพัสดุ {new} หรือไม่?",
        has_tracking_now: "ออเดอร์นี้เพิ่งได้เลขพัสดุ ต้องการแทนที่ด้วย {new} หรือไม่?",
        has_tracking: "ออเดอร์นี้มีเลขพัสดุแล้ว",
        same: "เลขพัสดุใหม่ตรงกับเลขเดิม",
        saved: "บันทึกเลขพัสดุ {tn} แล้ว"
    },
    tracking_failure: {
        skipped_barcode_not_saved: "ข้าม {n} รายการ (ออกเลขแล้วแต่บันทึกไม่สำเร็จ)",
        attach_tracking: "ใส่เลขพัสดุที่ออกแล้ว",
        attach_title: "ใส่เลขพัสดุที่ออกแล้ว — ออเดอร์ #{id}",
        attach_label: "เลขพัสดุที่ไปรษณีย์ออกให้แล้ว",
        attach_hint: "ใช้เลขจากข้อความด้านบน หรือจาก log ORPHAN BARCODE — ระบบจะไม่จองเลขใหม่",
        attach_saved: "บันทึกเลขพัสดุ {tn} แล้ว",
        attach_has_tracking: "ออเดอร์นี้มีเลขพัสดุแล้ว ไม่ต้องใส่ซ้ำ",
        revert_has_tracking: "ออเดอร์นี้มีเลขพัสดุแล้ว คืนสถานะรอตัดรอบไม่ได้",
        badge: "ไม่มีเลขพัสดุ {n}",
        title: "สร้างเลขพัสดุไม่สำเร็จ — รอบ #{id}",
        title_all: "สร้างเลขพัสดุไม่สำเร็จ (14 วันล่าสุด)",
        banner: "มี {n} ออเดอร์สร้างเลขพัสดุไม่สำเร็จ",
        view: "ดูรายการ",
        retry: "สร้างเลขไปรษณีย์ใหม่ ({n})",
        retry_result: "สำเร็จ {ok} / ล้มเหลว {fail}",
        edit_recipient: "แก้ไขที่อยู่ผู้รับ",
        edit_title: "แก้ไขที่อยู่ผู้รับ — ออเดอร์ #{id}",
        edit_saved: "บันทึกที่อยู่ผู้รับแล้ว",
        edited: "แก้ไขแล้วโดย {name}",
        edited_me: "คุณ",
        select_all: "เลือกทั้งหมดที่ล้มเหลว",
        total: "ทั้งหมด {n} รายการ",
        empty: "ไม่มีออเดอร์ที่ค้างเลขพัสดุ",
        table_not_ready: "ยังไม่มีตารางบันทึกสาเหตุ (ผู้ดูแลยังไม่รัน SQL) — แสดงเฉพาะออเดอร์ที่ยังไม่มีเลขพัสดุ",
        round_no: "รอบ #{id}",
        col_order: "เลขออเดอร์",
        col_recipient: "ผู้รับ",
        col_phone: "เบอร์โทร",
        col_postcode: "รหัสไปรษณีย์",
        col_reason: "สาเหตุ",
        col_attempts: "ลองแล้ว",
        col_last: "ล่าสุด",
        f_name: "ชื่อผู้รับ",
        f_phone: "เบอร์โทร",
        f_address: "ที่อยู่",
        f_area_search: "ค้นหาตำบล / อำเภอ / จังหวัด / รหัสไปรษณีย์",
        f_area_search_hint: "พิมพ์ตำบลหรือรหัสไปรษณีย์ เช่น \"ลุมพินี\" หรือ \"10330\"",
        phone_mobile_invalid: "เบอร์โทรผู้รับต้องเป็นเบอร์มือถือ 10 หลัก ขึ้นต้นด้วย 06, 08 หรือ 09",
        cod_phone_warning: "ออเดอร์ COD: เบอร์นี้คือเบอร์ที่ไปรษณีย์จะโทรเก็บเงิน",
        detail_line: "สร้างเลขพัสดุไม่สำเร็จ: {reason}",
        stuck_banner: "ออเดอร์ค้างสถานะรอขนส่งเข้ารับแต่ไม่อยู่ในรอบใด {n} รายการ",
        revert: "คืนสถานะรอตัดรอบ",
        revert_confirm: "คืน {n} ออเดอร์เป็นสถานะรอตัดรอบ เพื่อให้ตัดรอบใหม่ได้?",
        revert_done: "คืนสถานะแล้ว {n} / {total} ออเดอร์",
        reason: {
            barcode_not_saved: "ไปรษณีย์ออกเลขพัสดุแล้วแต่บันทึกไม่สำเร็จ — ห้ามสร้างใหม่ แจ้งผู้ดูแลระบบ",
            phone_invalid: "เบอร์โทรผู้รับไม่ถูกต้อง (ต้องเป็นมือถือ 10 หลัก)",
            recipient_name_invalid: "ชื่อผู้รับว่างหรือไม่ถูกต้อง",
            address_invalid: "ที่อยู่ผู้รับไม่ครบหรือไม่ถูกต้อง",
            area_invalid: "ตำบล/อำเภอ/จังหวัด ไม่ถูกต้อง",
            postcode_invalid: "รหัสไปรษณีย์ไม่ถูกต้อง",
            carrier_rejected: "ไปรษณีย์ไทยปฏิเสธข้อมูล",
            carrier_auth: "เชื่อมต่อไปรษณีย์ไทยไม่ได้ (สิทธิ์/คีย์) แจ้งผู้ดูแลระบบ",
            carrier_unavailable: "ระบบไปรษณีย์ไทยไม่ตอบสนอง ลองใหม่ภายหลัง",
            no_tracking_returned: "ไปรษณีย์ไทยไม่ส่งเลขพัสดุกลับมา",
            no_provider: "ขนส่งของออเดอร์นี้สร้างเลขอัตโนมัติไม่ได้",
            internal: "ระบบผิดพลาด",
            unknown: "ยังไม่มีเลขพัสดุ (ไม่ทราบสาเหตุ ลองสร้างใหม่)",
        },
    },
};
